(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bp-article"] && !Shopify.designMode) return;
  try {
    
  class BpArticle extends HTMLElement {
    connectedCallback() {
      this.buildToc();
      this.bindShare();
      this.bindShoppable();
    }

    // Wire quick-add triggers for shoppable product cards and cover photos.
    // Each card has a visually-hidden `.quick-add__button--choose` rendered by
    // the 'quick-add' snippet; clicking the visible card surface delegates to
    // bpOpenProductDrawer so the BP drawer animation runs immediately.
    bindShoppable() {
      this.querySelectorAll('[data-bp-article-shop-card]').forEach((card) => {
        const trigger = card.querySelector('.quick-add__button--choose');
        const btn = card.querySelector('.bp-article__shop-card-trigger');
        if (!btn || !trigger) return;
        btn.addEventListener('click', () => {
          if (window.bpOpenProductDrawer) window.bpOpenProductDrawer(trigger);
          else trigger.click();
        });
      });

      /* Cover CTA — no per-section binding needed anymore. The
         `[data-stl-trigger][data-drawer-id]` button is picked up by
         the global click delegation in assets/bp-stl-drawer.js, same
         as the home shop-the-look CTAs. */
    }

    // Share row — Facebook uses a real share URL (sharer.php), opened
    // in a popup. Instagram/TikTok/YouTube have no web share
    // endpoints, so we copy the article URL to the clipboard and show
    // a "Link copied — paste into <Platform>" toast. On mobile + HTTPS,
    // the system Web Share sheet (navigator.share) takes priority for
    // the copy buttons since it offers richer per-app options.
    bindShare() {
      const wrap = this.querySelector('[data-bp-share]');
      if (!wrap) return;
      const url = wrap.dataset.shareUrl || window.location.href;
      const title = wrap.dataset.shareTitle || document.title;
      const toast = wrap.querySelector('[data-bp-share-toast]');

      const showToast = (msg) => {
        if (!toast) return;
        toast.textContent = msg;
        toast.removeAttribute('hidden');
        // force reflow so transition runs from opacity:0
        // eslint-disable-next-line no-unused-expressions
        toast.offsetHeight;
        toast.classList.add('is-visible');
        clearTimeout(toast._t);
        toast._t = setTimeout(() => {
          toast.classList.remove('is-visible');
          setTimeout(() => toast.setAttribute('hidden', ''), 220);
        }, 2200);
      };

      // Facebook: open the share dialog in a sized popup.
      wrap.querySelectorAll('[data-bp-share-window]').forEach((a) => {
        a.addEventListener('click', (e) => {
          e.preventDefault();
          window.open(a.href, 'bp-share', 'width=600,height=560,noopener');
        });
      });

      // IG / TikTok / YT: copy link (or use Web Share API).
      wrap.querySelectorAll('[data-bp-share-copy]').forEach((btn) => {
        btn.addEventListener('click', async () => {
          const platform = btn.dataset.platform || 'app';
          if (navigator.share) {
            try {
              await navigator.share({ title, url });
              return;
            } catch (_) { /* user cancelled — fall through to copy */ }
          }
          try {
            await navigator.clipboard.writeText(url);
            showToast(`Link copied — paste into ${platform}`);
          } catch (_) {
            // Fallback: select a hidden textarea.
            const ta = document.createElement('textarea');
            ta.value = url;
            ta.setAttribute('readonly', '');
            ta.style.position = 'absolute';
            ta.style.left = '-9999px';
            document.body.appendChild(ta);
            ta.select();
            try { document.execCommand('copy'); showToast(`Link copied — paste into ${platform}`); }
            catch (__) { showToast('Copy failed — long-press the URL above'); }
            document.body.removeChild(ta);
          }
        });
      });
    }

    // Walk the article body for <h2>s, give each an id, and inject a
    // pill link for it into the TOC. Hides the TOC entirely when there
    // are no headings.
    buildToc() {
      const toc = this.querySelector('[data-toc]');
      const list = this.querySelector('[data-toc-list]');
      const body = this.querySelector('[data-body]');
      if (!toc || !list || !body) return;

      const headings = body.querySelectorAll('h2');
      if (!headings.length) {
        toc.remove();
        return;
      }

      const slugify = (str) =>
        str.toLowerCase().trim().replace(/[^\w\s-]/g, '').replace(/[\s_-]+/g, '-').replace(/^-+|-+$/g, '');

      headings.forEach((h, i) => {
        let id = h.id || slugify(h.textContent);
        if (!id) id = `section-${i + 1}`;
        if (document.getElementById(id) && document.getElementById(id) !== h) {
          id = `${id}-${i + 1}`;
        }
        h.id = id;

        const li = document.createElement('li');
        const a = document.createElement('a');
        a.href = `#${id}`;
        a.textContent = h.textContent.trim();
        li.appendChild(a);
        list.appendChild(li);
      });

      toc.removeAttribute('hidden');
    }
  }
  if (!customElements.get('bp-article')) customElements.define('bp-article', BpArticle);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bp-blog"] && !Shopify.designMode) return;
  try {
    
  class BpBlog extends HTMLElement {
    connectedCallback() {
      this.initCardMetaWrap();

      this.feature = this.querySelector('[data-feature]');
      if (!this.feature) return;
      this.track = this.feature.querySelector('[data-feature-track]');
      this.slides = this.feature.querySelectorAll('[data-feature-slide]');
      this.progress = this.feature.querySelector('[data-feature-progress]');
      this.prev = this.feature.querySelector('[data-feature-prev]');
      this.next = this.feature.querySelector('[data-feature-next]');
      this.index = 0;
      this.total = this.slides.length;
      if (this.total < 2) return;

      this.prev?.addEventListener('click', () => this.go(this.index - 1));
      this.next?.addEventListener('click', () => this.go(this.index + 1));

      this.bindSwipe();

      // F-027 — Off-screen slides must leave the focus order so Tab and
      // tap-focus don't trigger the browser's "scroll the focused element
      // into view" behavior, which left the carousel pinned between two
      // slides. Sync inert + aria-hidden now and on every go(); also
      // defensively reset any scrollLeft/scrollTop on the viewport that
      // might have crept in from a previous focus event.
      this.syncSlideA11y();
      this.feature.addEventListener('scroll', () => {
        if (this.feature.scrollLeft !== 0) this.feature.scrollLeft = 0;
        if (this.feature.scrollTop !== 0)  this.feature.scrollTop  = 0;
      }, { passive: true });

      // F-027 (intermediate viewports) — re-apply the transform whenever
      // the viewport resizes so the slide always lines up to the new
      // container width. go() reads .feature.clientWidth at the moment
      // of each call, so this also keeps the position in sync after any
      // layout reflow.
      this._onResize = () => this.go(this.index);
      window.addEventListener('resize', this._onResize, { passive: true });
    }

    // Post-grid cards: the "|" between author and date only reads right
    // when both sit on one line. Whether a given author name wraps
    // depends on its length vs. the card's width, not a fixed viewport
    // breakpoint, so this has to be measured rather than done in CSS.
    // Re-checked on resize and once webfonts swap in (font-metric
    // changes can shift where the wrap happens).
    initCardMetaWrap() {
      this.metas = this.querySelectorAll('.bp-blog__card-meta');
      if (!this.metas.length) return;
      this.syncCardMetaWrap();
      this._onMetaResize = () => this.syncCardMetaWrap();
      window.addEventListener('resize', this._onMetaResize, { passive: true });
      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(() => this.syncCardMetaWrap());
      }
    }

    syncCardMetaWrap() {
      this.metas.forEach((meta) => {
        const author = meta.querySelector('.bp-blog__card-author');
        const time = meta.querySelector('time');
        if (!author || !time) return;
        meta.classList.toggle('is-wrapped', time.offsetTop > author.offsetTop);
      });
    }

    // Set inert + aria-hidden on every non-active slide so off-screen
    // links/buttons drop out of the focus order entirely.
    syncSlideA11y() {
      this.slides.forEach((s, idx) => {
        const isActive = idx === this.index;
        if (isActive) {
          s.removeAttribute('inert');
          s.removeAttribute('aria-hidden');
        } else {
          s.setAttribute('inert', '');
          s.setAttribute('aria-hidden', 'true');
        }
      });
    }

    // Touch swipe — horizontal drag of >40px and dominantly horizontal
    // direction triggers a slide change. Bound on the track so taps on
    // links inside slides still navigate normally.
    bindSwipe() {
      const threshold = 40;
      let startX = 0;
      let startY = 0;
      let active = false;

      this.track.addEventListener('touchstart', (e) => {
        if (!e.touches || e.touches.length !== 1) return;
        startX = e.touches[0].clientX;
        startY = e.touches[0].clientY;
        active = true;
      }, { passive: true });

      this.track.addEventListener('touchend', (e) => {
        if (!active) return;
        active = false;
        const t = (e.changedTouches && e.changedTouches[0]) || null;
        if (!t) return;
        const dx = t.clientX - startX;
        const dy = t.clientY - startY;
        if (Math.abs(dx) < threshold) return;
        if (Math.abs(dx) < Math.abs(dy)) return; // vertical scroll, ignore
        if (dx < 0) this.go(this.index + 1); // swipe left → next
        else this.go(this.index - 1);        // swipe right → prev
      }, { passive: true });

      this.track.addEventListener('touchcancel', () => { active = false; }, { passive: true });
    }

    go(i) {
      this.index = (i + this.total) % this.total;
      // F-027 (intermediate viewports ~700-1023px) — translateX(-N%)
      // computes the percentage against the TRACK'S bounding box, which
      // in flex layouts can drift from the slide's actual rendered
      // width once meta/grid padding kicks in at the intermediate
      // breakpoint, leaving the previous slide partially visible on the
      // left after Next. Use a pixel-precise translate based on the
      // visible container width — that's always exactly one slide
      // wide. Re-firing on resize (above) keeps it correct after layout
      // reflows.
      const step = this.feature.clientWidth;
      // F-027 (follow-up) — pixel-precise translate alone wasn't enough.
      // At the intermediate viewport (~700-1023px) the slide's actual
      // rendered width was *larger* than the container's clientWidth:
      // .bp-blog__feature-image's aspect-ratio: 5/4 + the meta panel's
      // 88px right padding pushed the grid cell wider than the
      // flex-item's 100% basis, so stepping by clientWidth was still a
      // hair short of the slide's real width and a sliver of the
      // previous slide leaked on the left. Force every slide's width
      // to clientWidth in JS so slide_width === step exactly — no
      // leakage possible regardless of how the intrinsic sizing wanted
      // to grow.
      this.slides.forEach((s) => { s.style.width = step + 'px'; });
      this.track.style.transform = `translateX(-${this.index * step}px)`;
      this.slides.forEach((s, idx) => s.classList.toggle('is-active', idx === this.index));
      if (this.progress) {
        const pct = ((this.index + 1) / this.total) * 100;
        this.progress.style.setProperty('--progress', `${pct}%`);
      }
      // F-027 — keep the focus order in sync with the visible slide and
      // reset any residual viewport scroll from prior focus events.
      this.syncSlideA11y();
      this.feature.scrollLeft = 0;
      this.feature.scrollTop = 0;
    }
  }
  if (!customElements.get('bp-blog')) customElements.define('bp-blog', BpBlog);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bp-bundle-pdp"] && !Shopify.designMode) return;
  try {
    
  class BpBundlePdp extends HTMLElement {
    connectedCallback() {
      this.requiredItemCount = parseInt(this.dataset.requiredItemCount, 10) || 0;
      this.amplienceBase = this.dataset.amplienceBase || '';
      this.amplienceBundleId = this.dataset.amplienceBundleId || '';
      this.cards = Array.from(this.querySelectorAll('[data-bp-bundle-card]'));
      this.addAllBtn = this.querySelector('[data-bp-bundle-add-all]');
      this.addAllLabel = this.querySelector('[data-bp-bundle-add-all-label]');
      this.clearBtn = this.querySelector('[data-bp-bundle-clear]');
      this.priceEl = this.querySelector('[data-bp-bundle-pricing-price]');
      this.compareEl = this.querySelector('[data-bp-bundle-pricing-compare]');
      this.pricingEl = this.querySelector('[data-bp-bundle-pricing]');
      this.galleryRail = this.querySelector('[data-bp-bundle-gallery-rail]');

      // Per-card selectedVariant map (keyed by product.id).
      // Card writes its current variant here on every option change;
      // pricing + ADD ALL gating read from this state.
      this.selectedVariants = new Map();

      this.wireCards();
      this.wireAddAll();
      this.wireClear();
      this.refresh();

      if (this.amplienceBundleId) {
        this.fetchAmplienceHero().catch(() => { /* keep product.media fallback */ });
      }
    }

    wireCards() {
      this.cards.forEach((card) => {
        const select = card.querySelector('[data-bp-bundle-card-variant-select]');
        if (!select) return;

        // Seed selectedVariants with the initial selected_or_first_available_variant.
        const initialOpt = select.options[select.selectedIndex];
        if (initialOpt && initialOpt.dataset.available === 'true') {
          this.selectedVariants.set(card.dataset.productId, {
            id: initialOpt.value,
            price: parseInt(initialOpt.dataset.price, 10),
            available: true,
            handle: card.dataset.productHandle
          });
        }

        // Option radios — when one toggles, recompute the matching variant
        // by walking the <option> nodes and matching option1/2/3 values.
        const radios = card.querySelectorAll('.bp-bundle-card__option-value input[type="radio"]');
        radios.forEach((r) => {
          r.addEventListener('change', () => this.onOptionChange(card));
        });

        // Click-through label tap for swatch UX consistency.
        card.querySelectorAll('.bp-bundle-card__option-value').forEach((label) => {
          label.addEventListener('click', (e) => {
            const input = label.querySelector('input[type="radio"]');
            if (input && !input.checked) {
              input.checked = true;
              input.dispatchEvent(new Event('change', { bubbles: true }));
            }
          });
        });
      });
    }

    onOptionChange(card) {
      // Collect option values picked across all fieldsets on this card.
      const picked = [null, null, null];
      card.querySelectorAll('fieldset[data-option-position]').forEach((fs) => {
        const pos = parseInt(fs.dataset.optionPosition, 10);
        const checked = fs.querySelector('input[type="radio"]:checked');
        if (checked) picked[pos - 1] = checked.value;
      });

      // Reflect on labels: swap .is-selected.
      card.querySelectorAll('.bp-bundle-card__option-value').forEach((label) => {
        const input = label.querySelector('input[type="radio"]');
        label.classList.toggle('is-selected', !!(input && input.checked));
      });

      // Find the matching variant.
      const select = card.querySelector('[data-bp-bundle-card-variant-select]');
      let matched = null;
      Array.from(select.options).forEach((opt) => {
        const o1 = opt.dataset.option1 || null;
        const o2 = opt.dataset.option2 || null;
        const o3 = opt.dataset.option3 || null;
        if ((picked[0] === null || o1 === picked[0]) &&
            (picked[1] === null || o2 === picked[1]) &&
            (picked[2] === null || o3 === picked[2])) {
          if (!matched) matched = opt;
        }
      });

      if (matched) {
        select.value = matched.value;
        const productId = card.dataset.productId;
        const available = matched.dataset.available === 'true';
        const price = parseInt(matched.dataset.price, 10);

        if (available) {
          this.selectedVariants.set(productId, { id: matched.value, price, available, handle: card.dataset.productHandle });
        } else {
          this.selectedVariants.delete(productId);
        }

        // Update card price display.
        const priceEl = card.querySelector('[data-bp-bundle-card-price]');
        if (priceEl) {
          priceEl.textContent = this.formatMoney(price);
        }

        // Update option-value selected-value label if present.
        const labels = card.querySelectorAll('[data-bp-bundle-card-option-value]');
        labels.forEach((lbl) => {
          const pos = parseInt(lbl.dataset.bpBundleCardOptionValue, 10) - 1;
          if (picked[pos] !== null) lbl.textContent = picked[pos];
        });
      }

      this.refresh();
    }

    wireAddAll() {
      if (!this.addAllBtn) return;
      this.addAllBtn.addEventListener('click', (e) => {
        e.preventDefault();
        if (!this.requiredMet()) return;
        this.handleAddAllToBag();
      });
    }

    wireClear() {
      if (!this.clearBtn) return;
      this.clearBtn.addEventListener('click', (e) => {
        e.preventDefault();
        this.selectedVariants.clear();
        // Uncheck every radio and remove is-selected on every option.
        this.cards.forEach((card) => {
          card.querySelectorAll('input[type="radio"]').forEach((r) => { r.checked = false; });
          card.querySelectorAll('.bp-bundle-card__option-value').forEach((l) => l.classList.remove('is-selected'));
        });
        this.refresh();
      });
    }

    refresh() {
      const count = this.selectedVariants.size;
      const met = this.requiredMet();

      if (this.addAllBtn) {
        this.addAllBtn.disabled = !met;
        if (this.addAllLabel) {
          this.addAllLabel.textContent = met ? 'ADD ALL TO BAG' : 'SELECT SIZES & COLORS';
        }
      }
      if (this.clearBtn) {
        this.clearBtn.hidden = count === 0;
      }

      this.recomputePrice(met);
    }

    requiredMet() {
      const count = this.selectedVariants.size;
      return count > 0 && count >= this.requiredItemCount;
    }

    /**
     * Pricing recalc mirrors Atlas's BundlePricingInfo.js:
     *   - When `required_item_count` met AND discount > 0:
     *     show subtotal of selected variants WITH discount applied.
     *   - Otherwise: show whole-bundle base discounted.
     */
    recomputePrice(met) {
      if (!this.pricingEl || !this.priceEl) return;

      const discountType = this.pricingEl.dataset.discountType || 'percentage';
      const discountValue = parseFloat(this.pricingEl.dataset.discountValue) || 0;
      const baseTotal = parseFloat(this.pricingEl.dataset.baseTotal) || 0;

      const yourItemsTotal = Array.from(this.selectedVariants.values())
        .reduce((sum, v) => sum + (v.price || 0) / 100, 0);

      const reference = (met && discountValue > 0) ? yourItemsTotal : baseTotal;
      let discounted = reference;
      if (discountValue > 0) {
        if (discountType === 'percentage') {
          discounted = reference - reference * (discountValue / 100);
        } else {
          discounted = reference - discountValue;
        }
      }

      this.priceEl.textContent = '$' + this.stripTrailingZeros(discounted.toFixed(2));
      if (this.compareEl) {
        this.compareEl.textContent = '$' + this.stripTrailingZeros(reference.toFixed(2));
      }
    }

    async handleAddAllToBag() {
      const entries = Array.from(this.selectedVariants.values());
      if (entries.length === 0) return;

      // Attach Atlas-parity base LIPs per item (this batch add bypasses
      // the product form + LIP block). A bundle PDP is NOT an outfit-bundle
      // upsell (Atlas passes isBundleUpsell:false for the bundle form), so
      // these carry the base metafield LIPs only — no _is_bundle_product /
      // _upsell_* flags.
      const items = await Promise.all(entries.map(async (v) => {
        const item = { id: v.id, quantity: 1 };
        try {
          if (window.bpLips && v.handle) {
            const props = await window.bpLips.forVariant(v.handle, v.id);
            if (props && Object.keys(props).length) item.properties = props;
          }
        } catch (_) { /* add without props rather than fail the batch */ }
        return item;
      }));
      if (items.length === 0) return;

      this.addAllBtn.disabled = true;
      try {
        const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        const response = await fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items })
        });
        if (!response.ok) throw new Error('cart/add HTTP ' + response.status);
        const data = await response.json();

        // Dispatch the same event Atlas dispatches so existing cart
        // drawers / toasters pick it up unchanged.
        document.dispatchEvent(new CustomEvent('product:added', {
          detail: {
            items: data && data.items && data.items[0],
            triggerArea: 'other'
          }
        }));

        // Also open the cart drawer if Horizon provides a handle.
        if (window.bpOpenCartDrawer) window.bpOpenCartDrawer();
      } catch (err) {
        console.error('[bp-bundle-pdp] add-all failed', err);
        this.addAllBtn.disabled = false;
      }
    }

    /**
     * Amplience hero fetch — mirrors Atlas's getAmplienceImages flow.
     * URL: {base}/s/bostonproper/{bundle_id}_SET.json?protocol=https
     * Response: { items: [{ src, type? }] }. type === 'video' renders <video>.
     */
    async fetchAmplienceHero() {
      const url = `${this.amplienceBase}/s/bostonproper/${encodeURIComponent(this.amplienceBundleId)}_SET.json?protocol=https`;
      const res = await fetch(url, { cache: 'force-cache' });
      if (!res.ok) throw new Error('amplience HTTP ' + res.status);
      const data = await res.json();
      const items = (data && data.items) || [];
      if (items.length === 0 || !this.galleryRail) return;

      this.galleryRail.innerHTML = items.map((it) => {
        if (it.type === 'video') {
          return `
            <div class="bp-bundle-pdp__gallery-slide">
              <video class="bp-bundle-pdp__gallery-img" controls autoplay muted loop playsinline preload="auto" poster="${it.src}">
                <source src="${it.src}/mp4_720p" type="video/mp4">
                <source src="${it.src}/webm_720p" type="video/webm">
                <source src="${it.src}/mp4_480p" type="video/mp4">
              </video>
            </div>`;
        }
        const srcset = [400, 800, 1200, 1600, 1920]
          .map((w) => `${it.src}?w=${w}&fmt=auto ${w}w`)
          .join(', ');
        return `
          <div class="bp-bundle-pdp__gallery-slide">
            <img class="bp-bundle-pdp__gallery-img"
                 src="${it.src}?w=1200&fmt=auto"
                 srcset="${srcset}"
                 sizes="(min-width: 1024px) 60vw, 100vw"
                 alt="${this.dataset.bundleName}"
                 loading="lazy">
          </div>`;
      }).join('');
    }

    formatMoney(cents) {
      return '$' + this.stripTrailingZeros((cents / 100).toFixed(2));
    }
    stripTrailingZeros(s) {
      return String(s).replace(/\.00$/, '');
    }
  }
  if (!customElements.get('bp-bundle-pdp')) {
    customElements.define('bp-bundle-pdp', BpBundlePdp);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bp-cart-page"] && !Shopify.designMode) return;
  try {
    
  class BpCartPage extends HTMLElement {
    connectedCallback() {
      // React to cart updates fired by the BP cart drawer's bpCartChange().
      document.addEventListener('cart:updated', (e) => {
        if (e.detail && e.detail.cart) this.applyCart(e.detail.cart);
        else this.refresh();
      });

      // Horizon dispatches its own `cart:update` (NOT the BP `cart:updated`)
      // when an item is added through the quick-add drawer / a product form.
      // Without this listener the /cart page never hears about drawer adds —
      // the drawer already listens to both. Mirror it here.
      document.addEventListener('cart:update', (e) => {
        const detail = e.detail || {};
        if (detail.data && detail.data.didError) return;
        if (detail.resource) this.applyCart(detail.resource);
        else this.refresh();
      });

      // Discount Kit (Helium) GWP injection — refresh the displayed cart
      // so the gift line item shows up immediately. Mirrors Atlas's
      // CartPage.js:17-19 wiring.
      document.addEventListener('discount_kit:cart_changed', () => {
        this.refresh();
      });

      // Complete-the-Look arrow nav.
      const track = this.querySelector('[data-bp-ctl-track]');
      const prev = this.querySelector('[data-bp-ctl-prev]');
      const next = this.querySelector('[data-bp-ctl-next]');
      if (track && prev && next) {
        const step = () => Math.max(160, track.clientWidth / 4);
        prev.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));
        next.addEventListener('click', () => track.scrollBy({ left: step(), behavior: 'smooth' }));
      }

      // Keep the checkout button's amount protection-inclusive (QA, Dragana).
      this.wireNarvarTotalMirror();
    }

    // ----- Narvar checkout-total mirror -----
    // On /cart the page hosts TWO Narvar Shipping-Protection widgets: this
    // page's mount (#narvar-cart-page-dp-*) AND the always-present cart
    // drawer's mount (#narvar-cart-drawer-dp-*, since the drawer renders on
    // every page). Narvar mis-handles that dual cart context: it computes the
    // protection-inclusive checkout total correctly for the DRAWER button
    // (subtotal + premium, and it recomputes on every qty change) but leaves
    // the PAGE button pinned to the bare subtotal — never adding the premium,
    // never updating. So the cart-page checkout button read "Checkout - $90"
    // while the true with-protection total was "$93.10" (matches the drawer).
    //
    // We can't read the right number off the cart either: in Narvar's opt-out
    // model the protection is a PREVIEW, not yet a line item, so /cart.js
    // total_price is the bare subtotal here too. The drawer's rendered
    // #checkout-price IS Narvar's canonical, live, protection-inclusive
    // computation — so mirror it onto the page button. Copying the drawer's
    // own output (rather than re-deriving the premium) guarantees the page and
    // drawer never diverge and keeps Narvar the single owner of the formula.
    wireNarvarTotalMirror() {
      const PAGE_MOUNT = '#narvar-cart-page-dp-buttons';
      const DRAWER_MOUNT = '#narvar-cart-drawer-dp-buttons';
      const priceEl = (mountSel) => {
        const m = document.querySelector(mountSel);
        return m ? m.querySelector('#checkout-price') : null;
      };
      const mirror = () => {
        const src = priceEl(DRAWER_MOUNT);
        const dst = priceEl(PAGE_MOUNT);
        // Only act when both buttons exist (ineligible carts render neither,
        // and there's no wrong price to correct). Guard on inequality so we
        // never loop the page-wide Narvar observer in bp-cart-drawer.
        if (!src || !dst) return;
        const want = src.textContent;
        if (want && dst.textContent !== want) dst.textContent = want;
      };

      // The drawer button is Narvar's live source of truth: it re-renders on
      // async load and recomputes on every cart change. Observe its buttons
      // mount (NOT the widget mount — that live React subtree self-mutates and
      // a persistent observer on it can spin) and re-mirror on any change. We
      // only ever READ the drawer and WRITE the page, so this can't feed back.
      let observing = false;
      const attach = () => {
        if (observing) return true;
        const drawerMount = document.querySelector(DRAWER_MOUNT);
        if (!drawerMount) return false;
        try {
          new MutationObserver(mirror).observe(drawerMount, {
            childList: true, subtree: true, characterData: true
          });
          observing = true;
        } catch (e) { /* observer unsupported — poll + events still cover it */ }
        return observing;
      };

      // Belt-and-braces: re-mirror on cart mutations too. Narvar recomputes
      // the drawer button a beat after the mutation, so run twice.
      const onCart = () => { mirror(); setTimeout(mirror, 800); };
      document.addEventListener('cart:updated', onCart);
      document.addEventListener('cart:update', onCart);

      // Poll until Narvar's async bundle has injected the drawer buttons, then
      // attach the observer + do the first mirror. Also resolves the initial
      // page-load race (the page button can render before the premium is
      // ready). ~15s window (Narvar can be slow), then the observer/events
      // carry it.
      let tries = 0;
      const MAX = 50; // 50 x 300ms = 15s
      const tick = () => {
        const ready = attach();
        mirror();
        if (++tries < MAX && !(ready && priceEl(PAGE_MOUNT) && priceEl(DRAWER_MOUNT))) {
          setTimeout(tick, 300);
        }
      };
      tick();
    }

    async refresh() {
      try {
        const res = await fetch('/cart.js', { cache: 'no-store', credentials: 'same-origin' });
        const cart = await res.json();
        this.applyCart(cart);
      } catch (e) { console.error('[bp-cart-page] refresh failed', e); }
    }

    applyCart(cart) {
      // Real products only (exclude the Narvar Shipping Protection add-on,
      // which never renders a row and must not keep the bag from reading as
      // empty or inflate the count).
      const bpRealCount = cart.items.reduce(
        (n, i) => ((i.sku || '').toLowerCase() === 'narvardeliveryprotection' ? n : n + i.quantity),
        0
      );

      // Remove-all-items → the Narvar Shipping Protection line lingers with a
      // $3 total you can still check out (QA 7/16, Critical). When no real
      // product remains, clear the WHOLE cart — drops the line AND the cart
      // attributes Narvar keys its toggle off, so it can't be re-added. Same
      // fix as the drawer. Guarded + early return so we never paint the
      // transient "$3, no items" state.
      if (bpRealCount === 0 && cart.items.length > 0 && !this._clearingCart) {
        this._clearingCart = true;
        fetch('/cart/clear.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          cache: 'no-store',
          credentials: 'same-origin'
        })
          .then((r) => r.json())
          .then((c) => document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: c } })))
          .catch((e) => console.error('[bp-cart-page] clear failed', e))
          .finally(() => { this._clearingCart = false; });
        return;
      }

      // Bubble + subtotal — real products only for the count.
      const bubble = this.querySelector('[data-bp-cart-bubble]');
      if (bubble) bubble.textContent = bpRealCount;
      // Subtotal = merchandise only (exclude the Narvar Shipping Protection
      // line). cart.total_price includes it, so after the checkout round-trip
      // the Subtotal jumped to products+protection while the rows still showed
      // products only (QA 8/04, Dragana). Same formula as the Liquid render.
      const bpMerchSubtotal = cart.items.reduce(
        (sum, i) => ((i.sku || '').toLowerCase() === 'narvardeliveryprotection' ? sum : sum + i.final_line_price),
        0
      );
      const subtotal = this.querySelector('[data-bp-cart-subtotal]');
      if (subtotal) subtotal.textContent = this.formatMoney(bpMerchSubtotal);

      // Per-line updates: match every existing row to a cart item and update
      // it in place; only remove a row when its item is truly gone.
      //
      // Applying/removing a promo code RE-KEYS the discounted line (Shopify
      // changes item.key when the line's discount allocation changes), so a
      // key-only match treated the same line as "removed" and, seeing the new
      // key as a new item, async-re-rendered the whole list via syncItemsList
      // — the line visibly disappeared for a beat then reappeared (QA 7/27,
      // Dragana). Fall back to matching by variant id (an unclaimed cart item
      // of the same variant) so a re-keyed row updates in place and keeps its
      // node — no flicker, no refetch. Exclude the Narvar insurance line (it
      // never renders a row).
      const items = cart.items.filter((i) => (i.sku || '').toLowerCase() !== 'narvardeliveryprotection');
      const byKey = new Map(items.map((i) => [i.key, i]));
      const claimed = new Set();
      this.querySelectorAll('[data-bp-cart-line]').forEach((line) => {
        const key = line.dataset.lineKey;
        let item = (key && !claimed.has(key)) ? byKey.get(key) : null;
        if (!item) {
          const vid = line.dataset.variant;
          if (vid) item = items.find((i) => !claimed.has(i.key) && String(i.variant_id) === String(vid));
        }
        if (!item) {
          line.style.transition = 'opacity 0.2s ease, transform 0.2s ease';
          line.style.opacity = '0';
          line.style.transform = 'translateX(8px)';
          setTimeout(() => line.remove(), 220);
          return;
        }
        claimed.add(item.key);
        // Adopt the (possibly new) key so later updates match without a refetch.
        if (line.dataset.lineKey !== item.key) line.dataset.lineKey = item.key;
        const qty = line.querySelector('[data-bp-qty-input]');
        if (qty && qty.value !== String(item.quantity)) qty.value = item.quantity;
        const price = line.querySelector('[data-bp-line-price]');
        if (price) price.textContent = this.formatMoney(item.final_line_price);
        // Original price — struck through, shown only while a discount
        // (promo code, etc.) actually lowers the line. Mirrors the
        // Liquid render's hidden-by-default state (bp-cart-line-item.liquid)
        // so applying/removing a code updates it live without a refetch.
        const compare = line.querySelector('[data-bp-line-compare]');
        if (compare) {
          const hasDiscount = item.original_line_price > item.final_line_price;
          compare.hidden = !hasDiscount;
          if (hasDiscount) compare.textContent = this.formatMoney(item.original_line_price);
        }
      });

      // Genuinely-new items (e.g. added from the cart drawer while on /cart)
      // have no row yet — those weren't claimed above. Re-render the list from
      // the section so they appear.
      const hasNewItems = items.some((i) => !claimed.has(i.key));
      if (hasNewItems) this.syncItemsList();

      // Empty-state vs items-list + summary visibility.
      const itemsList = this.querySelector('[data-bp-cart-items]');
      const emptyState = this.querySelector('[data-bp-cart-empty]');
      const side = this.querySelector('[data-bp-cart-side]');
      const isEmpty = cart.item_count === 0;
      if (itemsList) itemsList.toggleAttribute('hidden', isEmpty);
      if (emptyState) emptyState.toggleAttribute('hidden', !isEmpty);
      if (side) side.toggleAttribute('hidden', isEmpty);
    }

    // Re-render the items list from the section (Section Rendering API, with
    // a full-page fetch fallback) so newly-added lines appear. Mirrors the
    // cart drawer's syncItemsList.
    async syncItemsList() {
      try {
        let html = '';
        let sectionId = '';
        const wrapper = this.closest('[id^="shopify-section-"]');
        if (wrapper) sectionId = wrapper.id.replace(/^shopify-section-/, '');

        if (sectionId) {
          try {
            const res = await fetch(`${window.location.pathname}?sections=${sectionId}`, {
              headers: { Accept: 'application/json' },
              cache: 'no-store',
              credentials: 'same-origin'
            });
            if (res.ok) {
              const json = await res.json();
              const candidate = json[sectionId];
              if (candidate && candidate.includes('data-bp-cart-items')) html = candidate;
            }
          } catch (_) { /* fall through to full-page fetch */ }
        }

        if (!html) {
          const res = await fetch(window.location.pathname, {
            cache: 'no-store',
            credentials: 'same-origin'
          });
          html = await res.text();
        }

        const doc = new DOMParser().parseFromString(html, 'text/html');
        const freshList = doc.querySelector('[data-bp-cart-items]');
        const currentList = this.querySelector('[data-bp-cart-items]');
        if (freshList && currentList) {
          currentList.innerHTML = freshList.innerHTML;
          currentList.hidden = false;
          // Let the bundle-upsell renderer (window.bpBundleUpsell) re-inject
          // its card against the fresh lines.
          document.dispatchEvent(new CustomEvent('bp:cart-lines:rendered'));
        }
      } catch (e) {
        console.error('[bp-cart-page] syncItemsList failed', e);
      }
    }

    formatMoney(cents) {
      // Drop the .00 on whole-dollar prices (site-wide convention). Intl adds
      // the thousands separator so a JS-updated total matches the Liquid
      // `money | replace: '.00', ''` render (QA 7/24: cart showed $X.00).
      return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' })
        .format(cents / 100).replace(/\.00$/, '');
    }
  }
  if (!customElements.get('bp-cart-page')) customElements.define('bp-cart-page', BpCartPage);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bp-catalog-request"] && !Shopify.designMode) return;
  try {
    
  // Catalog request → Klaviyo. The address/name/email/phone form is a Klaviyo
  // Onsite Form (embedded by ID as `klaviyo-form-<ID>`), mounted by the Onsite
  // runtime that the Klaviyo Shopify app embed loads globally. On submit,
  // Klaviyo natively subscribes the profile + assigns the list configured on
  // the form. We additionally push a `Catalog Request` custom metric so
  // downstream flows can trigger on it — mirroring Atlas's
  // catalog-request-template.liquid. Liquid is NOT evaluated inside this
  // JS block, so the form ID is read from the embed's data attribute at
  // event time. Bound once, window-level, so it survives editor re-renders.
  if (!window.__bpCatalogKlaviyoBound) {
    window.__bpCatalogKlaviyoBound = true;

    window.addEventListener('klaviyoForms', function (e) {
      if (!e || !e.detail) return;

      var embed = document.querySelector('[data-bp-catalog-form]');
      if (!embed) return; // no catalog form on this page

      // Only act on OUR catalog form. Klaviyo emits klaviyoForms for every
      // Onsite form on the page; when the event carries a formId, require a
      // match. (When it's absent, this page only has the catalog form.)
      var catalogFormId = embed.getAttribute('data-bp-klaviyo-form-id');
      if (e.detail.formId && catalogFormId && e.detail.formId !== catalogFormId) return;

      if (e.detail.type !== 'submit') return;

      var f = e.detail.metaData || {};
      var now = new Date();
      var ts = now.toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' }) +
               ' ' + now.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit' });

      var kl = window.klaviyo || [];
      try {
        kl.push(['track', 'Catalog Request', {
          email: f.$email,
          firstName: f.$first_name,
          lastName: f.$last_name,
          address1: f.$address1,
          address2: f.$address2,
          city: f.$city,
          state: f.$region,
          zip: f.$zip,
          phone: f.$phone,
          requestDate: ts
        }]);
      } catch (err) { /* non-fatal: Klaviyo form already handled the signup */ }

      // Success UX (Atlas hides the intro copy on submit). The Klaviyo form
      // shows its own confirmation; we swap our intro for an optional message.
      var intro = document.querySelector('[data-bp-cr-intro]');
      var success = document.querySelector('[data-bp-cr-success]');
      if (intro && success) {
        intro.setAttribute('hidden', '');
        success.removeAttribute('hidden');
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bp-category-showcase"] && !Shopify.designMode) return;
  try {
    
  class BpCategoryShowcase extends HTMLElement {
    connectedCallback() {
      this.cats = Array.from(this.querySelectorAll('.bp-cs__cat'));
      this.frames = Array.from(this.querySelectorAll('.bp-cs__media-frame'));
      this.mobileCta = this.querySelector('[data-mobile-cta]');
      if (this.cats.length === 0) return;

      this.activeIndex = 0;
      this.autoplayMs = parseInt(this.dataset.autoplayInterval, 10) || 4000;
      this.mq = window.matchMedia('(max-width: 1023px)');

      // Desktop: hover/focus swaps the active category. Click follows
      // the link normally — no preventDefault.
      this.cats.forEach((cat, i) => {
        const enter = () => this.setActive(i);
        cat.addEventListener('mouseenter', enter);
        cat.addEventListener('focusin', enter);
      });

      this.handleMqChange = this.handleMqChange.bind(this);
      this.mq.addEventListener('change', this.handleMqChange);
      this.handleMqChange();
    }

    disconnectedCallback() {
      this.stopAutoplay();
      this.mq?.removeEventListener('change', this.handleMqChange);
    }

    handleMqChange() {
      if (this.mq.matches) this.startAutoplay();
      else this.stopAutoplay();
    }

    setActive(index) {
      if (index === this.activeIndex) return;
      this.cats[this.activeIndex]?.classList.remove('is-active');
      this.frames[this.activeIndex]?.classList.remove('is-active');
      this.cats[index]?.classList.add('is-active');
      this.frames[index]?.classList.add('is-active');
      this.activeIndex = index;
      // Repoint the mobile CTA to the now-active category's link.
      if (this.mobileCta) {
        const link = this.cats[index]?.querySelector('a');
        if (link?.href) this.mobileCta.href = link.href;
      }
    }

    startAutoplay() {
      if (this.timer) return;
      // a11y (WCAG 2.2.2): don't auto-advance for reduced-motion users.
      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      this.timer = setInterval(() => {
        const next = (this.activeIndex + 1) % this.cats.length;
        this.setActive(next);
      }, this.autoplayMs);
    }

    stopAutoplay() {
      if (!this.timer) return;
      clearInterval(this.timer);
      this.timer = null;
    }
  }

  if (!customElements.get('bp-category-showcase')) {
    customElements.define('bp-category-showcase', BpCategoryShowcase);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bp-category-tiles"] && !Shopify.designMode) return;
  try {
    
  class BpCategoryTiles extends HTMLElement {
    connectedCallback() {
      const rail = this.querySelector('[data-bp-ct-rail]');
      const indicator = this.querySelector('[data-bp-ct-indicator]');
      if (!rail || !indicator) return;

      const update = () => {
        const visible = rail.clientWidth;
        const total = rail.scrollWidth;
        if (total <= visible) {
          indicator.style.display = 'none';
          return;
        }
        indicator.style.display = '';
        const overflow = total - visible;
        const thumbW = (visible / total) * 100;
        const thumbX = overflow > 0 ? rail.scrollLeft / overflow : 0;
        indicator.style.setProperty('--bp-ct-thumb-w', thumbW + '%');
        indicator.style.setProperty('--bp-ct-thumb-x', thumbX);
      };
      rail.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      this._update = update;
      requestAnimationFrame(update);
    }
    disconnectedCallback() {
      if (this._update) window.removeEventListener('resize', this._update);
    }
  }
  if (!customElements.get('bp-category-tiles')) {
    customElements.define('bp-category-tiles', BpCategoryTiles);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bp-collection-seo"] && !Shopify.designMode) return;
  try {
    
  class BpCollectionSeo extends HTMLElement {
    connectedCallback() {
      this.bodyEl = this.querySelector('[data-bp-seo-body]');
      this.toggleEl = this.querySelector('[data-bp-seo-toggle]');
      this.labelEl = this.querySelector('[data-bp-seo-toggle-label]');
      this.iconEl = this.querySelector('.bp-collection-seo__toggle-icon');
      if (!this.bodyEl || !this.toggleEl) return;

      this.moreLabel = this.dataset.moreLabel || 'Learn More';
      this.lessLabel = this.dataset.lessLabel || 'Show Less';

      this._evaluate = this._evaluate.bind(this);
      this.toggleEl.addEventListener('click', () => this._onToggle());
      window.addEventListener('resize', this._evaluate, { passive: true });
      requestAnimationFrame(this._evaluate);
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this._evaluate);
    }

    // Show the toggle only when the body actually overflows the collapsed
    // height. Skip while expanded so we don't fight the user's choice.
    _evaluate() {
      if (this.classList.contains('is-expanded')) return;
      this.classList.add('is-truncatable');
      const overflowing = this.bodyEl.scrollHeight - this.bodyEl.clientHeight > 4;
      this.classList.toggle('is-truncatable', overflowing);
      this.toggleEl.hidden = !overflowing;
    }

    _onToggle() {
      const expanded = this.classList.toggle('is-expanded');
      if (this.labelEl) this.labelEl.textContent = expanded ? this.lessLabel : this.moreLabel;
      if (this.iconEl) this.iconEl.textContent = expanded ? '−' : '+';
      this.toggleEl.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    }
  }

  if (!customElements.get('bp-collection-seo')) {
    customElements.define('bp-collection-seo', BpCollectionSeo);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bp-collection"] && !Shopify.designMode) return;
  try {
    
  class BpCollection extends HTMLElement {
    connectedCallback() {
      this.grid = this.querySelector('[data-grid]');
      if (!this.grid) return;

      this.bindBagIcons(this.grid);
      this.bindSort();
      this.bindLoadMore();
      this.bindPerPage();
      this.bindFilterDrawer();
      this.bindBackToTop();
      // Shop-the-Look tiles now come from Bloomreach content injection and
      // open the reusable STL drawer via assets/bp-stl-drawer.js's global
      // document-level [data-stl-trigger] delegation — no per-section
      // trigger binding needed.

      // Bloomreach takeover. Loads after defer so we poll briefly for
      // window.BpBloomreach to exist, then hand over grid + filters +
      // sort + Load More. The local bindings above remain in place as
      // a fallback if BR's fetch throws.
      if (this.dataset.brEnabled === '1') this.initBloomreach();

      // GA4 view_item_list. fireViewItemList() dedupes by product id and
      // keeps a running 0-based index, so it can be called repeatedly (once
      // per grid mutation) and each call only reports the NEWLY-added cards,
      // continuing the index. When Bloomreach is enabled it REPLACES the
      // initial Liquid cards, so firing here (before the swap) would emit a
      // throwaway event for cards BR is about to discard and reset the index
      // — let the MutationObserver fire after BR renders instead. Non-BR
      // grids have no later mutation, so they must fire now.
      if (this.dataset.brEnabled !== '1') this.fireViewItemList();
      const grid = this.querySelector('[data-grid]');
      if (grid) {
        const obs = new MutationObserver(() => {
          // Debounce — BR's hydration adds cards in one batch.
          clearTimeout(this._fireVilTimer);
          this._fireVilTimer = setTimeout(() => this.fireViewItemList(), 250);
        });
        obs.observe(grid, { childList: true });
        this._vilObs = obs;
      }

      // GA4 sort_change — bubbles from the sort <select>.
      const sortSel = this.querySelector('[data-sort-select]');
      if (sortSel) {
        sortSel.addEventListener('change', () => {
          if (window.bpTrack && window.bpTrack.sort_change) {
            window.bpTrack.sort_change(sortSel.value, 'Site Browse');
          }
        });
      }

      // Runs LAST + never throws — a UI nicety must not block the BR
      // takeover above (an early throw here previously left the grid
      // showing "No products found").
      this.syncSortPlacement();
    }

    // Mobile (wireframe): the header collapses to "Filters & Sort by" +
    // count, so Sort moves into the filter drawer. We relocate the single
    // existing .bp-coll__sort element (rather than duplicating the <select>)
    // so both sort wirings — this section's GA4 handler and BR's own
    // querySelector('[data-sort-select]') — keep working; moving a node
    // preserves its listeners and it stays within the section root.
    syncSortPlacement() {
      try {
        const sortEl = this.querySelector('.bp-coll__sort');
        const drawer = this.querySelector('dialog.bp-filter-drawer');
        const drawerBody = drawer && drawer.querySelector('.bp-filter-drawer__body');
        const toolbar = this.querySelector('.bp-coll__toolbar');
        // Desktop home: grouped with per-page (Figma), not a bare toolbar
        // cell. Falls back to the toolbar itself if the wrapper is ever
        // missing so this never throws.
        const desktopTarget = this.querySelector('.bp-coll__right-group') || toolbar;
        if (!sortEl || !drawer || !drawerBody || !toolbar) return;

        const mq = window.matchMedia('(max-width: 767px)');
        const place = () => {
          if (mq.matches) {
            // Mobile: sit Sort just ABOVE the filter body. It must be a
            // SIBLING of .bp-filter-drawer__body, not a child — Bloomreach's
            // renderFacets() replaces the body's innerHTML on every render,
            // which would otherwise destroy the relocated Sort control.
            if (sortEl.parentElement !== drawer || sortEl.nextElementSibling !== drawerBody) {
              drawer.insertBefore(sortEl, drawerBody);
              sortEl.classList.add('bp-coll__sort--in-drawer');
            }
          } else if (sortEl.parentElement !== desktopTarget) {
            // Desktop: return Sort to the right-group, after per-page.
            desktopTarget.appendChild(sortEl);
            sortEl.classList.remove('bp-coll__sort--in-drawer');
          }
        };
        place();
        // addEventListener on MediaQueryList is unsupported in older Safari
        // (<14) — fall back to addListener so this never throws.
        if (mq.addEventListener) mq.addEventListener('change', place);
        else if (mq.addListener) mq.addListener(place);
      } catch (err) {
        console.warn('[bp-collection] syncSortPlacement skipped', err);
      }
    }

    fireViewItemList() {
      if (!window.bpTrack || !window.bpTrack.view_item_list) return;
      // Read EVERY product card (no 20-cap) in the order they're SHOWN on
      // the grid. The grid uses `grid-auto-flow: dense` with promo-tile
      // injection, so DOM order can differ from visual order — sort by
      // on-screen position (row, then column) so the items[] index matches
      // what the shopper sees.
      let cards = Array.prototype.slice.call(this.querySelectorAll('[data-bp-track-product]'));
      if (!cards.length) return;
      const measured = cards.filter((c) => {
        const r = c.getBoundingClientRect();
        return r.width > 0 && r.height > 0;
      });
      if (measured.length) {
        // Layout is ready → visual order, and drop any hidden/unlaid cards.
        cards = measured.sort((a, b) => {
          const ra = a.getBoundingClientRect();
          const rb = b.getBoundingClientRect();
          if (Math.abs(ra.top - rb.top) > 8) return ra.top - rb.top; // row
          return ra.left - rb.left;                                   // column
        });
      } // else layout not measured yet → keep DOM (source) order

      // Parse card payloads in visual order.
      const parsed = [];
      cards.forEach((card) => {
        try {
          const p = JSON.parse(card.getAttribute('data-bp-track-product'));
          if (p && p.id) parsed.push({ id: String(p.id), p: p });
        } catch (_) { /* skip malformed */ }
      });
      if (!parsed.length) return;

      // Running-index state: this method is called on EVERY grid mutation
      // (initial BR render, then each lazy-loaded batch), so we dedupe by
      // product id and only report cards not yet sent, continuing the GA4
      // index. That yields ONE event per 20 new products with a continuous,
      // 0-based index across batches — instead of re-emitting the whole grid
      // from index 0 on every mutation.
      if (!this._vilReported) { this._vilReported = new Set(); this._vilNextIndex = 0; }

      // A filter/sort/new-page swaps the WHOLE grid: if any already-reported
      // product is no longer present, the list changed → reset and restart
      // the index at 0. (Lazy-load only APPENDS, so reported ids all remain.)
      const currentIds = new Set(parsed.map((x) => x.id));
      let replaced = false;
      this._vilReported.forEach((id) => { if (!currentIds.has(id)) replaced = true; });
      if (replaced) { this._vilReported = new Set(); this._vilNextIndex = 0; }

      const fresh = parsed.filter((x) => !this._vilReported.has(x.id));
      if (!fresh.length) return; // nothing new since the last call

      const items = fresh.map(({ p }) => ({
        id:           p.id,
        title:        p.title,
        vendor:       p.vendor,
        handle:       p.handle,
        url:          p.url,
        sku:          p.sku,        // item-level SKU → item_id / item_parent_id
        product_type: p.product_type,
        metafields: { BP_ProductAttributes: { bp_department: p.category || '' } },
        selected_variant: p.selected_variant
      }));
      const collHandle = this.dataset.collectionHandle || '';
      // item_list_name = "Site Browse", location_id (+ item_list_id) =
      // "Product Listing" (GA4 QA #2 — in step with select_item so the funnel
      // links). startIndex continues the index across lazy-loaded batches.
      window.bpTrack.view_item_list(items, 'Site Browse', collHandle, 'Product Listing', this._vilNextIndex);
      fresh.forEach((x) => this._vilReported.add(x.id));
      this._vilNextIndex += fresh.length;
    }

    initBloomreach() {
      const cfg = {
        host:      this.dataset.brHost,
        accountId: this.dataset.brAccountId,
        domainKey: this.dataset.brDomainKey,
        catId:     this.dataset.brCatId,
        viewId:    this.dataset.brViewId || '',
        perPage:   this.dataset.brPerPage,
        siteUrl:   this.dataset.brSiteUrl,
        // Source collection handle → BR renderCard namespaces card links as
        // /collections/{handle}/products/{handle} so the PDP's `collection`
        // global is set and its breadcrumb reflects where the customer came
        // from (Atlas parity). Empty on the /search PLP → plain product links.
        collectionHandle: this.dataset.collectionHandle || '',
        // BR audit: send ref_url (previous page) + auth_key (when configured)
        // on every Discovery call. buildRequestUrl only sets them when truthy.
        refUrl:    document.referrer || location.href,
        authKey:   (window.shop && window.shop.br && window.shop.br.authKey) || '',
        brUid:     (function () {
          // Decode the URL-encoded _br_uid_2 cookie so bp-bloomreach.js's
          // params.set() (URLSearchParams) single-encodes it, not double
          // (BR audit — 63% of calls were double-encoded).
          var raw = (document.cookie.match(/(?:^|;\s*)_br_uid_2=([^;]+)/) || [])[1] || '';
          try { return decodeURIComponent(raw); } catch (e) { return raw; }
        })(),
        // §9.4 card knobs — BR renderCard mirrors the Liquid card's bag +
        // quick-view behavior from these.
        cardQbStyle: this.dataset.bpCardQbStyle || 'button',
        cardQvDest:  this.dataset.bpCardQvDest || 'drawer',
        cardQvVisD:  this.dataset.bpCardQvVisD || 'hover',
        cardQvVisM:  this.dataset.bpCardQvVisM || 'shown',
        // Secondary-image-on-hover — same §9.4 knob the homepage carousel
        // exposes. Empty/missing dataset (theme-editor preview before the
        // setting has a saved value) defaults to on, matching the Liquid
        // card's own nil-defaults-true behavior.
        cardSecondaryHover: this.dataset.bpCardSecondaryHover !== 'false',
        // Content injection — merchandised promo / Shop-the-Look tiles from
        // Bloomreach, interleaved into the grid at their slots. Off → grid
        // is products only.
        contentInjection: this.dataset.brContentInjection === '1',
        // Called after every BR render so the freshly injected cards get
        // their bag icons wired to the quick-add drawer.
        onRender: (grid) => this.bindBagIcons(grid)
      };
      const tryInit = (deadline) => {
        if (window.BpBloomreach && typeof window.BpBloomreach.init === 'function') {
          window.BpBloomreach.init(this, cfg);
          return;
        }
        if (deadline <= 0) {
          console.warn('[bp-collection] BR script never loaded; keeping Liquid grid.');
          return;
        }
        setTimeout(() => tryInit(deadline - 100), 100);
      };
      tryInit(3000);
    }

    bindFilterDrawer() {
      const opener = this.querySelector('[data-bp-filter-open]');
      const drawer = this.querySelector('dialog.bp-filter-drawer');
      if (!opener || !drawer) return;

      opener.addEventListener('click', (e) => {
        e.preventDefault();
        if (drawer.open) return;
        if (typeof drawer.showModal === 'function') drawer.showModal();
        else drawer.setAttribute('open', '');
      });

      // Native Esc → fire cancel before close; intercept so we can
      // play the slide-out animation instead of the instant close.
      drawer.addEventListener('cancel', (e) => {
        e.preventDefault();
        this.closeFilterDrawer(drawer);
      });

      drawer.addEventListener('click', (e) => {
        // 1. Pill toggle — stage selection locally, no navigation.
        const pill = e.target.closest('[data-bp-pill]');
        if (pill) {
          if (pill.getAttribute('aria-disabled') === 'true') return;
          e.preventDefault();
          e.stopPropagation();
          this.togglePill(pill);
          return;
        }

        // 2. Apply Filters — build URL from staged pills + price + sort/perpage.
        if (e.target.closest('[data-bp-filter-apply]')) {
          e.preventDefault();
          e.stopPropagation();
          this.applyFilters(drawer);
          return;
        }

        // 3. Clear Filters — navigate to bare collection (preserve sort + per_page).
        if (e.target.closest('[data-bp-filter-clear]')) {
          e.preventDefault();
          e.stopPropagation();
          this.clearFilters(drawer);
          return;
        }

        // 4. Header X close.
        if (e.target.closest('[data-bp-filter-close]')) {
          e.preventDefault();
          e.stopPropagation();
          this.closeFilterDrawer(drawer);
          return;
        }

        // 5. Backdrop click: target IS the dialog itself.
        if (e.target === drawer) {
          e.preventDefault();
          e.stopPropagation();
          this.closeFilterDrawer(drawer);
        }
      });
    }

    togglePill(pill) {
      const next = !pill.classList.contains('is-active');
      pill.classList.toggle('is-active', next);
      if (next) pill.setAttribute('aria-current', 'true');
      else pill.removeAttribute('aria-current');
      this.updateFilterCount(pill.closest('[data-bp-filter]'));
    }

    updateFilterCount(detailsEl) {
      if (!detailsEl) return;
      const count = detailsEl.querySelectorAll('[data-bp-pill].is-active').length;
      const summary = detailsEl.querySelector('.bp-filter__summary');
      if (!summary) return;
      let countEl = summary.querySelector('.bp-filter__count');
      if (count > 0) {
        if (!countEl) {
          countEl = document.createElement('span');
          countEl.className = 'bp-filter__count';
          const chev = summary.querySelector('.bp-filter__chevron');
          if (chev) summary.insertBefore(countEl, chev);
          else summary.appendChild(countEl);
        }
        countEl.textContent = `${count} Selected`;
      } else if (countEl) {
        countEl.remove();
      }
    }

    applyFilters(drawer) {
      const baseUrl = drawer.dataset.collectionUrl || window.location.pathname;
      const params = new URLSearchParams();

      // Active pills.
      drawer.querySelectorAll('[data-bp-pill].is-active').forEach((pill) => {
        const key = pill.dataset.param;
        const val = pill.dataset.value;
        if (key && val) params.append(key, val);
      });

      // Price min/max.
      const priceForm = drawer.querySelector('[data-bp-price-form]');
      if (priceForm) {
        new FormData(priceForm).forEach((value, key) => {
          if (value !== '' && value != null) params.append(key, value);
        });
      }

      // Preserve current sort + per_page.
      const current = new URLSearchParams(window.location.search);
      ['sort_by', 'per_page'].forEach((k) => {
        const v = current.get(k);
        if (v) params.set(k, v);
      });

      const qs = params.toString();
      window.location.href = baseUrl + (qs ? `?${qs}` : '');
    }

    clearFilters(drawer) {
      const baseUrl = drawer.dataset.collectionUrl || window.location.pathname;
      const params = new URLSearchParams();
      const current = new URLSearchParams(window.location.search);
      ['sort_by', 'per_page'].forEach((k) => {
        const v = current.get(k);
        if (v) params.set(k, v);
      });
      const qs = params.toString();
      window.location.href = baseUrl + (qs ? `?${qs}` : '');
    }

    closeFilterDrawer(drawer) {
      // Guard against double-fire (Esc + cancel + click can stack).
      if (drawer.dataset.bpClosing === '1' || !drawer.open) return;
      drawer.dataset.bpClosing = '1';
      drawer.classList.add('is-closing');

      const finish = () => {
        drawer.classList.remove('is-closing');
        delete drawer.dataset.bpClosing;
        try { drawer.close(); } catch (_) { drawer.removeAttribute('open'); }
      };

      // Wait for slide-out animation; fall back to a short timeout if
      // animationend never fires (e.g. reduced-motion).
      let done = false;
      const onEnd = (e) => {
        if (done || (e && e.target !== drawer)) return;
        done = true;
        drawer.removeEventListener('animationend', onEnd);
        finish();
      };
      drawer.addEventListener('animationend', onEnd);
      setTimeout(() => { if (!done) onEnd(); }, 350);
    }

    bindBackToTop() {
      const btn = this.querySelector('[data-bp-to-top]');
      if (!btn) return;
      btn.hidden = false; // it's shown/hidden via [data-visible] + CSS now
      btn.addEventListener('click', () => {
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' });
      });
      let ticking = false;
      const onScroll = () => {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(() => {
          // Show after roughly one viewport of scroll.
          btn.toggleAttribute('data-visible', window.scrollY > window.innerHeight * 0.8);
          ticking = false;
        });
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }

    bindPerPage() {
      // Per-page is implemented client-side: the server always paginates
      // by 24 (the section's default). Clicking "120" auto-cascades Load
      // More until 120+ products are in the grid; "All" cascades until
      // paginate.next is null. Clicking a SMALLER value than what's
      // currently loaded does a fresh navigation so we end up with a
      // clean trimmed grid rather than visually deleting cards.
      const params = new URLSearchParams(window.location.search);
      const initial = params.get('per_page') || '24';
      this.querySelectorAll('[data-perpage-value]').forEach((a) => {
        a.classList.toggle('is-active', a.dataset.perpageValue === initial);
        a.addEventListener('click', (e) => {
          const target = a.dataset.perpageValue;
          const targetCount = target === '1000' ? Infinity : parseInt(target, 10);
          const loaded = this.countProductCells();

          // If we'd be SHRINKING (e.g. user has 120 loaded and clicks
          // "24"), let the link navigate normally — fresh page, clean
          // state. Don't try to remove cards in place.
          if (loaded > targetCount) return;

          e.preventDefault();
          const url = new URL(window.location.href);
          url.searchParams.set('per_page', target);
          history.replaceState({}, '', url.toString());
          this.querySelectorAll('[data-perpage-value]').forEach((x) =>
            x.classList.toggle('is-active', x === a)
          );
          this.cascadeUntil(targetCount);
        });
      });

      // If the user lands directly on ?per_page=120 (deep link or
      // refresh after picking a tab), auto-cascade once on connect.
      // BR OFF only: when Bloomreach owns the grid it runs its own initial
      // fetch + per-page cascade (bp-bloomreach.js). Firing this legacy
      // Shopify loadNextPage() cascade too races the BR takeover — it
      // appends Shopify page-2 HTML onto the 8-card BR fallback while BR
      // replaces the grid with its own page-size worth, inflating the grid
      // past the selected page size (e.g. the "24" tab rendering ~32 cards).
      if (this.dataset.brEnabled !== '1') {
        const initialTarget = initial === '1000' ? Infinity : parseInt(initial, 10);
        if (initialTarget > this.countProductCells()) {
          this.cascadeUntil(initialTarget);
        }
      }
    }

    async cascadeUntil(targetCount) {
      let btn = this.querySelector('[data-loadmore]');
      while (btn && this.countProductCells() < targetCount) {
        await this.loadNextPage(btn);
        btn = this.querySelector('[data-loadmore]');
      }
    }

    countProductCells() {
      // Tile cells are .bp-tile; product cells are everything else.
      return this.grid.querySelectorAll(':scope > li:not(.bp-tile)').length;
    }

    bindBagIcons(scope) {
      scope.querySelectorAll('.bp-card__quick').forEach((bag) => {
        if (bag.dataset.bpBound) return;
        bag.dataset.bpBound = '1';

        let prefetched = false;
        // Prefetch the EXACT URL the drawer will open (variant +
        // section_id) into the shared drawer cache, so the click is a
        // cache hit rather than a warm HTTP entry under a mismatched URL.
        const prefetch = () => {
          if (prefetched) return;
          prefetched = true;
          try {
            const card = bag.closest('.bp-card');
            const link = card?.querySelector('.bp-card__media-link') || card?.querySelector('a[href*="/products/"]');
            if (!link?.href) return;
            const u = new URL(link.href, window.location.origin);
            if (!u.searchParams.has('variant')) {
              const pc = card.closest('product-card');
              const vid = pc && typeof pc.getSelectedVariantId === 'function' ? pc.getSelectedVariantId() : null;
              if (vid) u.searchParams.set('variant', vid);
            }
            let mainId = window.__bpPdpMainSectionId;
            if (!mainId) { try { mainId = sessionStorage.getItem('bpPdpMainSectionId'); } catch (e) {} }
            if (mainId) u.searchParams.set('section_id', mainId);
            const fetchUrl = u.toString();
            const cache = (window.__bpDrawerCache = window.__bpDrawerCache || new Map());
            if (cache.get(fetchUrl)) return;
            fetch(fetchUrl, { credentials: 'same-origin', headers: { 'Accept': 'text/html' } })
              .then((r) => (r.ok ? r.text() : null))
              .then((html) => {
                if (!html) return;
                const grid = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-product-grid-content]');
                if (grid) cache.set(fetchUrl, grid.cloneNode(true));
              })
              .catch(() => {});
          } catch (e) {}
        };
        bag.addEventListener('mouseenter', prefetch);
        bag.addEventListener('focus', prefetch);
        bag.addEventListener('touchstart', prefetch, { passive: true });

        bag.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          const card = bag.closest('.bp-card');
          if (!card) return;

          const open = () => {
            const trigger = card.querySelector('.quick-add__button--choose');
            if (!trigger) return false;
            if (typeof window.bpOpenProductDrawer === 'function') {
              window.bpOpenProductDrawer(trigger);
            } else {
              trigger.click();
            }
            return true;
          };

          // Liquid cards (and already-hydrated BR cards) have the trigger.
          if (open()) return;

          // BR card clicked before it hydrated (rare — hydration fires 300px
          // ahead of the viewport). Fetch + inject the quick-add on demand,
          // then open. Guard so a mid-fetch double-click doesn't stack.
          const handle = (card.dataset.productUrl || '').match(/\/products\/([^/?#]+)/);
          if (!handle || card.dataset.bpQaLoading === '1' || !window.BpCardHydrate) return;
          card.dataset.bpQaLoading = '1';
          window.BpCardHydrate.hydrateHandle(handle[1])
            .then((data) => { window.BpCardHydrate.applyHydration(card, data); })
            .then(() => { card.dataset.bpQaLoading = '0'; open(); })
            .catch(() => { card.dataset.bpQaLoading = '0'; });
        });
      });
    }

    bindSort() {
      const select = this.querySelector('[data-sort-select]');
      if (!select) return;
      // When Bloomreach is enabled, bp-bloomreach.js handles sort changes
      // client-side (re-fetch, no reload). Navigating here too caused a
      // double-handle: the grid re-fetched instantly, then this reload
      // fired — re-showing the skeleton and re-rendering. Only navigate on
      // the no-JS / BR-off path.
      if (this.dataset.brEnabled === '1') return;
      select.addEventListener('change', () => {
        const url = new URL(window.location.href);
        url.searchParams.set('sort_by', select.value);
        url.searchParams.delete('page');
        window.location.href = url.toString();
      });
    }

    bindLoadMore() {
      const btn = this.querySelector('[data-loadmore]');
      if (!btn) return;
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        this.loadNextPage(btn);
      });
    }

    async loadNextPage(btn) {
      if (!btn || btn.classList.contains('is-loading')) return;
      btn.classList.add('is-loading');
      const originalText = btn.textContent;
      btn.textContent = 'Loading…';

      try {
        const res = await fetch(btn.href, { credentials: 'same-origin' });
        const html = await res.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const nextGrid = doc.querySelector('[data-grid]');
        const nextBtn = doc.querySelector('[data-loadmore]');

        if (nextGrid) {
          nextGrid.querySelectorAll(':scope > li').forEach((li) => {
            this.grid.appendChild(li);
          });
          this.bindBagIcons(this.grid);
          // Reusable STL drawer forms are wired at populate time; the global
          // handler covers any drawers on the page too.
          if (window.bpStlDrawer && typeof window.bpStlDrawer.init === 'function') {
            window.bpStlDrawer.init(document);
          }
        }

        if (nextBtn) {
          btn.href = nextBtn.href;
          btn.classList.remove('is-loading');
          btn.textContent = originalText;
        } else {
          btn.outerHTML = '<span class="bp-coll__loadmore is-end">End of results</span>';
        }
      } catch (err) {
        console.error('[bp-collection] load-more failed:', err);
        btn.classList.remove('is-loading');
        btn.textContent = originalText;
      }
    }
  }

  if (!customElements.get('bp-collection')) {
    customElements.define('bp-collection', BpCollection);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bp-coupons"] && !Shopify.designMode) return;
  try {
    
  class BpCoupons extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', (e) => {
        const opener = e.target.closest('[data-bp-cpn-open]');
        if (opener) {
          const dlg = this.querySelector('[data-bp-cpn-dialog="' + opener.getAttribute('data-bp-cpn-open') + '"]');
          if (dlg && dlg.showModal) dlg.showModal(); else if (dlg) dlg.setAttribute('open', '');
          return;
        }
        const closer = e.target.closest('[data-bp-cpn-close]');
        if (closer) {
          const dlg = closer.closest('dialog');
          if (dlg && dlg.close) dlg.close(); else if (dlg) dlg.removeAttribute('open');
        }
      });
      this.querySelectorAll('[data-bp-cpn-dialog]').forEach((dlg) => {
        dlg.addEventListener('click', (e) => { if (e.target === dlg) { try { dlg.close(); } catch (_) { dlg.removeAttribute('open'); } } });
      });
    }
  }
  if (!customElements.get('bp-coupons')) customElements.define('bp-coupons', BpCoupons);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bp-digital-catalog"] && !Shopify.designMode) return;
  try {
    
  class BpDigitalCatalog extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('[data-bp-dc-tab]'));
      this.embeds = Array.from(this.querySelectorAll('[data-bp-dc-embed]'));

      this.tabs.forEach((tab) => {
        tab.addEventListener('click', (e) => this.handleClick(e));
      });

      const hash = (window.location.hash || '').replace('#', '');
      if (hash) {
        const matched = this.tabs.find((t) => t.dataset.id === hash);
        if (matched) this.activate(matched.dataset.id);
      }

      // Product clicks inside the Publitas ecom-light overlay ("more info" /
      // the #pubProdList "shop this look" list) open Publitas's own product
      // modal (#prod-frame iframe). That iframe loads the product page — as
      // long as Publitas serves the link as /products/<handle>?view=quickview,
      // Shopify renders templates/product.quickview.json (the buy box only,
      // chrome stripped by bp-fonts.liquid), matching Atlas. No click
      // interception here: let Publitas drive its native modal.

      // Cart bridge (parent side). When a shopper adds to bag inside the
      // quickview iframe, sections/bp-quickview-cart-bridge.liquid posts a
      // "cart changed" ping up to this page. Re-fetch the authoritative cart
      // and dispatch Horizon's `cart:update` with an add source + the cart
      // as `resource`. The BP cart drawer (this page, full page context)
      // opens on that event and renders the new line via its own
      // syncItemsList — and because it opens with showModal() it sits in the
      // top layer, above the Publitas modal, so the shopper sees the cart
      // slide in over the catalog with the just-added item (and the header
      // bag count updates). Bound once.
      if (!BpDigitalCatalog._cartBridgeBound) {
        BpDigitalCatalog._cartBridgeBound = true;
        window.addEventListener('message', (e) => {
          if (e.origin !== window.location.origin) return;
          const d = e.data || {};
          if (!d || d.source !== 'bp-quickview') return;
          if (d.type === 'saved-for-later') {
            // Quickview saved an item WITHOUT firing the toast here — the
            // in-frame toast is the visible one now (a parent toast would sit
            // behind the Publitas modal). The iframe wrote the save to the
            // shared localStorage in ITS OWN JS context, so re-seed this page's
            // in-memory mirror before re-rendering, or the drawer + top-nav
            // count stay stale until a reload (QA 7/27, Dragana). The drawer
            // re-renders on bp:saved:updated; the toast ignores it.
            if (window.bpSavedForLater && window.bpSavedForLater.reloadFromStorage) {
              window.bpSavedForLater.reloadFromStorage();
            }
            document.dispatchEvent(new CustomEvent('bp:saved:updated', { detail: { item: d.item || null } }));
            return;
          }
          if (d.type === 'open-saved-drawer') {
            // In-frame toast "View" was clicked — open THIS page's saved
            // drawer, which opens in the top layer above the Publitas modal.
            const drawer = document.querySelector('bp-saved-drawer');
            if (drawer && typeof drawer.open === 'function') drawer.open();
            else { const t = document.querySelector('[data-bp-saved-open]'); if (t) t.click(); }
            return;
          }
          if (d.type !== 'cart:updated') return;
          fetch('/cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store', credentials: 'same-origin' })
            .then((r) => r.json())
            .then((cart) => {
              document.dispatchEvent(new CustomEvent('cart:update', {
                detail: { resource: cart, data: { source: 'product-form-component' } }
              }));
            })
            .catch(() => {});
        });
      }
    }

    handleClick(e) {
      e.preventDefault();
      const id = e.currentTarget.dataset.id;
      if (!id) return;
      this.activate(id);
      if (history.replaceState) {
        history.replaceState(null, '', '#' + id);
      } else {
        window.location.hash = id;
      }
    }

    activate(id) {
      this.tabs.forEach((tab) => {
        const on = tab.dataset.id === id;
        tab.classList.toggle('is-active', on);
        tab.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      this.embeds.forEach((embed) => {
        const on = embed.dataset.id === id;
        embed.classList.toggle('is-active', on);
        if (on) {
          embed.removeAttribute('hidden');
        } else {
          embed.setAttribute('hidden', '');
        }
      });
    }
  }

  if (!customElements.get('bp-digital-catalog')) {
    customElements.define('bp-digital-catalog', BpDigitalCatalog);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bp-footer-main"] && !Shopify.designMode) return;
  try {
    
  class BpFooter extends HTMLElement {
    connectedCallback() {
      this._mq = window.matchMedia('(max-width: 1023px)');
      this._mq.addEventListener('change', () => this._sync());
      this._sync();
    }

    _sync() {
      if (this._mq.matches) {
        this._initAccordions();
      } else {
        this._destroyAccordions();
      }
    }

    _initAccordions() {
      this.querySelectorAll('.bp-footer__col-heading').forEach(heading => {
        if (heading._bpHandler) return;
        heading._bpHandler = e => {
          const link = heading.querySelector('a');
          if (link && e.target === link) e.preventDefault();
          const col = heading.closest('.bp-footer__col');
          const isOpen = col.classList.toggle('bp-footer__col--open');
          heading.setAttribute('aria-expanded', String(isOpen));
        };
        // a11y: the heading exposes role=button but was click-only, so a
        // keyboard user couldn't open/close the accordion. Toggle on
        // Enter/Space when the heading itself (not the nested link) is
        // focused; the link keeps its native Enter navigation.
        heading._bpKeyHandler = e => {
          if ((e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') && e.target === heading) {
            e.preventDefault();
            heading._bpHandler(e);
          }
        };
        heading.setAttribute('role', 'button');
        heading.setAttribute('tabindex', '0');
        heading.setAttribute('aria-expanded', 'false');
        heading.addEventListener('click', heading._bpHandler);
        heading.addEventListener('keydown', heading._bpKeyHandler);
      });
    }

    _destroyAccordions() {
      this.querySelectorAll('.bp-footer__col-heading').forEach(heading => {
        if (!heading._bpHandler) return;
        heading.removeEventListener('click', heading._bpHandler);
        if (heading._bpKeyHandler) {
          heading.removeEventListener('keydown', heading._bpKeyHandler);
          delete heading._bpKeyHandler;
        }
        delete heading._bpHandler;
        heading.removeAttribute('role');
        heading.removeAttribute('tabindex');
        heading.removeAttribute('aria-expanded');
        heading.closest('.bp-footer__col')?.classList.remove('bp-footer__col--open');
      });
    }
  }

  if (!customElements.get('bp-footer')) customElements.define('bp-footer', BpFooter);

  // Footer "Sign Up" → open the Klaviyo Onsite form. Lives here in the
  // {% javascript %} block (Horizon always loads it) instead of a raw
  // section <script>, which doesn't reliably execute — that was why the
  // click did nothing. Bound-once, document-level delegation so it fires
  // regardless of when the button renders and survives editor re-renders.
  // (Liquid is NOT evaluated inside {% javascript %}, so the form id comes
  // from the button's data-bp-klaviyo-form-id at click time.)
  if (!window.__bpFooterKlaviyoBound) {
    window.__bpFooterKlaviyoBound = true;
    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('.klaviyo_form_trigger_footer');
      if (!btn) return;
      e.preventDefault();
      var formId = btn.getAttribute('data-bp-klaviyo-form-id') || 'X8v8qM';
      // Use the _klOnsite queue push — the documented, proven trigger (the
      // real window.klaviyo.openForm() method did NOT open the form in
      // testing, while this did). The app-embed Onsite runtime drains the
      // queue; if it hasn't loaded yet, the push waits in the queue for it.
      window._klOnsite = window._klOnsite || [];
      window._klOnsite.push(['openForm', formId]);
    }, true); // capture phase → runs before any AB Tasty click listener that
              // might stopPropagation on the button and swallow the open.
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bp-grid-blocks"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initGridIndicator(section) {
      const rail = section.querySelector('[data-bp-grid-rail]');
      const indicator = section.querySelector('.bp-grid__indicator');
      if (!rail || !indicator || rail._bpGridIndicatorWired) return;
      rail._bpGridIndicatorWired = true;

      function update() {
        const visible = rail.clientWidth;
        const total = rail.scrollWidth;
        if (total <= visible) {
          indicator.style.display = 'none';
          return;
        }
        indicator.style.display = '';
        const overflow = total - visible;
        const thumbW = (visible / total) * 100;
        const thumbX = overflow > 0 ? rail.scrollLeft / overflow : 0;
        indicator.style.setProperty('--bp-grid-thumb-w', thumbW + '%');
        indicator.style.setProperty('--bp-grid-thumb-x', thumbX);
      }

      rail.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      requestAnimationFrame(update);
    }

    /* Pastel comment #6 — the whole tile should be clickable to the
       same URL as its "Shop Now" CTA. Single source of truth: find
       the first link inside the tile and proxy clicks to it via
       cta.click(). Whatever the CTA does (navigate, open modal,
       run a JS handler) the tile mirrors — including the case where
       href is "#" (merchant hasn't set a URL yet); the cursor still
       advertises clickability so we don't silently regress. */
    function initTileClick(tile) {
      if (tile._bpTileClickWired) return;
      tile._bpTileClickWired = true;
      var cta = tile.querySelector(
        '.bp-cta, .bp-cta-button, a.bp-cta-group__cta, a[href]:not([href=""])'
      );
      if (!cta) return;
      tile.style.cursor = 'pointer';
      tile.setAttribute('data-bp-tile-clickable', '');
      tile.addEventListener('click', function (e) {
        /* Let inner anchors / buttons / form fields handle their own
           clicks. closest() walks up from the click target to find
           an interactive element BEFORE we hit the tile root. */
        if (e.target.closest('a, button, input, select, textarea, summary, [role="button"]')) return;
        /* Proxy to the CTA — preserves new-tab / JS handlers / href
           behavior whether it's a real URL or "#". */
        cta.click();
      });
    }

    function initAll(scope) {
      (scope || document).querySelectorAll('.bp-grid[data-bp-grid-mobile="carousel"]').forEach(initGridIndicator);
      (scope || document).querySelectorAll('.bp-grid__tile').forEach(initTileClick);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initAll(), { once: true });
    } else {
      initAll();
    }
    /* Theme-editor re-renders the section on every setting change —
       re-bind the new tile nodes. */
    document.addEventListener('shopify:section:load', function (e) {
      if (e.target && e.target.classList && e.target.classList.contains('bp-grid-blocks-section')) {
        initAll(e.target);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bp-hero-slider"] && !Shopify.designMode) return;
  try {
    
  class BpHeroSlider extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('.bp-hero__slide'));
      this.dots = Array.from(this.querySelectorAll('.bp-hero__dot'));
      this.indicator = this.querySelector('[data-bp-hero-indicator]');
      this.slideCount = this.slides.length;

      // Activate the first slide client-side if SSR didn't paint
      // `.is-active` on any slide. Covers any cross-context Liquid
      // edge case where the block's self-positioning can't resolve.
      if (this.slideCount > 0 && !this.slides.some((s) => s.classList.contains('is-active'))) {
        this.slides[0].classList.add('is-active');
        this.slides[0].setAttribute('aria-hidden', 'false');
        if (this.dots[0]) {
          this.dots[0].classList.add('is-active');
          this.dots[0].setAttribute('aria-selected', 'true');
        }
      }

      // a11y (WCAG 4.1.2): inactive slides were aria-hidden but their CTA
      // links stayed keyboard-focusable off-screen. `inert` removes each
      // inactive slide from the tab order + a11y tree; the active one stays
      // interactive. set() keeps this in sync on every advance.
      this.slides.forEach((s) => {
        s.toggleAttribute('inert', !s.classList.contains('is-active'));
      });

      if (this.slideCount <= 1) {
        if (this.indicator) this.indicator.style.display = 'none';
        return;
      }

      this.activeIndex = 0;
      this.autoplay = this.dataset.autoplay === '1';
      this.autoplayInterval = parseInt(this.dataset.autoplayInterval, 10) || 6000;

      this.querySelectorAll('[data-direction]').forEach((btn) => {
        btn.addEventListener('click', () => {
          this.go(btn.dataset.direction === 'next' ? 1 : -1);
        });
      });

      this.dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          const target = parseInt(dot.dataset.slideTarget, 10);
          if (!Number.isNaN(target)) this.set(target);
        });
      });

      this.addEventListener('mouseenter', () => this.stop());
      this.addEventListener('mouseleave', () => this.start());
      this.addEventListener('focusin', () => this.stop());
      this.addEventListener('focusout', () => this.start());

      this.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowRight') { e.preventDefault(); this.go(1); }
        if (e.key === 'ArrowLeft')  { e.preventDefault(); this.go(-1); }
      });

      this._updateIndicator();
      this.start();
    }

    disconnectedCallback() { this.stop(); }

    _updateIndicator() {
      if (!this.indicator) return;
      const thumbW = (1 / this.slideCount) * 100;
      const thumbX = this.slideCount > 1 ? this.activeIndex / (this.slideCount - 1) : 0;
      this.indicator.style.setProperty('--bp-hero-thumb-w', thumbW + '%');
      this.indicator.style.setProperty('--bp-hero-thumb-x', thumbX);
    }

    set(index) {
      const next = ((index % this.slideCount) + this.slideCount) % this.slideCount;
      if (next === this.activeIndex) return;

      this.slides[this.activeIndex]?.classList.remove('is-active');
      this.slides[this.activeIndex]?.setAttribute('aria-hidden', 'true');
      this.slides[this.activeIndex]?.setAttribute('inert', '');
      this.dots[this.activeIndex]?.classList.remove('is-active');
      this.dots[this.activeIndex]?.setAttribute('aria-selected', 'false');

      this.slides[next]?.classList.add('is-active');
      this.slides[next]?.setAttribute('aria-hidden', 'false');
      this.slides[next]?.removeAttribute('inert');
      this.dots[next]?.classList.add('is-active');
      this.dots[next]?.setAttribute('aria-selected', 'true');

      this.activeIndex = next;
      this._updateIndicator();
    }

    go(delta) { this.set(this.activeIndex + delta); }

    start() {
      if (!this.autoplay || this.timer) return;
      // a11y (WCAG 2.2.2): don't auto-advance for users who prefer reduced motion.
      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      this.timer = setInterval(() => this.go(1), this.autoplayInterval);
    }

    stop() {
      if (this.timer) { clearInterval(this.timer); this.timer = null; }
    }
  }

  if (!customElements.get('bp-hero-slider')) {
    customElements.define('bp-hero-slider', BpHeroSlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bp-how-to-wear-it"] && !Shopify.designMode) return;
  try {
    
  class BpHtwi extends HTMLElement {
    async connectedCallback() {
      this.style_ = this.dataset.bpHtwiStyle || '';
      this.max = parseInt(this.dataset.bpHtwiMax, 10) || 6;
      this.target = this.querySelector('[data-bp-htwi-target]');
      this.heading = this.querySelector('[data-bp-htwi-heading]');
      this.subtitle = this.querySelector('[data-bp-htwi-subtitle]');
      if (!this.style_ || !this.target) return;

      // Wire click interception up front (delegated, on the outermost element)
      // so a product click is caught even before the composer finishes
      // rendering — and so we win the capture race against the composer's own
      // click/navigation handlers.
      this.bindClicks();

      // Stylitics Add-to-Cart engagement tracking (#3, Atlas parity):
      // trackAddItemToCart on the main PDP add ('main') and the widget
      // quick-view add ('widget').
      this.initAtcTracking();

      // Re-render for the newly-selected colour. The colour swatches soft-swap
      // only the MAIN product section (bp-pdp-swap → bp:pdp:swapped); How-To-
      // Wear-It is a SEPARATE section that isn't replaced, so without this its
      // outfits stayed on the first colour's style (QA 7/21). Read the new
      // style off the swapped-in gallery and re-init the composer for it.
      this._onSwap = () => {
        const g = document.querySelector('bp-pdp-gallery[data-bp-style]') ||
                  document.querySelector('[data-bp-style]');
        const newStyle = g ? (g.getAttribute('data-bp-style') || '').trim() : '';
        this.reInitFor(newStyle);
      };
      document.addEventListener('bp:pdp:swapped', this._onSwap);

      // Defer the composer init (Stylitics SDK wait + outfit network) until
      // the section is near the viewport — it's below the fold on the PDP,
      // so running it at page load steals bandwidth/main-thread from the LCP.
      if ('IntersectionObserver' in window) {
        const io = new IntersectionObserver((entries, obs) => {
          if (entries.some((e) => e.isIntersecting)) {
            obs.disconnect();
            this.initComposer();
          }
        }, { rootMargin: '600px 0px' });
        io.observe(this);
      } else {
        this.initComposer();
      }
    }

    // Tell the gallery's "How to Wear It" pill (blocks/bp-pdp-media-gallery)
    // whether it should show itself. The pill starts hidden and only reveals
    // once it hears visible:true — never on the strength of bp_style alone,
    // since that metafield being set doesn't guarantee Stylitics has outfits
    // for this exact style number.
    notifyVisibility(visible) {
      document.dispatchEvent(new CustomEvent('bp:htwi:visibility', { detail: { visible: visible } }));
    }

    // Hide the widget WITHOUT display:none on the parent container (Stylitics
    // PDP best practice — the SDK needs its container rendered to measure /
    // track impressions). Instead, conditionally hide the title (heading +
    // subtitle/badge) and the gallery jumplink (via notifyVisibility(false)),
    // and collapse the container's padding (bp-htwi--empty) so the empty target
    // leaves no orphaned heading or vertical gap.
    hideWidget() {
      if (this.heading) this.heading.hidden = true;
      if (this.subtitle) this.subtitle.hidden = true;
      this.classList.add('bp-htwi--empty');
      this.notifyVisibility(false);
    }
    showWidget() {
      this.classList.remove('bp-htwi--empty');
    }

    // Re-init the composer for a new colour's style (from bp:pdp:swapped).
    reInitFor(newStyle) {
      if (!newStyle) { this.hideWidget(); return; }
      if (newStyle === this.style_ && this._composer) return; // same style, already shown
      this.style_ = newStyle;
      this.showWidget();
      // Hide the pill again until the NEW style's render confirms content —
      // otherwise a swap from a style with outfits to one without would leave
      // the pill visible (from the old confirmation) pointing at nothing.
      this.notifyVisibility(false);
      // Re-hide the heading + subtitle until the new style's render confirms
      // content — otherwise the previous colour's revealed heading lingers
      // over the empty widget during (and after) re-init for a style with no
      // outfits.
      if (this.heading) this.heading.hidden = true;
      if (this.subtitle) this.subtitle.hidden = true;
      // Tear down the previous render's observers + composer before re-init.
      if (this._obs) { try { this._obs.disconnect(); } catch (_) {} this._obs = null; }
      if (this._lookObs) { try { this._lookObs.disconnect(); } catch (_) {} this._lookObs = null; this._lookWatchNode = null; }
      if (this._composer && typeof this._composer.destroy === 'function') {
        try { this._composer.destroy(); } catch (_) {}
      }
      this._composer = null;
      // Only re-init if the composer has already been attempted (i.e. the
      // section was in view); otherwise the pending IntersectionObserver will
      // init with the updated style when the shopper scrolls to it.
      if (this._initAttempted) this.initComposer();
    }

    async initComposer() {
      // Guard against a double-init race: trackAddToCart() can force an early
      // init while the IntersectionObserver init is still pending (or vice
      // versa) — without this we'd mount two composers (two grids, two
      // fetches). reInitFor() nulls _composer before re-calling, so a
      // legitimate colour-swap re-init still proceeds.
      if (this._initing || this._composer) return;
      this._initing = true;
      this._initAttempted = true;
      try {
        await this.waitForComposer();
        if (typeof window.StyliticsComposer === 'undefined' ||
            typeof window.StyliticsComposer.initialize !== 'function') {
          this.hideWidget();
          return;
        }

        this.target.innerHTML = '';

        // Exact config parity with Atlas's StyliticsComposer.js grid module.
        const composer = await window.StyliticsComposer.initialize({
          client: 'bostonproper',
          target: this.target,
          config: {
            modules: [
              {
                type: 'grid',
                params: {
                  api: {
                    item_number: this.style_,
                    min: 1,
                    max: this.max,
                  },
                  display: {
                    typeScaledGrid: true,
                    maintainImageAspectRatio: true,
                    labelStyle: 1,
                    labelBorderColor: '#edc685',
                    dynamicLabelBackground: true,
                    // Prev/next arrows on mobile viewports (Grid
                    // Configurations docs) — production parity.
                    showMobileArrows: true,
                  },
                  text: {
                    counterHeading: 'Outfit',
                  },
                },
              },
            ],
            sharedParams: {
              customer: { clientUserId: null },
              analytics: { placement: 'pdp' },
            },
          },
        });

        await composer.start();

        window.styliticsComposer = composer;
        window.__styliticsComposerRegistry = window.__styliticsComposerRegistry || {};
        window.__styliticsComposerRegistry.pdp = composer;
        this._composer = composer;

        // The widget renders async — reveal the heading + wire clicks once
        // content lands, and keep watching for re-renders (nav between outfits).
        setTimeout(() => this.onRendered(), 1500);
        this.observeContent();
      } catch (err) {
        console.warn('[bp-htwi] Stylitics composer init failed', err);
        this.hideWidget();
      } finally {
        this._initing = false;
      }
    }

    waitForComposer() {
      return new Promise((resolve) => {
        let attempts = 0;
        const check = () => {
          attempts += 1;
          if (typeof window.StyliticsComposer !== 'undefined') resolve();
          else if (attempts >= 100) resolve(); // ~10s cap, resolve anyway
          else setTimeout(check, 100);
        };
        check();
      });
    }

    hasContent() {
      return !!this.target.querySelector('a[href*="/products/"], [class*="stylitics-grid-item"]');
    }

    onRendered() {
      const hasContent = this.hasContent();
      if (hasContent) {
        this.showWidget();
        if (this.heading) this.heading.hidden = false;
        if (this.subtitle) this.subtitle.hidden = false;
        this.notifyVisibility(true);
        this.setupLookWatcher();
      } else {
        // No outfits for this style (e.g. a swatch swap to a colour Stylitics
        // has no looks for). Per Stylitics PDP best practice, DON'T display:none
        // the parent — conditionally hide the title + jumplink and collapse the
        // empty container instead (hideWidget also fires notifyVisibility(false)).
        this.hideWidget();
      }
      this.bindClicks();
      this.stripPriceZeros();
    }

    // "On Model Look" badge (Atlas parity — setupLookNumberWatcher). The
    // composer renders an outfit counter (.stylitics-count-index); outfit #1
    // is the on-model look, the rest are "Look N". We mirror that number into
    // the badge via the --look-text custom property. observeContent() re-runs
    // onRendered on every composer re-render (outfit nav), so the badge stays
    // in sync without a second observer.
    updateLookLabel() {
      if (!this.subtitle || !this.target) return;
      let n = 1;
      try {
        const counter = this.target.querySelector('.stylitics-count-index');
        n = counter ? parseInt(counter.textContent || '1', 10) : 1;
      } catch (_) {}
      // "On Model Look" (Shop-the-Model) may show ONLY when the CURRENT outfit is
      // an on-model look — Stylitics tags those outfits with a `model_*` entry
      // (QA 8/06: a flat-lay collage was mislabeled "On Model Look"). The composer
      // renders outfits in API order, so outfit N maps to outfits[N-1]; other
      // outfits read "Look N". Resolve from the shared, memoized outfits fetch (no
      // extra request) and guard against a stale write if the shopper navigated on.
      const idx = n;
      this.fetchOutfits().then((outfits) => {
        let cur = idx;
        try {
          const c = this.target.querySelector('.stylitics-count-index');
          cur = c ? parseInt(c.textContent || '1', 10) : idx;
        } catch (_) {}
        if (cur !== idx) return; // counter already moved — a newer call handles it
        const outfit = Array.isArray(outfits) ? outfits[idx - 1] : null;
        // On-model = Stylitics' documented `on-model-image` attribute (the field
        // Atlas's HowToWearIt reads; not populated in our feed yet) OR the
        // `model_*` tag present on on-model outfits today — a bridge until the
        // attribute is enabled on the account, so it's correct now AND auto-
        // corrects once Stylitics turns on `on-model-image`. Either → the STM
        // badge; neither → "Look N".
        const onModel = !!(outfit && (
          outfit['on-model-image'] ||
          (outfit.tags || []).some((t) => /^model_/i.test(String(t)))
        ));
        const text = onModel ? 'On Model Look' : ('Look ' + idx);
        this.subtitle.style.setProperty('--look-text', '"' + text + '"');
      });
    }

    // Keep the badge in sync as the shopper navigates outfits (next/prev).
    // Atlas parity (setupLookNumberWatcher): a DEDICATED observer on the
    // composer's .stylitics-count-index with characterData:true — the general
    // observeContent() observer intentionally omits characterData (it would
    // loop with stripPriceZeros), so a counter that updates its TEXT in place
    // on nav wouldn't otherwise fire. Re-targets if the SDK re-renders the
    // counter as a new node (onRendered re-invokes this each render).
    setupLookWatcher() {
      if (!this.target) return;
      const counter = this.target.querySelector('.stylitics-count-index');
      // Counter not in the DOM yet (or none) — just set the label once.
      if (!counter) { this.updateLookLabel(); return; }
      if (this._lookWatchNode === counter && this._lookObs) { this.updateLookLabel(); return; }
      if (this._lookObs) { try { this._lookObs.disconnect(); } catch (_) {} }
      this._lookWatchNode = counter;
      this._lookObs = new MutationObserver(() => this.updateLookLabel());
      this._lookObs.observe(counter, { childList: true, characterData: true, subtree: true });
      this.updateLookLabel();
    }

    // Drop the .00 on whole-dollar prices in the Stylitics widget so the hover
    // price matches the rest of the site (QA 7/24: "How to Wear It" showed
    // $95.00). Stylitics renders e.g.
    // <span data-testid="stylitics-ui-regular-price">$95.00</span>; edit the
    // TEXT NODE only (leaves Svelte's marker comments intact). Idempotent — a
    // stripped "$95" has no ".00", so re-running on every render is safe and
    // can't loop (the childList observer doesn't watch characterData).
    stripPriceZeros() {
      if (!this.target) return;
      const els = this.target.querySelectorAll('[data-testid*="price"], [class*="stylitics"][class*="price"]');
      els.forEach((el) => {
        el.childNodes.forEach((n) => {
          if (n.nodeType === 3 && n.nodeValue.indexOf('.00') !== -1) {
            n.nodeValue = n.nodeValue.replace(/(\d)\.00\b/g, '$1');
          }
        });
      });
    }

    observeContent() {
      const obs = new MutationObserver(() => {
        // Strip .00 immediately on every render (Stylitics re-renders on hover
        // / outfit nav) so the hover price never flashes the cents.
        this.stripPriceZeros();
        clearTimeout(this._reWire);
        this._reWire = setTimeout(() => this.onRendered(), 150);
      });
      obs.observe(this.target, { childList: true, subtree: true });
      this._obs = obs;
    }

    // Intercept product-item clicks → open the BP quick-add drawer for that
    // product instead of navigating to the PDP.
    bindClicks() {
      if (this._clicksBound) return;
      this._clicksBound = true;
      this.addEventListener(
        'click',
        (e) => {
          // Name / "Shop" link — a real <a href="/products/…">.
          const link = e.target.closest && e.target.closest('a[href*="/products/"]');
          if (link && link.href) {
            e.preventDefault();
            e.stopImmediatePropagation();
            // Fire the Stylitics click engagement ourselves — our
            // stopImmediatePropagation suppresses the composer's native click
            // handler, which is what would have called trackClickItem.
            this.trackItemClick(link.href);
            // Remember this look item so the follow-up add fires
            // trackAddItemToCart with placement 'widget' (#3).
            this.setWidgetAddContext(link.href);
            this.openQuickAdd(link.href);
            return;
          }
          // Item IMAGE click — Stylitics renders each item as a <div role="link">
          // with NO href, so the link check above misses it and the SDK navigates
          // to the PDP instead of opening the drawer (QA 8/06: image click behaved
          // differently from the name / "Shop" link). Catch the grid-item div and
          // resolve its product URL from data-stylitics-client-colorway-id (= the
          // outfit item's remote_id) so the image opens Quickview like the name.
          const cell = e.target.closest && e.target.closest('[data-stylitics-client-colorway-id]');
          const cwId = cell && cell.getAttribute('data-stylitics-client-colorway-id');
          if (!cwId) return;
          e.preventDefault();
          e.stopImmediatePropagation();
          this.fetchOutfits().then((outfits) => {
            let href = '';
            (outfits || []).some((o) => (o.items || []).some((it) => {
              const ids = [it && it.remote_id].concat((it && it.other_client_item_ids) || []);
              if (ids.some((x) => String(x) === String(cwId)) && it.affiliate_link) {
                href = it.affiliate_link;
                return true;
              }
              return false;
            }));
            if (!href) return;
            this.trackItemClick(href);
            this.setWidgetAddContext(href);
            this.openQuickAdd(href);
          });
        },
        { capture: true }
      );
    }

    // Resolve the clicked item's remote_id + outfitId from the outfits API
    // (cached) and fire trackClickItem — same as Atlas's StyliticsComposer.
    async trackItemClick(href) {
      try {
        const mod = window.styliticsComposer
          && window.styliticsComposer.modules
          && window.styliticsComposer.modules[0];
        if (!mod || typeof mod.trackClickItem !== 'function') return;
        const norm = (u) => String(u || '')
          .replace(/^https?:\/\/[^/]+/, '')
          .replace(/^\/products\//, '')
          .replace(/[/?#].*$/, '')
          .trim();
        const handle = norm(href);
        const outfits = await this.fetchOutfits();
        for (const outfit of outfits) {
          const item = (outfit.items || []).find((it) => norm(it && it.affiliate_link) === handle);
          if (item) {
            mod.trackClickItem(String(item.remote_id), { outfitId: outfit.id });
            return;
          }
        }
      } catch (e) { /* tracking is best-effort */ }
    }

    fetchOutfits() {
      // Reuse the shared, memoized fetch (bp-stylitics-loader) so click/ATC
      // tracking never adds another outfits request — the SDK grid render is
      // the single intended call, and this resolves from the same cache.
      if (typeof window.bpStyliticsOutfits === 'function') {
        return window.bpStyliticsOutfits(this.style_);
      }
      if (this._outfitsPromise) return this._outfitsPromise;
      const url = 'https://widget-api.stylitics.com/api/outfits?username=bostonproper&item_number='
        + encodeURIComponent(this.style_);
      this._outfitsPromise = fetch(url, { cache: 'force-cache' })
        .then((r) => (r.ok ? r.json() : []))
        .then((d) => (Array.isArray(d) ? d : []))
        .catch(() => []);
      return this._outfitsPromise;
    }

    // ===== Stylitics Add-to-Cart engagement tracking (#3) =====
    // Atlas fires styliticsComposer.modules[0].trackAddItemToCart on both the
    // main PDP add ({placement:'main'}) and the widget quick-view add
    // ({placement:'widget'}). Our adds all flow through Horizon's cart events
    // (product:added / cart:update), so we diff the cart to find the ADDED
    // line and attribute it: the widget context (set on a look-item click)
    // wins by handle match; otherwise a line matching THIS product is 'main'.
    // Other adds (e.g. Complete-the-look) are ignored — they aren't HTWI
    // engagement.
    initAtcTracking() {
      this._mainProductId = this.dataset.bpHtwiProductId || '';
      // Seed a baseline so the first add has something to diff against.
      fetch('/cart.js', { credentials: 'same-origin' })
        .then((r) => r.json())
        .then((c) => { this._cartSnap = this.snapCart(c); })
        .catch(() => {});
      this._onAdd = (e) => this.onCartMaybeAdded(e);
      document.addEventListener('product:added', this._onAdd);
      document.addEventListener('cart:update', this._onAdd);
    }

    snapCart(cart) {
      const m = {};
      ((cart && cart.items) || []).forEach((it) => {
        m[it.key] = { qty: it.quantity, product_id: it.product_id, handle: it.handle, price: it.price };
      });
      return m;
    }

    // Record the clicked look item so the next add is attributed to the
    // widget. Matched by handle at add time, so it can't mis-attribute a
    // later main-product add. Resolves the item's remote_id (the Stylitics
    // itemId) from the shared outfit data.
    setWidgetAddContext(productUrl) {
      const norm = (u) => String(u || '')
        .replace(/^https?:\/\/[^/]+/, '')
        .replace(/^\/products\//, '')
        .replace(/[/?#].*$/, '')
        .trim();
      const handle = norm(productUrl);
      if (!handle) return;
      // Valid for a generous window (the shopper may take a while to pick a
      // size in the drawer); the handle match keeps it from firing on an
      // unrelated add.
      window.__bpStyliticsWidgetAdd = { style: handle, handle: handle, until: Date.now() + 90000 };
      this.fetchOutfits().then((outfits) => {
        (outfits || []).some((outfit) => {
          const item = ((outfit && outfit.items) || []).find((it) => norm(it && it.affiliate_link) === handle);
          if (item) {
            const ctx = window.__bpStyliticsWidgetAdd;
            if (ctx && ctx.handle === handle) ctx.style = String(item.remote_id || item.item_id || handle);
            return true;
          }
          return false;
        });
      }).catch(() => {});
    }

    async onCartMaybeAdded(e) {
      let cart = e && e.detail && e.detail.cart;
      if (!cart || !cart.items) {
        try { cart = await fetch('/cart.js', { credentials: 'same-origin' }).then((r) => r.json()); }
        catch (_) { return; }
      }
      const next = this.snapCart(cart);
      const prev = this._cartSnap;
      this._cartSnap = next;
      if (!prev) return; // no baseline yet — just seed

      const added = [];
      Object.keys(next).forEach((k) => {
        if (!prev[k] || next[k].qty > prev[k].qty) added.push(next[k]);
      });
      if (!added.length) return;

      const ctx = window.__bpStyliticsWidgetAdd;
      const widgetFresh = ctx && ctx.until > Date.now();

      added.forEach((line) => {
        const price = (typeof line.price === 'number') ? (line.price / 100).toFixed(2) : '';
        if (widgetFresh && ctx.handle && String(line.handle) === String(ctx.handle)) {
          this.trackAddToCart(ctx.style, price, 'widget');
          window.__bpStyliticsWidgetAdd = null; // consume
        } else if (this._mainProductId && String(line.product_id) === String(this._mainProductId)) {
          this.trackAddToCart(this.style_, price, 'main');
        }
        // else: not an HTWI-relevant add (Complete-the-look, saved-for-later…)
      });
    }

    trackAddToCart(itemId, price, placement) {
      if (!itemId) return;
      const payload = { currency: 'USD', itemId: String(itemId), placement: placement };
      if (price) payload.price = String(price);
      // The composer provides trackAddItemToCart, but the shopper may add from
      // the buy box BEFORE scrolling to the (lazy) widget, so it may not be up
      // yet. Kick off init once and retry for a few seconds until the module
      // exists, then fire. Gives up silently if the SDK never loads.
      let tries = 0;
      const attempt = () => {
        const mod = window.styliticsComposer && window.styliticsComposer.modules && window.styliticsComposer.modules[0];
        if (mod && typeof mod.trackAddItemToCart === 'function') {
          try { mod.trackAddItemToCart(payload); } catch (_) { /* best-effort */ }
          return;
        }
        if (!this._initAttempted) {
          Promise.resolve().then(() => this.initComposer()).catch(() => {});
        }
        if (tries++ < 20) setTimeout(attempt, 300); // ~6s ceiling
      };
      attempt();
    }

    openQuickAdd(productUrl) {
      if (!productUrl) return;
      // Stylitics returns ABSOLUTE product URLs on the prod domain
      // (https://www.bostonproper.com/products/...). On staging that anchor
      // is cross-origin, so Horizon's quick-add fetch of the product content
      // fails and the drawer opens but never loads (STAGING ONLY, Ernie
      // 7/22). Rewrite to a path relative to the CURRENT origin so the fetch
      // hits staging on staging / prod on prod — same reason bp-bloomreach
      // normalizes BR's placeholder hosts to relative /products/<handle>.
      try {
        var u = new URL(productUrl, window.location.origin);
        productUrl = u.pathname + u.search;
      } catch (_) {
        var m = String(productUrl).match(/\/products\/[^\s"']+/);
        if (m) productUrl = m[0];
      }
      // Horizon's quick-add derives its product URL from a <product-card>
      // ancestor's link. Build a hidden, minimal trigger for the clicked
      // product, then open the drawer through it (window.bpOpenProductDrawer).
      let host = this._qaHost;
      if (!host) {
        host = document.createElement('div');
        host.setAttribute('data-bp-htwi-qa-host', '');
        host.style.cssText =
          'position:absolute;left:-9999px;top:0;width:1px;height:1px;overflow:hidden;';
        document.body.appendChild(host);
        this._qaHost = host;
      }
      // Horizon's quick-add reads the product URL from the product-card's
      // `ref="productCardLink"` (this.refs.productCardLink), so the anchor
      // MUST carry that ref — without it productPageUrl is '' and the drawer
      // opens empty.
      host.innerHTML =
        '<product-card>' +
        '<a class="product-card__link" ref="productCardLink" href="' + productUrl + '"></a>' +
        '<quick-add-component ref="quickAdd">' +
        '<button type="button" class="button quick-add__button quick-add__button--choose add-to-cart-button" ' +
        'on:click="quick-add-component/handleClick"></button>' +
        '</quick-add-component>' +
        '</product-card>';

      const choose = host.querySelector('.quick-add__button--choose');
      requestAnimationFrame(() => {
        try {
          if (typeof window.bpOpenProductDrawer === 'function' && choose) {
            window.bpOpenProductDrawer(choose);
          } else if (choose) {
            choose.click();
          } else {
            window.location.href = productUrl;
          }
        } catch (err) {
          console.warn('[bp-htwi] quick-add open failed, navigating', err);
          window.location.href = productUrl;
        }
      });
    }

    disconnectedCallback() {
      if (this._obs) this._obs.disconnect();
      if (this._lookObs) this._lookObs.disconnect();
      if (this._onSwap) document.removeEventListener('bp:pdp:swapped', this._onSwap);
      if (this._onAdd) {
        document.removeEventListener('product:added', this._onAdd);
        document.removeEventListener('cart:update', this._onAdd);
      }
      if (this._composer && typeof this._composer.destroy === 'function') {
        try { this._composer.destroy(); } catch (e) { /* noop */ }
      }
      if (this._qaHost) this._qaHost.remove();
    }
  }
  if (!customElements.get('bp-htwi')) customElements.define('bp-htwi', BpHtwi);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bp-image-row"] && !Shopify.designMode) return;
  try {
    
  class BpImageRow extends HTMLElement {
    connectedCallback() {
      const rail = this.querySelector('[data-bp-imr-rail]');
      const indicator = this.querySelector('[data-bp-imr-indicator]');
      if (!rail || !indicator) return;

      const update = () => {
        const visible = rail.clientWidth;
        const total = rail.scrollWidth;
        if (total <= visible) {
          indicator.style.display = 'none';
          return;
        }
        indicator.style.display = '';
        const overflow = total - visible;
        const thumbW = (visible / total) * 100;
        const thumbX = overflow > 0 ? rail.scrollLeft / overflow : 0;
        indicator.style.setProperty('--bp-imr-thumb-w', thumbW + '%');
        indicator.style.setProperty('--bp-imr-thumb-x', thumbX);
      };
      rail.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      this._update = update;
      requestAnimationFrame(update);
    }
    disconnectedCallback() {
      if (this._update) window.removeEventListener('resize', this._update);
    }
  }
  if (!customElements.get('bp-image-row')) {
    customElements.define('bp-image-row', BpImageRow);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bp-our-most-loved"] && !Shopify.designMode) return;
  try {
    
  class BpOurMostLoved extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.bp-oml__track');
      if (!this.track) return;

      this.indicator = this.querySelector('[data-bp-oml-indicator]');
      this.prevBtn = this.querySelector('[data-direction="prev"]');
      this.nextBtn = this.querySelector('[data-direction="next"]');

      if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.scrollByCard(-1));
      if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.scrollByCard(1));

      // §9.4 quick-view + quick-buy behaviors — same pattern as
      // bp-product-carousel. Honors data-bp-card-qv-dest (drawer/PDP)
      // and data-bp-card-qb-style (button/whole_product/disabled).
      const openDrawer = (card) => {
        const trigger = card.querySelector('.quick-add__button--choose');
        if (!trigger) return;
        if (typeof window.bpOpenProductDrawer === 'function') {
          window.bpOpenProductDrawer(trigger);
        } else {
          trigger.click();
        }
      };

      const prefetchCard = (card) => {
        if (card.__bpPrefetched) return;
        card.__bpPrefetched = true;
        const link = card.querySelector('.bp-oml-card__media-link');
        if (link?.href) fetch(link.href, { credentials: 'same-origin' }).catch(() => {});
      };

      const handleQv = (card, e) => {
        const dest = card.dataset.bpCardQvDest || 'drawer';
        const url = card.dataset.productUrl;
        if (dest === 'pdp') {
          if (e.currentTarget.matches('[data-bp-card-qv-trigger]') && url) {
            e.preventDefault();
            window.location.href = url;
          }
          return;
        }
        e.preventDefault();
        e.stopPropagation();
        openDrawer(card);
      };

      this.querySelectorAll('.bp-oml-card').forEach((card) => {
        const style = card.dataset.bpCardQbStyle || 'button';
        if (style === 'disabled') return;

        if (style === 'button') {
          const bag = card.querySelector('[data-bp-card-qv-trigger]');
          if (!bag) return;
          ['mouseenter', 'focus', 'touchstart'].forEach((ev) =>
            bag.addEventListener(ev, () => prefetchCard(card), { passive: true })
          );
          bag.addEventListener('click', (e) => handleQv(card, e));
        } else if (style === 'whole_product') {
          ['mouseenter', 'focus', 'touchstart'].forEach((ev) =>
            card.addEventListener(ev, () => prefetchCard(card), { passive: true })
          );
          card.addEventListener('click', (e) => handleQv(card, e));
        }
      });

      this.updateArrows = this.updateArrows.bind(this);
      this.track.addEventListener('scroll', this.updateArrows, { passive: true });
      window.addEventListener('resize', this.updateArrows);
      requestAnimationFrame(this.updateArrows);
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.updateArrows);
    }

    scrollByCard(direction) {
      const slide = this.track.querySelector('.bp-oml__slide');
      if (!slide) return;
      const styles = getComputedStyle(this.track);
      const gap = parseFloat(styles.columnGap || styles.gap) || 0;
      const step = slide.getBoundingClientRect().width + gap;
      this.track.scrollBy({ left: step * direction, behavior: 'smooth' });
    }

    updateArrows() {
      const { scrollLeft, scrollWidth, clientWidth } = this.track;
      if (this.prevBtn && this.nextBtn) {
        this.prevBtn.disabled = scrollLeft <= 1;
        this.nextBtn.disabled = scrollLeft + clientWidth >= scrollWidth - 1;
      }
      if (this.indicator) {
        if (scrollWidth <= clientWidth) {
          this.indicator.style.display = 'none';
        } else {
          this.indicator.style.display = '';
          const thumbW = (clientWidth / scrollWidth) * 100;
          const overflow = scrollWidth - clientWidth;
          const thumbX = overflow > 0 ? scrollLeft / overflow : 0;
          this.indicator.style.setProperty('--bp-oml-thumb-w', thumbW + '%');
          this.indicator.style.setProperty('--bp-oml-thumb-x', thumbX);
        }
      }
    }
  }

  if (!customElements.get('bp-our-most-loved')) {
    customElements.define('bp-our-most-loved', BpOurMostLoved);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bp-product-carousel"] && !Shopify.designMode) return;
  try {
    
  class BpProductCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.bp-pc__track');
      if (!this.track) return;

      this.indicator = this.querySelector('[data-bp-pc-indicator]');
      this.prevBtn = this.querySelector('[data-direction="prev"]');
      this.nextBtn = this.querySelector('[data-direction="next"]');

      /* Mobile intro promotion — on <1024px the optional intro card
         lifts OUT of the scrolling track and renders above it (per
         Figma "quote above carousel" layout). On ≥1024px it slides
         BACK into the track as the first card. Re-evaluates on
         resize so rotating a tablet between layouts works cleanly. */
      this.introSlide = this.track.querySelector('.bp-pc__slide--intro');
      if (this.introSlide) {
        this.introHolder = document.createElement('div');
        this.introHolder.className = 'bp-pc__intro-mobile';
        this.introMq = window.matchMedia('(max-width: 1023px)');
        this.syncIntroPlacement = () => {
          if (!this.introSlide || !this.track) return;
          if (this.introMq.matches) {
            // Mobile: move the slide into the holder above the track.
            if (this.introSlide.parentNode !== this.introHolder) {
              this.introHolder.appendChild(this.introSlide);
              this.track.parentNode.insertBefore(this.introHolder, this.track);
            }
          } else {
            // Desktop: ensure the slide is back as first child of the track.
            if (this.introSlide.parentNode !== this.track) {
              this.track.insertBefore(this.introSlide, this.track.firstChild);
            }
            if (this.introHolder.parentNode) this.introHolder.parentNode.removeChild(this.introHolder);
          }
        };
        this.syncIntroPlacement();
        this.introMq.addEventListener('change', this.syncIntroPlacement);
      }

      if (this.prevBtn) {
        this.prevBtn.addEventListener('click', () => this.scrollByCard(-1));
      }
      if (this.nextBtn) {
        this.nextBtn.addEventListener('click', () => this.scrollByCard(1));
      }

      // Quick-view + swatch behaviors — driven by per-card data attrs
      // (data-bp-card-qv-dest, data-bp-card-qb-style) so the merchant
      // controls dest (drawer vs. PDP) and trigger style (button vs.
      // whole-product) per §9.4. Hover/focus/touchstart prefetches the
      // product page so the drawer fetch is warm.
      const openDrawer = (card) => {
        const trigger = card.querySelector('.quick-add__button--choose');
        if (!trigger) return;
        if (typeof window.bpOpenProductDrawer === 'function') {
          window.bpOpenProductDrawer(trigger);
        } else {
          trigger.click();
        }
      };

      // Prefetch the EXACT URL the drawer will open (variant +
      // section_id) and store the grid in the shared drawer cache, so
      // the click is a cache hit — not just a warm HTTP entry under a
      // different (bare) URL, which was the prior miss.
      const prefetchCard = (card) => {
        if (card.__bpPrefetched) return;
        card.__bpPrefetched = true;
        try {
          const link = card.querySelector('.bp-card__media-link') || card.querySelector('a[href*="/products/"]');
          if (!link?.href) return;
          const u = new URL(link.href, window.location.origin);
          if (!u.searchParams.has('variant')) {
            const pc = card.closest('product-card');
            const vid = pc && typeof pc.getSelectedVariantId === 'function' ? pc.getSelectedVariantId() : null;
            if (vid) u.searchParams.set('variant', vid);
          }
          let mainId = window.__bpPdpMainSectionId;
          if (!mainId) { try { mainId = sessionStorage.getItem('bpPdpMainSectionId'); } catch (e) {} }
          if (mainId) u.searchParams.set('section_id', mainId);
          const fetchUrl = u.toString();
          const cache = (window.__bpDrawerCache = window.__bpDrawerCache || new Map());
          if (cache.get(fetchUrl)) return;
          fetch(fetchUrl, { credentials: 'same-origin', headers: { 'Accept': 'text/html' } })
            .then((r) => (r.ok ? r.text() : null))
            .then((html) => {
              if (!html) return;
              const grid = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-product-grid-content]');
              if (grid) cache.set(fetchUrl, grid.cloneNode(true));
            })
            .catch(() => {});
        } catch (e) {}
      };

      const handleQv = (card, e) => {
        const dest = card.dataset.bpCardQvDest || 'drawer';
        const url = card.dataset.productUrl;
        if (dest === 'pdp') {
          // Let the user navigate to the PDP. If the click came from
          // the bag button (which is type="button"), do the navigation
          // ourselves; if it came from the card surface, the link
          // inside will follow naturally — don't preventDefault.
          if (e.currentTarget.matches('[data-bp-card-qv-trigger]') && url) {
            e.preventDefault();
            window.location.href = url;
          }
          return;
        }
        e.preventDefault();
        e.stopPropagation();
        openDrawer(card);
      };

      this.querySelectorAll('.bp-card').forEach((card) => {
        const style = card.dataset.bpCardQbStyle || 'button';

        if (style === 'disabled') return;

        if (style === 'button') {
          const bag = card.querySelector('[data-bp-card-qv-trigger]');
          if (!bag) return;
          ['mouseenter', 'focus', 'touchstart'].forEach((ev) =>
            bag.addEventListener(ev, () => prefetchCard(card), { passive: true })
          );
          bag.addEventListener('click', (e) => handleQv(card, e));
        } else if (style === 'whole_product') {
          // Entire card surface = trigger. The product link inside
          // still works for keyboard / right-click; mouse clicks on
          // anything inside the card open the drawer (or navigate
          // to the PDP, depending on dest).
          ['mouseenter', 'focus', 'touchstart'].forEach((ev) =>
            card.addEventListener(ev, () => prefetchCard(card), { passive: true })
          );
          card.addEventListener('click', (e) => {
            // Don't hijack clicks on swatches.
            if (e.target.closest('.bp-card__swatches')) return;
            handleQv(card, e);
          });
        }

      });

      this.updateArrows = this.updateArrows.bind(this);
      this.track.addEventListener('scroll', this.updateArrows, { passive: true });
      window.addEventListener('resize', this.updateArrows);
      // Initial state
      requestAnimationFrame(this.updateArrows);
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.updateArrows);
    }

    scrollByCard(direction) {
      const slide = this.track.querySelector('.bp-pc__slide');
      if (!slide) return;
      const styles = getComputedStyle(this.track);
      const gap = parseFloat(styles.columnGap || styles.gap) || 0;
      const step = slide.getBoundingClientRect().width + gap;
      this.track.scrollBy({ left: step * direction, behavior: 'smooth' });
    }

    updateArrows() {
      const { scrollLeft, scrollWidth, clientWidth } = this.track;
      // 1px slack for sub-pixel rounding
      if (this.prevBtn && this.nextBtn) {
        this.prevBtn.disabled = scrollLeft <= 1;
        this.nextBtn.disabled = scrollLeft + clientWidth >= scrollWidth - 1;
      }
      if (this.indicator) {
        if (scrollWidth <= clientWidth) {
          this.indicator.style.display = 'none';
        } else {
          this.indicator.style.display = '';
          const thumbW = (clientWidth / scrollWidth) * 100;
          const overflow = scrollWidth - clientWidth;
          const thumbX = overflow > 0 ? scrollLeft / overflow : 0;
          this.indicator.style.setProperty('--bp-pc-thumb-w', thumbW + '%');
          this.indicator.style.setProperty('--bp-pc-thumb-x', thumbX);
        }
      }
    }
  }

  if (!customElements.get('bp-product-carousel')) {
    customElements.define('bp-product-carousel', BpProductCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bp-product-featured-grid"] && !Shopify.designMode) return;
  try {
    
  class BpProductFeaturedGrid extends HTMLElement {
    connectedCallback() {
      // No interactive carousel logic — section is a static grid.
      // Hook left for future per-card behaviors if needed.
    }
  }
  if (!customElements.get('bp-product-featured-grid')) {
    customElements.define('bp-product-featured-grid', BpProductFeaturedGrid);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bp-quick-drawer"]) return;
  try {
    
  /* =============================================================
     BP Quick Drawer — controller script.

     Responsibilities:
       1. window.bpOpenProductDrawer(triggerEl) — instant-open API
          for card click handlers (unchanged signature; 5 callers).
       2. Close latch — Horizon's quick-add handleClick is async and
          ALWAYS calls showDialog after its fetch resolves. A
          user-close mid-fetch would silently reopen otherwise; we
          wrap showDialog to early-return when the latch is on.
       3. MutationObserver on #quick-add-modal-content — fires
          redistribute() + the BP block hydrators after Horizon's
          morph completes.
       4. redistribute() — moves morphed pieces into the structured
          shell:
            .product-information__media → .bp-qd__media-slot
            .buy-buttons-block          → .bp-qd__cta-slot (wrapped
                                          in .bp-qd__atc-row)
            .bp-pdp-save-later          → into the atc-row alongside
                                          the ATC button (and flag
                                          it bp-pdp-save-later--placed
                                          so the block's own inline
                                          IIFE skips its reparent)
       5. Hydrators (color-siblings hover + fetch fallback, Yotpo
          SDK refresh, notify-me availability toggle, preorder
          reparent + date compute, final-sale reparent) — ported
          verbatim from snippets/bp-product-drawer.liquid.

     Idempotent at every level — multiple opens of the same product
     don't re-bind events. The script itself is guarded by a window
     singleton flag.
     ============================================================= */
  if (!window._bpQuickDrawerInited) {
    window._bpQuickDrawerInited = true;

    (function () {
      'use strict';

      var TAG = '[bp-qd]';
      function log() {
        var args = Array.prototype.slice.call(arguments);
        args.unshift(TAG);
        try { console.log.apply(console, args); } catch (_) {}
      }

      function getDialogEl()      { return document.getElementById('quick-add-dialog'); }
      function getDialog()        { var el = getDialogEl(); return el && ((el.refs && el.refs.dialog) || el.querySelector('dialog')); }
      function getModalContent()  { return document.getElementById('quick-add-modal-content'); }
      function getMediaSlot()     { return document.querySelector('[data-bp-qd-media-slot]'); }
      function getCtaSlot()       { return document.querySelector('[data-bp-qd-cta-slot]'); }
      function clearLoading()     { document.body.classList.remove('bp-drawer-loading'); }

      window._bpDrawerState = window._bpDrawerState || { latched: false };
      var state = window._bpDrawerState;

      /* ----- Public API — instant open ----- */
      window.bpOpenProductDrawer = function (triggerEl) {
        if (!triggerEl) { log('called with no trigger'); return; }
        log('open requested → clearing latch');
        state.latched = false;

        document.body.classList.add('bp-drawer-loading');

        /* Purge stale content from any previous drawer open. The
           morph only replaces children of #quick-add-modal-content,
           so the media/cta-slot we moved nodes into still hold the
           previous product's markup. Clear ONCE per open (here),
           not on every MutationObserver fire — fires during a single
           morph cycle would otherwise wipe content we just placed. */
        var mediaSlot = getMediaSlot();
        if (mediaSlot) mediaSlot.innerHTML = '';
        var ctaSlot = getCtaSlot();
        if (ctaSlot) {
          ctaSlot.querySelectorAll('[data-bp-qd-placed]').forEach(function (el) {
            el.remove();
          });
        }
        /* Reset hydrate-schedule flags so the retry-poll restarts
           fresh for the new product. */
        var modalContent = getModalContent();
        if (modalContent) {
          modalContent._bpFinalSaleScheduled = false;
          modalContent._bpPreorderScheduled = false;
          modalContent._bpListedBlocks = false;
          modalContent._bpUserPicked = false;
          /* TrueFit's per-product widget id needs re-registration
             when a new product's iframe morphs in. */
          modalContent.querySelectorAll('.tfc-fitrec-product[data-bp-tf-hydrated]').forEach(function (el) {
            el.removeAttribute('data-bp-tf-hydrated');
          });
        }

        var dialogEl = getDialogEl();
        try {
          if (dialogEl && typeof dialogEl.showDialog === 'function') {
            dialogEl.showDialog();
          }
        } catch (e) { log('showDialog threw', e); }

        requestAnimationFrame(function () {
          try { triggerEl.click(); }
          catch (e) { clearLoading(); log('triggerEl.click threw', e); }
        });

        setTimeout(clearLoading, 6000);
      };

      /* ----- Wire close-latch + morph observer when dialog mounts ----- */
      function attachWatchers() {
        var dialog = getDialog();
        if (!dialog) {
          log('no <dialog> yet — retrying');
          setTimeout(attachWatchers, 100);
          return;
        }
        if (dialog._bpHooked) { log('dialog already hooked'); return; }
        dialog._bpHooked = true;
        log('hooked into dialog');

        dialog.addEventListener('close', function () {
          state.latched = true;
          clearLoading();
        });

        /* Wrap showDialog as the single enforcement point — stale
           Horizon handleClicks call it, and we early-return when
           latched. */
        function tryWrapShowDialog() {
          var dialogEl = getDialogEl();
          if (!dialogEl) return false;
          if (dialogEl._bpShowWrapped) return true;
          if (typeof dialogEl.showDialog !== 'function') return false;
          dialogEl._bpShowWrapped = true;
          var orig = dialogEl.showDialog;
          dialogEl.showDialog = function () {
            if (state.latched) { log('showDialog blocked — latched'); return undefined; }
            return orig.apply(dialogEl, arguments);
          };
          return true;
        }
        if (!tryWrapShowDialog() && window.customElements && customElements.whenDefined) {
          customElements.whenDefined('quick-add-dialog').then(tryWrapShowDialog);
        }

        /* Backstop — if showDialog wrap missed (timing edge), watch
           the `open` attribute and slam shut if we're latched. */
        new MutationObserver(function () {
          if (!dialog.open) return;
          if (!state.latched) return;
          try { dialog.close(); } catch (_) {}
        }).observe(dialog, { attributes: true, attributeFilter: ['open'] });

        /* Require an actively-chosen size in the drawer. The fetched
           section preselects the variant (?variant=), so a shopper could
           add a defaulted size without picking one. Uncheck any
           preselected radio in a multi-value option fieldset — the radios
           are `required` and the buy-buttons form is non-novalidate, so
           product-form.js's checkValidity() then blocks Add to Bag until a
           size is chosen (same guard as the PDP). Single-value options
           keep their auto-selection. Guarded per content-render and reset
           on open / sibling-swap so a new colour's size is re-required. */
        function requireDrawerSize(scope) {
          var picker = scope.querySelector('variant-picker');
          if (!picker) return;
          function multiFieldsets() {
            return Array.prototype.filter.call(
              scope.querySelectorAll('variant-picker fieldset.variant-option'),
              function (fs) { return fs.querySelectorAll('input[type="radio"]').length > 1; }
            );
          }
          if (!multiFieldsets().length) return; // nothing to choose (single-size / no size)

          /* The CTA is redistributed into .bp-qd__cta-slot (outside
             modalContent), so search the whole dialog for it. Self-
             contained (doesn't depend on bp-require-size wiring in the
             drawer). */
          var dialog = scope.closest('quick-add-dialog') || document.getElementById('quick-add-dialog') || document;

          function evaluate() {
            // Until the shopper actively picks a size, keep any preselected
            // size cleared — the fetched section preselects via ?variant=
            // and Horizon re-checks it on every morph, so this must re-run
            // (not once) or the default (XS) sticks and gets added.
            if (!scope._bpUserPicked) {
              multiFieldsets().forEach(function (fs) {
                fs.querySelectorAll('input[type="radio"]:checked').forEach(function (r) {
                  r.checked = false;
                  r.setAttribute('data-current-checked', 'false');
                });
              });
            }
            var complete = scope._bpUserPicked && multiFieldsets().every(function (fs) {
              return fs.querySelector('input[type="radio"]:checked');
            });
            // A complete selection can still resolve to a sold-out variant —
            // Horizon flags that on the radio itself (aria-disabled +
            // data-option-available, stamped per option value by
            // snippets/variant-main-picker.liquid). This mirrors
            // blocks/bp-require-size.liquid's selectionInStock() check on the
            // PDP: picking a struck-through size here only satisfies "every
            // fieldset has a checked radio," so without this check the button
            // went fully enabled on an OOS pick and Add to Bag round-tripped
            // to Shopify's "already sold out" error (QA 7/27).
            var checkedRadios = multiFieldsets().map(function (fs) {
              return fs.querySelector('input[type="radio"]:checked');
            }).filter(Boolean);
            var inStock = !complete || checkedRadios.every(function (r) {
              return r.getAttribute('aria-disabled') !== 'true' &&
                     r.getAttribute('data-option-available') !== 'false';
            });
            var addable = complete && inStock;
            dialog.querySelectorAll('add-to-cart-component button, button[name="add"], .add-to-cart-button').forEach(function (btn) {
              btn.toggleAttribute('data-bp-size-block', !addable);
              if (!addable) btn.setAttribute('aria-disabled', 'true');
              else btn.removeAttribute('aria-disabled');
              // No size chosen yet: data-bp-size-block's pointer-events:none
              // (blocks/bp-require-size.liquid CSS) + the required-radio
              // validity block a submit — `disabled` is left alone so the
              // button isn't a dead end. OOS size chosen: the form IS valid
              // (a radio is checked), so only the real `disabled` property
              // stops it. Track ownership so we never re-enable a button
              // Horizon/server disabled for another reason.
              if (complete && !inStock) {
                btn.disabled = true;
                scope._bpSizeDisabledByUs = true;
              } else if (scope._bpSizeDisabledByUs) {
                btn.disabled = false;
                scope._bpSizeDisabledByUs = false;
              }
            });
            dialog.querySelectorAll('accelerated-checkout-component, .shopify-payment-button').forEach(function (el) {
              el.style.display = addable ? '' : 'none';
            });
            /* Ship date is variant-specific — hide it until a size is picked. */
            if (!complete) {
              var pol = scope.querySelector('.bp-preorder-line');
              if (pol) pol.hidden = true;
            }
          }

          if (!scope._bpSizeWired) {
            scope._bpSizeWired = true;
            // Delegated on modalContent (stable across variant-picker morphs).
            // A radio change in a size fieldset = the shopper's active pick.
            scope.addEventListener('change', function (e) {
              var t = e.target;
              if (t && t.type === 'radio' && t.closest && t.closest('fieldset.variant-option')) {
                scope._bpUserPicked = true;
                syncPickedVariant();
              }
              evaluate();
            }, { passive: true });
          }
          // Push the shopper's picked variant into the buy-buttons form input.
          // In quick-add context Horizon's variant-picker does NOT write
          // ?variant= to the URL (variant-picker.js isOnProductPage is false
          // under quick-add-dialog) and its section re-fetch "only morphs the
          // variant picker" — never the form, which redistribute() has moved
          // out into .bp-qd__cta-slot. So the picked variant never reaches
          // product-form.js#getIntendedVariantId, which then falls back to the
          // stale first-variant id and adds the wrong size. Sync it ourselves:
          // each option-value radio carries the resulting variant on
          // data-variant-id (the same field variant-picker.js reads).
          function syncPickedVariant() {
            var picks = multiFieldsets().map(function (fs) {
              return fs.querySelector('input[type="radio"]:checked');
            });
            if (!picks.length || !picks.every(Boolean)) return;
            var vid = null;
            picks.forEach(function (r) { if (r.dataset.variantId) vid = r.dataset.variantId; });
            if (!vid) return;
            dialog.querySelectorAll('input[name="id"]').forEach(function (inp) {
              inp.value = vid;
            });
          }
          evaluate(); // re-assert on every render
        }

        /* Morph observer — fires when Horizon's morph drops content
           into #quick-add-modal-content. */
        var modalContent = getModalContent();
        if (modalContent) {
          var ready = 'product-form-component, variant-picker, .product-details, [data-product-grid-content]';
          new MutationObserver(function () {
            if (modalContent.querySelector(ready)) {
              clearLoading();
              redistribute(modalContent);
              hydrateColorSiblings(modalContent);
              hydrateYotpoWidgets(modalContent);
              hydrateNotifyMe(modalContent);
              hydratePreorderLine(modalContent);
              hydrateFinalSale(modalContent);
              hydrateTrueFit(modalContent);
              requireDrawerSize(modalContent);
              /* Debug: list every bp-* element morphed in so we can
                 see if blocks like .bp-final-sale are missing from
                 the fetched HTML (e.g. cached pre-metafield-set
                 version still in Horizon's #cachedContent Map, or
                 metafield value doesn't match the truthy whitelist
                 in bp-final-sale.liquid). */
              if (!modalContent._bpListedBlocks) {
                modalContent._bpListedBlocks = true;
                /* Use classList — SVG className is SVGAnimatedString
                   and doesn't have .split. classList works on both. */
                var bpEls = modalContent.querySelectorAll('[class*="bp-"]');
                var classes = {};
                bpEls.forEach(function (el) {
                  Array.prototype.forEach.call(el.classList, function (c) {
                    if (c.indexOf('bp-') === 0) classes[c] = (classes[c] || 0) + 1;
                  });
                });
                log('morphed bp-* classes:', Object.keys(classes).sort().join(', '));
                log('contains "Final Sale" text:', modalContent.textContent.indexOf('Final Sale') !== -1);
              }
            }
          }).observe(modalContent, { childList: true, subtree: true });
        }
      }

      /* =============================================================
         REDISTRIBUTE — move morphed nodes into the structured shell.

         Runs after every morph. Idempotent: each moved node is
         tagged with [data-bp-qd-placed] so a follow-up mutation
         doesn't re-move it (or, more importantly, doesn't try to
         move an empty node that morph just emptied).
         ============================================================= */
      function redistribute(scope) {
        var mediaSlot = getMediaSlot();
        var ctaSlot = getCtaSlot();
        if (!mediaSlot || !ctaSlot) return;

        /* No purge here — bpOpenProductDrawer() handles the cross-
           open clear once per open. The MutationObserver fires many
           times during a single morph cycle; a purge here would wipe
           content we just placed on an earlier fire of the same
           morph. Per-element [data-bp-qd-placed] is sufficient
           idempotency for the within-morph case. */

        /* 1. Gallery → media-slot */
        var media = scope.querySelector('.product-information__media:not([data-bp-qd-placed])');
        if (media) {
          media.setAttribute('data-bp-qd-placed', '');
          mediaSlot.appendChild(media);

          /* Force-load every gallery image. In the drawer the rail is a
             horizontal carousel, so slides past the first sit off-screen and
             their loading="lazy" viewport trigger never fires — only the first
             image painted (QA 7/23, Brooke). The full Amplience set hydrates
             ASYNC via the gallery's connectedCallback -> replaceRail(), which
             REBUILDS slides 1..n with loading="lazy" AFTER this point, so a
             one-time flip misses them. Watch the slot and flip every lazy
             gallery image to eager as it appears; stop after the hydration
             window. */
          var eagerLoadGallery = function () {
            mediaSlot.querySelectorAll(
              '.bp-pdp-gallery__img[loading="lazy"], .bp-pdp-gallery__slide img[loading="lazy"], .product-media__image[loading="lazy"]'
            ).forEach(function (img) { img.loading = 'eager'; });
          };
          eagerLoadGallery();
          var galEl = mediaSlot.querySelector('bp-pdp-gallery');
          var eagerMo = new MutationObserver(eagerLoadGallery);
          eagerMo.observe(galEl || mediaSlot, { childList: true, subtree: true });
          setTimeout(function () { eagerMo.disconnect(); }, 8000);

          /* Root cause of "only the first image loads": <bp-pdp-gallery>'s
             custom element is defined in the gallery block's {% javascript %},
             which only loads on the PDP — NOT the PLP. Opening quick-add from a
             PLP inserts un-upgraded gallery markup, so connectedCallback never
             runs and the Amplience hydration (replaceRail) that fills slides
             1..n never fires — leaving slide 0 + an empty reserved placeholder.
             Fill the rest from the inert Shopify media <template> the block
             bakes in (same slides hydrateFromFallback() would use), which needs
             no upgraded element. Skip if the gallery hydrated itself (PDP
             quick-add, where the element IS defined). */
          var galleryDefined = window.customElements && customElements.get('bp-pdp-gallery');
          if (galEl && !galleryDefined) {
            setTimeout(function () {
              if (galEl.getAttribute('data-bp-source') ||
                  !galEl.querySelector('[data-bp-amp-placeholder]')) return; // already hydrated
              var rail = galEl.querySelector('[data-bp-pdp-rail], .bp-pdp-gallery__rail');
              var tpl  = galEl.querySelector('template[data-bp-shopify-fallback]');
              if (!rail || !tpl) return;
              rail.querySelectorAll('[data-bp-amp-placeholder]').forEach(function (ph) { ph.remove(); });
              var frag = tpl.content.cloneNode(true);
              frag.querySelectorAll('.bp-pdp-gallery__slide').forEach(function (s) {
                if (s.getAttribute('data-index') === '0') return; // keep painted hero
                rail.appendChild(s);
              });
              galEl.setAttribute('data-bp-source', 'qd-fallback');
              eagerLoadGallery();
            }, 500);
          }

          /* Inject prev/next chevron arrows overlaid on the gallery
             image (mobile carousel). Same 44×44 BP chevron used in
             bp-styled-for-you / bp-shop-the-look. */
          var gallery = mediaSlot.querySelector('bp-pdp-gallery');
          var rail = mediaSlot.querySelector('.bp-pdp-gallery__rail');
          if (gallery && rail && !gallery.querySelector('.bp-qd-gallery-nav')) {
            var chevronSvg = '<svg xmlns="http://www.w3.org/2000/svg" width="44" height="44" viewBox="0 0 44 44" fill="none" aria-hidden="true">' +
              '<path d="M18.1326 13.8674C18.0884 13.8244 18.0442 13.7814 18 13.7385C17.9128 13.8256 17.8256 13.9128 17.7385 14C17.7814 14.0442 17.8244 14.0884 17.8674 14.1326C18.1304 14.4029 18.3934 14.6733 18.6564 14.9436C21.0232 17.3768 23.3901 19.8099 25.7569 22.2431V21.7569C23.3238 24.1238 20.8906 26.4906 18.4575 28.8575C18.1871 29.1205 17.9168 29.3835 17.6464 29.6464C17.527 29.7627 17.4075 29.8789 17.288 29.9951C17.527 30.2341 17.7659 30.473 18.0049 30.712C18.1211 30.5925 18.2373 30.473 18.3536 30.3536C18.6165 30.0832 18.8795 29.8129 19.1425 29.5425C21.5094 27.1094 23.8762 24.6762 26.2431 22.2431L26.486 21.9933L26.2431 21.7569C23.8099 19.3901 21.3768 17.0232 18.9436 14.6564C18.6733 14.3934 18.4029 14.1304 18.1326 13.8674Z" fill="currentColor"/>' +
              '<path d="M18.3536 13.6464C18.2373 13.527 18.1211 13.4075 18.0049 13.288C17.7659 13.527 17.527 13.7659 17.288 14.0049C17.4075 14.1211 17.527 14.2373 17.6464 14.3536C17.9168 14.6165 18.1871 14.8795 18.4575 15.1425C20.8906 17.5094 23.3238 19.8762 25.7569 22.2431V21.7569C23.3901 24.1901 21.0232 26.6232 18.6564 29.0564C18.3934 29.3267 18.1304 29.5971 17.8674 29.8674C17.8244 29.9116 17.7814 29.9558 17.7385 30C17.8256 30.0872 17.9128 30.1744 18 30.2615C18.0442 30.2186 18.0884 30.1756 18.1326 30.1326C18.4029 29.8696 18.6733 29.6066 18.9436 29.3436C21.3768 26.9768 23.8099 24.6099 26.2431 22.2431L26.486 21.9933L26.2431 21.7569C23.8762 19.3238 21.5094 16.8906 19.1425 14.4575C18.8795 14.1871 18.6165 13.9168 18.3536 13.6464Z" fill="currentColor"/>' +
            '</svg>';
            var prev = document.createElement('button');
            prev.type = 'button';
            prev.className = 'bp-qd-gallery-nav bp-qd-gallery-nav--prev';
            prev.setAttribute('aria-label', 'Previous image');
            prev.innerHTML = chevronSvg;
            var next = document.createElement('button');
            next.type = 'button';
            next.className = 'bp-qd-gallery-nav bp-qd-gallery-nav--next';
            next.setAttribute('aria-label', 'Next image');
            next.innerHTML = chevronSvg;
            gallery.appendChild(prev);
            gallery.appendChild(next);

            var scrollByOne = function (dir) {
              var slide = rail.querySelector('.bp-pdp-gallery__slide');
              if (!slide) return;
              var step = slide.getBoundingClientRect().width;
              rail.scrollBy({ left: step * dir, behavior: 'smooth' });
            };
            var updateDisabled = function () {
              var scrollLeft = rail.scrollLeft;
              var maxScroll = rail.scrollWidth - rail.clientWidth;
              prev.disabled = scrollLeft <= 1;
              next.disabled = scrollLeft >= maxScroll - 1;
            };
            prev.addEventListener('click', function () { scrollByOne(-1); });
            next.addEventListener('click', function () { scrollByOne(1); });
            rail.addEventListener('scroll', updateDisabled, { passive: true });
            requestAnimationFrame(updateDisabled);
          }
        }

        /* 1b. Title → wrap in a link to the PDP. Can't embed the URL
              via the shared "text_xrnftG" block's dynamic-source text
              (templates/product.json) — Shopify's dynamic-source type
              check rejects a `product.url` (type URL) binding inside a
              `text`-type setting. Source the URL from the product
              form's own data-product-url instead (blocks/buy-buttons
              .liquid: <product-form-component data-product-url="…">),
              which is already present in the same morphed content. */
        var titleHeading = scope.querySelector('h1:not([data-bp-qd-placed])');
        var titleFormEl = scope.querySelector('product-form-component[data-product-url]');
        if (titleHeading && titleFormEl) {
          titleHeading.setAttribute('data-bp-qd-placed', '');
          var titleLink = document.createElement('a');
          titleLink.href = titleFormEl.getAttribute('data-product-url');
          while (titleHeading.firstChild) {
            titleLink.appendChild(titleHeading.firstChild);
          }
          titleHeading.appendChild(titleLink);
        }

        /* 2. Buy-buttons span → cta-slot, wrapped in an atc-row so we
              can place the heart inline next to the ATC button.
              Newer Horizon versions no longer wrap in .buy-buttons-block —
              the whole form lives directly under <product-form-component>.
              Fall back to that when the older wrapper isn't found. */
        var buyBlock = scope.querySelector('.buy-buttons-block:not([data-bp-qd-placed])') ||
                       scope.querySelector('product-form-component:not([data-bp-qd-placed])');
        if (buyBlock) {
          buyBlock.setAttribute('data-bp-qd-placed', '');

          /* Wrap the existing .product-form-buttons in an atc-row
             so we can flexbox the heart in alongside ATC. */
          var atcRow = document.createElement('div');
          atcRow.className = 'bp-qd__atc-row';
          var formButtons = buyBlock.querySelector('.product-form-buttons');
          if (formButtons) {
            var atcWrap = document.createElement('div');
            atcWrap.style.flex = '1 1 auto';
            atcWrap.style.minWidth = '0';
            /* Pull the ATC out of formButtons (leave Shop Pay / qty
               inside formButtons; we hide those via CSS but keep
               them in the DOM so Horizon's variant logic still
               finds them). */
            var atc = formButtons.querySelector('add-to-cart-component, button[name="add"]');
            if (atc) {
              /* If ATC is wrapped in a <span style="--add-to-cart-font-case: ;">, move the wrapper. */
              var atcParent = atc.closest('span') && atc.closest('span') !== formButtons ? atc.closest('span') : atc;
              atcWrap.appendChild(atcParent);
            }
            atcRow.appendChild(atcWrap);
            formButtons.insertBefore(atcRow, formButtons.firstChild);
          }

          ctaSlot.insertBefore(buyBlock, ctaSlot.firstChild);
        }

        /* 3. Save-for-later heart — leave it in place. As of the PDP
              gallery overlay (blocks/bp-pdp-media-gallery.liquid), the
              heart lives inside the .bp-pdp-gallery__first-cell so it
              sits on top of the first product image. The drawer used
              to reparent it into the cta-row alongside ATC; that's no
              longer the desired UX — the heart should stay anchored
              to the image just like on the PDP. We still flag it
              `--placed` to suppress any legacy reparent IIFE on the
              old standalone bp-pdp-save-for-later block (currently
              orphan but kept for re-use). */
        var heart = scope.querySelector('.bp-pdp-save-later:not([data-bp-qd-placed])');
        if (heart) {
          heart.setAttribute('data-bp-qd-placed', '');
          heart.classList.add('bp-pdp-save-later--placed');
        }

        /* 4. ATC label → "Add to bag" per Figma. The button text is
              the deepest <span> inside .add-to-cart-text__content
              (set by snippets/add-to-cart-button.liquid → locale
              "Add to cart"). Horizon re-morphs the entire ATC button
              on every variant change (assets/product-form.js:673),
              so a one-time swap here would revert. Attach a
              MutationObserver to the cta-slot that re-applies the
              swap whenever the text mutates. Idempotent via the
              `_bpBagObserver` flag on the slot. */
        if (!ctaSlot._bpBagObserver) {
          var swapBagLabel = function () {
            ctaSlot.querySelectorAll('.add-to-cart-text__content span span').forEach(function (el) {
              if (!el.children.length && el.textContent.trim() === 'Add to cart') {
                el.textContent = 'Add to bag';
              }
            });
          };
          swapBagLabel();
          ctaSlot._bpBagObserver = new MutationObserver(swapBagLabel);
          ctaSlot._bpBagObserver.observe(ctaSlot, {
            childList: true,
            subtree: true,
            characterData: true
          });
        }
      }

      /* =============================================================
         YOTPO — strip "already rendered" markers + poke the SDK so
         it re-hydrates the morphed widget container.
         ============================================================= */
      function hydrateYotpoWidgets(scope) {
        var widgets = scope.querySelectorAll('.yotpo-widget-instance:not([data-bp-yotpo-rehydrated])');
        if (!widgets.length) return;
        widgets.forEach(function (w) {
          w.setAttribute('data-bp-yotpo-rehydrated', '');
          w.removeAttribute('data-yotpo-element-loaded');
          w.removeAttribute('data-yotpo-widget-uuid');
          w.innerHTML = '';
        });

        // Shield the MAIN-PAGE Yotpo widgets (esp. the PDP reviews widget in
        // #bp-pdp-reviews) from the global init below. initWidgets() /
        // refreshWidgets() re-scan the whole document, and re-rendering the
        // already-loaded reviews widget drops it back into its collapsed,
        // internally-scrolling loading state that never re-expands — so after
        // opening the quick-add drawer from How-to-Wear-It the reviews section
        // shows inside a scroll box (QA: Adrienne). Detach the non-drawer
        // widgets for the duration of the scan, then restore the fully-rendered
        // nodes untouched on the next frame (the SDK only acts on what it finds
        // during the synchronous scan).
        var held = [];
        document.querySelectorAll('.yotpo-widget-instance').forEach(function (w) {
          if (scope.contains(w) || !w.parentNode) return;
          var ph = document.createComment('bp-yotpo-hold');
          w.parentNode.replaceChild(ph, w);
          held.push({ node: w, ph: ph });
        });

        // Call only the FIRST available API — don't stack the legacy
        // refreshWidgets() on top of initWidgets() (extra full re-scans).
        try {
          if (window.yotpoWidgetsContainer && typeof window.yotpoWidgetsContainer.initWidgets === 'function') {
            window.yotpoWidgetsContainer.initWidgets();
          } else if (window.YotpoApi && typeof window.YotpoApi.refreshWidgets === 'function') {
            window.YotpoApi.refreshWidgets();
          } else if (window.Yotpo && window.Yotpo.API && typeof window.Yotpo.API.refreshWidgets === 'function') {
            window.Yotpo.API.refreshWidgets();
          } else if (window.yotpo && typeof window.yotpo.refreshWidgets === 'function') {
            window.yotpo.refreshWidgets();
          }
        } catch (_) {}

        if (held.length) {
          requestAnimationFrame(function () {
            held.forEach(function (h) {
              if (h.ph.parentNode) h.ph.parentNode.replaceChild(h.node, h.ph);
            });
          });
        }
      }

      /* =============================================================
         NOTIFY ME — toggle .bp-notify-trigger + hide ATC / Shop Pay
         based on current variant availability table.
         ============================================================= */
      function hydrateNotifyMe(scope) {
        var trigger = scope.querySelector('[data-bp-notify-trigger]');
        if (!trigger) return;

        var productId = trigger.dataset.sectionProduct;
        var jsonEl = scope.querySelector('#bp-notify-variants-' + productId);
        if (!jsonEl) return;
        var table;
        try { table = JSON.parse(jsonEl.textContent || '{}'); } catch (e) { return; }

        /* CTA selectors live across the morphed body AND the
           redistribute()-moved cta-slot. Use the document so we
           catch both. */
        var ctaSelectors = '.buy-buttons, button[name="add"], add-to-cart-component, accelerated-checkout-component, .accelerated-checkout-block, [data-shop-pay-button], .bp-qd__atc-row';
        function setVisible(vid) {
          // The table (from blocks/bp-notify-me-button.liquid) is a RICH
          // per-variant object { available, fullPrice, gates:{currentInv,
          // inboundInv} } — NOT a flat boolean. The old code read
          // `table[vid] !== false`, and an object is never === false, so it
          // ALWAYS thought the variant was available → Add-to-Cart showed on
          // sold-out variants and clicking it threw a Shopify error (QA 7/27).
          // Use the exact same gate as the PDP: only a sold-out, full-price
          // variant with no on-hand and no inbound restock gets Notify Me.
          var entry = table[String(vid)] || {};
          var available = entry.available !== false;
          var gates = entry.gates || {};
          var currentInv = Number(gates.currentInv) || 0;
          var inboundInv = Number(gates.inboundInv) || 0;
          var restockEligible = !available && !!entry.fullPrice && currentInv <= 0 && inboundInv <= 0;
          trigger.style.display = restockEligible ? '' : 'none';
          document.querySelectorAll(ctaSelectors).forEach(function (el) {
            el.style.display = restockEligible ? 'none' : '';
          });
          var btn = trigger.querySelector('[data-bp-notify-open]');
          if (btn) btn.setAttribute('data-bp-notify-variant-id', String(vid));
          trigger.dataset.bpCurrentVariant = String(vid);
          window.bpCurrentVariantId = vid;
        }

        // Quick-add doesn't write ?variant= to the URL, so read the picked
        // variant from the checked radio's data-variant-id first — the
        // browser updates `checked` synchronously before any 'change'
        // handler runs, so this sidesteps any ordering issue against
        // requireDrawerSize's own handler — then the hidden id input, then
        // whatever this trigger last recorded.
        function currentVid() {
          var r = scope.querySelector('variant-picker input[type="radio"]:checked[data-variant-id]');
          if (r && r.dataset.variantId) return r.dataset.variantId;
          var idInput = scope.querySelector('input[name="id"]') ||
            document.querySelector('#quick-add-modal-content input[name="id"], .bp-qd__cta-slot input[name="id"]');
          if (idInput && idInput.value) return idInput.value;
          return trigger.dataset.bpCurrentVariant || null;
        }

        var initial = parseInt(trigger.dataset.bpCurrentVariant, 10) || null;
        if (initial) setVisible(initial);

        // Rebind the document variant listeners with THIS render's closure —
        // same fix as hydratePreorderLine's identical problem: reopening the
        // drawer on another product re-runs hydrate, and without removing
        // the previous listener, stale closures bound to the OLD product's
        // table pile up on document and can win the race against the fresh
        // one on every variant:update. That's why Notify Me only ever worked
        // for whichever product was opened first in a session, then silently
        // stopped reacting for every product after (QA 7/27).
        var onVariantChange = function (e) {
          var vid = (e && e.detail && (e.detail.resource && e.detail.resource.id || e.detail.variant && e.detail.variant.id || e.detail.id));
          if (vid) setVisible(vid);
        };
        if (scope._bpNotifyOnChange) {
          document.removeEventListener('variant:update', scope._bpNotifyOnChange);
          document.removeEventListener('variant:change', scope._bpNotifyOnChange);
        }
        scope._bpNotifyOnChange = onVariantChange;
        document.addEventListener('variant:update', onVariantChange);
        document.addEventListener('variant:change', onVariantChange);

        // variant:update only fires after Horizon's scoped section re-fetch
        // resolves (a real network round trip) — also recompute
        // synchronously on any radio change in the picker (the same signal
        // requireDrawerSize keys off), so the swap doesn't lag behind the
        // fetch. Bind once; always call the LATEST setVisible via the
        // scope-stored reference (mirrors hydratePreorderLine) so a later
        // product's hydrate doesn't leave this closure stale either.
        scope._bpNotifySetVisible = setVisible;
        scope._bpNotifyCurrentVid = currentVid;
        if (!scope._bpNotifyChangeWired) {
          scope._bpNotifyChangeWired = true;
          scope.addEventListener('change', function (e) {
            var t = e.target;
            if (t && t.type === 'radio' && t.closest && t.closest('fieldset.variant-option')) {
              setTimeout(function () {
                if (!scope._bpNotifySetVisible || !scope._bpNotifyCurrentVid) return;
                var vid = scope._bpNotifyCurrentVid();
                if (vid) scope._bpNotifySetVisible(vid);
              }, 0);
            }
          }, { passive: true });
        }
      }

      /* =============================================================
         PREORDER LINE — reparent into the variant-picker size legend
         + compute the +13-day weekend-bumped ship date per variant.
         ============================================================= */
      function hydratePreorderLine(scope) {
        if (scope._bpPreorderScheduled) return;
        scope._bpPreorderScheduled = true;
        var attempts = 0;
        var MAX = 30;
        (function tryHydrate() {
          attempts++;
          var line = scope.querySelector('.bp-preorder-line');
          var row = line && ensureVariantHeaderRow(scope);
          var productId = line && line.dataset.sectionProduct;
          var jsonEl = productId && scope.querySelector('#bp-preorder-variants-' + productId);
          if (!line || !row || !jsonEl) {
            if (attempts < MAX) return setTimeout(tryHydrate, 100);
            scope._bpPreorderScheduled = false; return;
          }
          var data;
          try { data = JSON.parse(jsonEl.textContent || '{}'); }
          catch (e) { scope._bpPreorderScheduled = false; return; }

          var variants = data.variants || {};
          var originalOverride = data._originalOverride || '';
          var dateEl = line.querySelector('[data-bp-preorder-date]');

          line.setAttribute('data-bp-preorder-hydrated', '');
          log('hydratePreorderLine: placed in variant-header row on attempt ' + attempts);

          /* Re-attach the line into the variant-picker header row on EVERY
             update — not just once. Horizon re-morphs the variant-picker
             fieldset on each size/variant change (variant-picker.js), and
             morph.js removes children absent from the fresh markup, including
             this line (which we move INTO the fieldset). The PDP block
             survives because its own inline script re-runs relocateToLegend on
             variant:update; in the drawer that script never executes (morphed
             <script> tags don't run), so placing once meant the line vanished
             the instant a size was picked — which is exactly when it should
             appear. Holds the persistent `line` node and re-appends it,
             evicting any stale duplicate a re-fetch may have injected. */
          function place() {
            var r = ensureVariantHeaderRow(scope);
            if (!r) return;
            r.querySelectorAll('.bp-preorder-line').forEach(function (el) { if (el !== line) el.remove(); });
            if (line.parentNode !== r) r.appendChild(line);
          }
          place();

          /* Gate + date math reuse the shared window.bpPreorder helper
             (assets/bp-preorder-dates.js) — the Atlas-verbatim port the PDP
             and cart also use — so quick view shows an IDENTICAL date and
             applies the SAME display gate. theme.liquid now loads that helper
             (deferred) on every template the drawer can open from. The local
             fallbacks below are only used if the helper somehow hasn't loaded;
             they mirror it exactly, including the crucial detail that Atlas
             adds NO +13-day offset — the previous local copy did, showing a
             date ~2 weeks too late (and the old gate wrongly hid any variant
             with on-hand inventory > 0). */
          var bp = window.bpPreorder;
          function localShouldShow(entry) {
            if (!entry) return false;
            if (!entry.switchActive) return false;
            if (!entry.dcDate || entry.dcDate === '0') return false;
            if (!entry.isPreOrder) return false;
            if (entry.inboundInv <= 0) return false;
            if (entry.currentInv > entry.inboundInv) return false;
            if (entry.currentInv - 1 > entry.inboundInv) return false;
            return true;
          }
          function localFormatDate(raw) {
            if (originalOverride) return originalOverride;
            if (!raw || raw === '0') return null;
            var d = new Date(raw);
            if (isNaN(d.getTime()) || d < new Date()) return null;
            var day = d.getDay();
            if (day === 6) d.setDate(d.getDate() + 2);
            else if (day === 0) d.setDate(d.getDate() + 1);
            try { return d.toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: '2-digit' }); }
            catch (_) { return d.toDateString(); }
          }
          function shouldShow(entry) { return (bp && bp.shouldShow) ? bp.shouldShow(entry) : localShouldShow(entry); }
          function formatDate(raw) { return (bp && bp.formatDate) ? bp.formatDate(raw, originalOverride) : localFormatDate(raw); }

          function dlg() {
            return scope.closest('quick-add-dialog') || document.getElementById('quick-add-dialog') || document;
          }

          /* Hidden line-item property on the redistributed add-to-cart form,
             so adding to bag FROM quick view carries `_expected_ship_date`
             (same key as blocks/bp-preorder-line.liquid + Atlas's
             updateLineItemProperties). The block's own inline <script> that
             normally syncs this never executes in the drawer — morph.js
             injects the block's markup via innerHTML, which does NOT run
             injected <script> tags — so without this the cart has no
             ship-date LIP fallback and the order data omits it entirely.
             Disabled/blank when there's no date so FormData drops it. */
          var LIP_NAME = 'properties[_expected_ship_date]';
          function ensureLip() {
            var form = dlg().querySelector('form[action$="/cart/add"]');
            if (!form) return null;
            var input = form.querySelector('input[name="' + LIP_NAME + '"]');
            if (!input) {
              input = document.createElement('input');
              input.type = 'hidden';
              input.name = LIP_NAME;
              input.setAttribute('data-bp-expected-ship-lip', '');
              input.disabled = true;
              form.appendChild(input);
            }
            return input;
          }
          function syncLip(value) {
            var input = ensureLip();
            if (!input) return;
            if (value) { input.value = value; input.disabled = false; }
            else { input.value = ''; input.disabled = true; }
          }

          /* A size must be actively chosen before we commit to a ship date —
             it's variant-specific. Mirror requireDrawerSize: any multi-value
             option fieldset with no checked radio means "not chosen yet". */
          function sizeSelected() {
            var fs = scope.querySelectorAll('variant-picker fieldset.variant-option');
            for (var i = 0; i < fs.length; i++) {
              if (fs[i].querySelectorAll('input[type="radio"]').length <= 1) continue;
              if (!fs[i].querySelector('input[type="radio"]:checked')) return false;
            }
            return true;
          }
          /* Quick-add doesn't write ?variant= to the URL, so read the picked
             variant from the checked radio's data-variant-id first (the field
             requireDrawerSize.syncPickedVariant also uses), then the form's
             hidden id input (moved out to the cta-slot), then the global. */
          function currentVid() {
            var r = scope.querySelector('variant-picker input[type="radio"]:checked[data-variant-id]');
            if (r && r.dataset.variantId) return r.dataset.variantId;
            var idInput = dlg().querySelector('form[action$="/cart/add"] input[name="id"]') || scope.querySelector('input[name="id"]');
            if (idInput && idInput.value) return idInput.value;
            return window.bpCurrentVariantId || null;
          }

          function update(vid) {
            place();
            vid = vid || currentVid();
            if (!vid || !sizeSelected()) { line.hidden = true; syncLip(''); return; }
            var entry = variants[String(vid)];
            if (!shouldShow(entry)) { line.hidden = true; syncLip(''); return; }
            var formatted = formatDate(entry.dcDate);
            if (!formatted) { line.hidden = true; syncLip(''); return; }
            if (dateEl) dateEl.textContent = formatted;
            line.hidden = false;
            syncLip(formatted);
          }

          update();

          /* Rebind the document variant listeners with THIS render's closure,
             removing the previous product's (reopening the drawer on another
             product re-runs hydrate; without the swap, stale closures bound to
             the old variants[] would accumulate on document). */
          var onChange = function (e) {
            var vid = (e && e.detail && (e.detail.resource && e.detail.resource.id || e.detail.variant && e.detail.variant.id || e.detail.id));
            update(vid);
          };
          if (scope._bpPreorderOnChange) {
            document.removeEventListener('variant:update', scope._bpPreorderOnChange);
            document.removeEventListener('variant:change', scope._bpPreorderOnChange);
          }
          scope._bpPreorderOnChange = onChange;
          document.addEventListener('variant:update', onChange);
          document.addEventListener('variant:change', onChange);

          /* Picking a size in quick-add may not dispatch variant:update, so
             also recompute on any radio change in the picker (the same signal
             requireDrawerSize keys off). Bind once; always call the LATEST
             update via the scope-stored reference so it uses fresh data. */
          scope._bpPreorderUpdate = update;
          if (!scope._bpPreorderChangeWired) {
            scope._bpPreorderChangeWired = true;
            scope.addEventListener('change', function (e) {
              var t = e.target;
              if (t && t.type === 'radio' && t.closest && t.closest('fieldset.variant-option')) {
                setTimeout(function () { if (scope._bpPreorderUpdate) scope._bpPreorderUpdate(); }, 0);
              }
            }, { passive: true });
          }

          scope._bpPreorderScheduled = false;
        })();
      }

      /* =============================================================
         FINAL SALE — reparent into the variant-picker size legend.
         The block has no JS so the reparent IS the hydration.

         Don't flag as hydrated until the legend exists AND the move
         lands. The MutationObserver fires many times during morph,
         and the first fire often arrives before variant-picker
         children have rendered. Flagging too early would exclude the
         element from later retries → label silently never shows.
         ============================================================= */
      /* =============================================================
         TRUE FIT — bp-truefit-loader.liquid (rendered globally in
         <head>) ships tf-integration.js, but that script only binds
         .tfc-fitrec-product elements present in the DOM at initial
         page load. On the homepage / collection / article, there ARE
         no .tfc-fitrec-product mounts at page load — so TF doesn't
         bind anything. When morph injects the widget into the drawer,
         TF still doesn't know it exists; the click handler's
         tfcapi('triggerOpen') then warns "widget isn't rendered yet".

         tfcapi('calculate') triggers TF to re-scan the document and
         bind any new .tfc-fitrec-product elements. Call it once per
         morph, retry briefly so even a slow tf-integration.js load
         catches up.
         ============================================================= */
      function hydrateTrueFit(scope) {
        var mount = scope.querySelector('.tfc-fitrec-product:not([data-bp-tf-hydrated])');
        if (!mount) return;
        mount.setAttribute('data-bp-tf-hydrated', '');
        var attempts = 0;
        (function ping() {
          attempts++;
          if (typeof window.tfcapi === 'function') {
            try { window.tfcapi('calculate'); } catch (_) {}
            log('TrueFit: calculate ping on attempt ' + attempts);
            return;
          }
          if (attempts < 20) setTimeout(ping, 250);  // wait up to 5s for tf-integration.js
          else log('TrueFit: tfcapi never appeared (loader blocked?)');
        })();
      }

      /* Wrap the variant-picker's legend + (final-sale / preorder-line)
         in a single normal <div> so they lay out on one row. <legend>
         has stubborn browser-default rendering that ignores `display`
         in some engines and clips appended children inside the
         fieldset border. By moving the legend AND the meta element
         into a sibling div before the labels, we get plain flexbox
         on a plain element — no quirks. */
      function ensureVariantHeaderRow(scope) {
        var fieldset = scope.querySelector('variant-picker fieldset.variant-option');
        if (!fieldset) return null;
        var legend = fieldset.querySelector(':scope > legend');
        if (!legend) return null;
        var row = fieldset.querySelector(':scope > .bp-qd__variant-header');
        if (!row) {
          row = document.createElement('div');
          row.className = 'bp-qd__variant-header';
          fieldset.insertBefore(row, legend);
          row.appendChild(legend);
        }
        return row;
      }

      function hydrateFinalSale(scope) {
        // BP: hydration into the variant-header row is disabled — the
        // standalone Sales-Red bar from blocks/bp-final-sale.liquid is
        // now the canonical visual (matches PDP). We still mark the
        // node hydrated so the legacy fallback "out-of-legend" CSS
        // rule (.bp-final-sale:not([data-bp-final-sale-hydrated]))
        // doesn't kick in and override the block stylesheet.
        var fs = document.querySelector('.bp-qd__body .bp-final-sale, .bp-qd__cta-slot .bp-final-sale, dialog.bp-qd .bp-final-sale');
        if (fs) fs.setAttribute('data-bp-final-sale-hydrated', '');
      }

      /* =============================================================
         COLOR SIBLINGS — hover label-swap + INV5 fetch fallback.
         ============================================================= */
      function hydrateColorSiblings(scope) {
        var roots = scope.querySelectorAll('[data-bp-colors]:not([data-bp-hydrated])');
        roots.forEach(function (root) {
          root.setAttribute('data-bp-hydrated', '');
          var isInv5 = root.hasAttribute('data-bp-inv5-handle');

          /* INV5/INV7 sibling families: run the SAME canonical union-crawl +
             ordering the PDP uses (shared window.bpColorSiblings.hydrateRoot),
             so the swatch SET + ORDER is identical regardless of which colour
             opened the drawer — no more per-colour drift. Previously the drawer
             ran its own seed-only fetch here (this product's own, drifting
             bp_stylecolorlist), which is why swatches appeared/disappeared as
             the colour changed. The morphed block's own inline crawl <script>
             never executes (Horizon's morph doesn't run theme-block inline
             scripts — assets/morph.js only recreates .shopify-app-block
             script[src]), so the drawer must invoke the shared hydrator itself.
             hydrateRoot handles hover-label wiring, swatch crops, discount
             badges, availability + go-live filtering, and canonical ordering. */
          if (isInv5) {
            if (window.bpColorSiblings && window.bpColorSiblings.hydrateRoot) {
              window.bpColorSiblings.hydrateRoot(root);
            }
            return;
          }

          /* Non-INV variant colours are rendered server-side (in stock only,
             not --pending) — nothing to fetch, just wire the hover-label
             preview so the label reflects the hovered colour. */
          var labelName = root.querySelector('[data-bp-active-color]');
          var initialName = labelName ? labelName.textContent : '';
          var items = Array.prototype.slice.call(root.querySelectorAll('.bp-colors__item:not(.is-active)'));
          items.forEach(function (item) {
            item.addEventListener('mouseenter', function () {
              if (labelName && item.dataset.bpColorName) labelName.textContent = item.dataset.bpColorName;
            });
            item.addEventListener('mouseleave', function () {
              if (labelName) labelName.textContent = initialName;
            });
          });
        });
      }

      /* =============================================================
         Color-sibling swap INSIDE the drawer.

         BP colours are separate products, so bp-color-siblings emits
         <a href="/products/{sibling}"> swatches. Inside the quick-view
         drawer those must reload the drawer with the sibling — not
         navigate the page (bp-pdp-swap is told to ignore drawer
         anchors) and not leave a stale drawer open (QA 7/16).

         We fetch the sibling PDP, lift its [data-product-grid-content]
         (the same fragment the drawer morphs on open), and drop it into
         #quick-add-modal-content. That childList mutation fires the
         morph observer above, which re-runs redistribute() + every
         hydrator and clears the loading state. No URL/history change —
         it's an overlay, closing it should return to the origin page.
         ============================================================= */
      /* Snapshot the shopper's non-colour selection (Size) so we can
         re-apply it on the sibling. */
      function captureDrawerSize(scope) {
        try {
          var checked = scope.querySelector('variant-picker input[type="radio"]:checked');
          if (!checked) return null;
          var fs = checked.closest('fieldset');
          var pfx = fs && fs.querySelector('.variant-option__swatch-prefix');
          var name = pfx ? pfx.textContent.trim() : (checked.name || '');
          var lc = name.toLowerCase();
          if (lc === 'color' || lc === 'colour') return null;
          return { option: name, value: checked.value };
        } catch (_) { return null; }
      }

      function restoreDrawerSize(scope, sel) {
        if (!sel) return;
        try {
          var fieldsets = scope.querySelectorAll('variant-picker fieldset.variant-option');
          for (var i = 0; i < fieldsets.length; i++) {
            var pfx = fieldsets[i].querySelector('.variant-option__swatch-prefix');
            var name = pfx ? pfx.textContent.trim() : '';
            if (!name || name.toLowerCase() !== sel.option.toLowerCase()) continue;
            var radios = fieldsets[i].querySelectorAll('input[type="radio"]');
            for (var j = 0; j < radios.length; j++) {
              if (radios[j].value === sel.value) {
                if (!radios[j].checked) {
                  radios[j].checked = true;
                  radios[j].dispatchEvent(new Event('input', { bubbles: true }));
                  radios[j].dispatchEvent(new Event('change', { bubbles: true }));
                }
                return;
              }
            }
          }
        } catch (_) {}
      }

      function loadSiblingIntoDrawer(url) {
        var modalContent = getModalContent();
        if (!modalContent || !url) return;

        /* Capture Size BEFORE we wipe the current content. */
        var keepSize = captureDrawerSize(modalContent);

        document.body.classList.add('bp-drawer-loading');

        var mediaSlot = getMediaSlot();
        if (mediaSlot) mediaSlot.innerHTML = '';
        var ctaSlot = getCtaSlot();
        if (ctaSlot) {
          ctaSlot.querySelectorAll('[data-bp-qd-placed]').forEach(function (el) { el.remove(); });
        }
        modalContent._bpFinalSaleScheduled = false;
        modalContent._bpPreorderScheduled = false;
        modalContent._bpListedBlocks = false;
        modalContent._bpUserPicked = false;

        var clean = url.split('#')[0];

        /* Inject the grid's CHILDREN (innerHTML), not the grid wrapper —
           this mirrors Horizon's morph(modalContent, productGrid), which
           flattens the grid into the flex-column body. Injecting the
           wrapper (outerHTML) kept the 2-col product grid, squishing
           content into one column (QA 7/16). The childList mutation fires
           the morph observer above, which re-runs redistribute() + every
           hydrator. */
        function applyGrid(gridEl) {
          /* Crossfade the new colour in instead of hard-repainting the
             whole panel: preload the incoming primary image, drop
             modalContent to opacity 0, swap, then fade back to 1. Reads
             as a swatch colour change rather than a full reload. */
          var primary = gridEl.querySelector('.bp-pdp-gallery__img, .product-media__image, img');
          var url = primary
            ? (primary.getAttribute('src') || (primary.getAttribute('srcset') || '').trim().split(' ')[0] || '')
            : '';
          var swap = function () {
            modalContent.style.transition = 'opacity 0.18s ease';
            modalContent.style.opacity = '0';
            requestAnimationFrame(function () {
              modalContent.innerHTML = gridEl.innerHTML;
              requestAnimationFrame(function () { modalContent.style.opacity = '1'; });
              /* Re-apply the shopper's Size on the sibling once the new
                 <variant-picker> has upgraded. */
              if (keepSize) {
                requestAnimationFrame(function () { restoreDrawerSize(modalContent, keepSize); });
              }
            });
          };
          if (url) {
            var done = false;
            var go = function () { if (done) return; done = true; swap(); };
            var im = new Image();
            im.onload = go;
            im.onerror = go;
            im.src = url;
            setTimeout(go, 400); // never block the swap on a slow image
          } else {
            swap();
          }
        }

        /* BP: fetch only the product `main` section (id learned by
           quick-add.js) instead of the whole sibling PDP, and reuse the
           shared drawer cache warmed by prefetch. */
        var mainId = window.__bpPdpMainSectionId;
        if (!mainId) { try { mainId = sessionStorage.getItem('bpPdpMainSectionId'); } catch (e) {} }
        var fetchUrl = mainId
          ? clean + (clean.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + encodeURIComponent(mainId)
          : clean;
        var cache = window.__bpDrawerCache;
        var cachedGrid = (cache && cache.get) ? cache.get(fetchUrl) : null;

        if (cachedGrid) {
          applyGrid(cachedGrid.cloneNode(true));
          return;
        }

        function fetchGrid(u) {
          return fetch(u, { credentials: 'same-origin', headers: { 'Accept': 'text/html' } })
            .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); })
            .then(function (html) {
              var doc = new DOMParser().parseFromString(html, 'text/html');
              var fresh = doc.querySelector('[data-product-grid-content]');
              if (!fresh) throw new Error('no [data-product-grid-content] in ' + u);
              return fresh;
            });
        }

        fetchGrid(fetchUrl)
          .then(function (fresh) {
            if (cache && cache.set) cache.set(fetchUrl, fresh.cloneNode(true));
            applyGrid(fresh);
          })
          .catch(function (err) {
            /* BP: section fetch may 404 if the learned id drifted — drop
               it and retry the full sibling page once. */
            if (fetchUrl !== clean) {
              window.__bpPdpMainSectionId = null;
              try { sessionStorage.removeItem('bpPdpMainSectionId'); } catch (e) {}
              fetchGrid(clean)
                .then(applyGrid)
                .catch(function (err2) { clearLoading(); log('sibling load failed', err2); });
            } else {
              clearLoading();
              log('sibling load failed', err);
            }
          });

        setTimeout(clearLoading, 6000);
      }

      document.addEventListener('click', function (e) {
        var anchor = e.target.closest && e.target.closest('a[href]');
        if (!anchor) return;
        var modalContent = getModalContent();
        if (!modalContent || !modalContent.contains(anchor)) return;
        if (!anchor.closest('[data-bp-colors]')) return;
        var href = anchor.getAttribute('href') || '';
        if (!/\/products\//.test(href)) return;
        var dialog = getDialog();
        if (!dialog || !dialog.open) return;
        e.preventDefault();
        e.stopPropagation();
        loadSiblingIntoDrawer(href);
      }, true);

      /* =============================================================
         Size Chart click handler — registered once on the document so
         it fires for the morphed button inside the drawer. There is no
         PDP-side JS in bp-size-chart-link.liquid, and even if there
         were it only loads with that block, so on the homepage /
         collection / article it wouldn't be bound.

         - [data-bp-size-chart-open] → open #bp-size-chart-drawer
           (rendered globally from theme.liquid since the BP: ungate
           on bp-size-chart-drawer.liquid).

         NOTE: the old TrueFit [data-bp-fma-trigger] handler was
         removed. Per BP (7/20) the NATIVE TrueFit widget is used, not
         a custom "What's my size?" CTA — its own trigger lives inside
         the inline .tfc-fitrec-product bar.
         ============================================================= */
      document.addEventListener('click', function (e) {
        var sc = e.target.closest('[data-bp-size-chart-open]');
        if (sc) {
          e.preventDefault();
          var dialog = document.getElementById('bp-size-chart-drawer');
          if (!dialog) { log('size chart: dialog not in DOM'); return; }
          try {
            if (typeof dialog.showModal === 'function') dialog.showModal();
            else dialog.setAttribute('open', '');
          } catch (err) {
            dialog.setAttribute('open', '');
          }
          document.body.classList.add('bp-size-chart-open');
          return;
        }
      });

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', attachWatchers);
      } else {
        attachWatchers();
      }
    })();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bp-search-results"]) return;
  try {
    
class BpSearchResults extends HTMLElement {
  connectedCallback() {
    this.grid = this.querySelector('[data-grid]');
    if (!this.grid) return;

    this.query = (new URLSearchParams(location.search).get('q') || this.dataset.searchQuery || '').trim();

    this.bindFilterDrawer();

    // No query → don't fire a query-less BR call; drop the skeleton and prompt.
    if (!this.query) {
      this.classList.add('bp-br-ready');
      const empty = this.querySelector('[data-sr-empty]');
      if (empty) { empty.textContent = 'Enter a search term to see results.'; empty.hidden = false; }
      return;
    }

    this.initBloomreach();
    this.trackSearch();

    // GA4 view_item_list. Search cards are ALWAYS Bloomreach-rendered async
    // (the Liquid grid ships empty), so — like bp-collection's BR path — there
    // is nothing to report on connect; a MutationObserver fires once BR paints
    // the cards, and again when a facet/sort/page swap replaces them.
    // fireViewItemList() dedupes by product id and keeps a running 0-based
    // index, so it can be called repeatedly and only reports NEW cards; a full
    // grid swap resets the index (see the method). Search-specific identity is
    // declared HERE and consumed by the shared window.bpTrack.view_item_list —
    // no forked event-building.
    const grid = this.grid;
    if (grid) {
      const obs = new MutationObserver(() => {
        clearTimeout(this._fireVilTimer);
        this._fireVilTimer = setTimeout(() => this.fireViewItemList(), 250);
      });
      obs.observe(grid, { childList: true });
      this._vilObs = obs;
    }
  }

  // Mirrors bp-collection.fireViewItemList (the DOM reader is per-section by
  // design — CLAUDE.md §9.4 lists JS dedup as a deferred follow-up), but
  // declares the SEARCH list identity: item_list_name "Search Results",
  // surface (location_id / item_list_id / event_location) "Search Experience".
  fireViewItemList() {
    if (!window.bpTrack || !window.bpTrack.view_item_list) return;
    // Read every product card in the order shown on the grid. The grid can use
    // dense flow, so DOM order may differ from visual order — sort by on-screen
    // position (row, then column) so the items[] index matches what's seen.
    let cards = Array.prototype.slice.call(this.querySelectorAll('[data-bp-track-product]'));
    if (!cards.length) return;
    const measured = cards.filter((c) => {
      const r = c.getBoundingClientRect();
      return r.width > 0 && r.height > 0;
    });
    if (measured.length) {
      cards = measured.sort((a, b) => {
        const ra = a.getBoundingClientRect();
        const rb = b.getBoundingClientRect();
        if (Math.abs(ra.top - rb.top) > 8) return ra.top - rb.top; // row
        return ra.left - rb.left;                                   // column
      });
    }

    const parsed = [];
    cards.forEach((card) => {
      try {
        const p = JSON.parse(card.getAttribute('data-bp-track-product'));
        if (p && p.id) parsed.push({ id: String(p.id), p: p });
      } catch (_) { /* skip malformed */ }
    });
    if (!parsed.length) return;

    if (!this._vilReported) { this._vilReported = new Set(); this._vilNextIndex = 0; }

    // A facet/sort/page swap replaces the WHOLE grid: if any already-reported
    // product is gone, the list changed → reset and restart the index at 0.
    // (Lazy-load only APPENDS, so reported ids all remain — no double-fire.)
    const currentIds = new Set(parsed.map((x) => x.id));
    let replaced = false;
    this._vilReported.forEach((id) => { if (!currentIds.has(id)) replaced = true; });
    if (replaced) { this._vilReported = new Set(); this._vilNextIndex = 0; }

    const fresh = parsed.filter((x) => !this._vilReported.has(x.id));
    if (!fresh.length) return; // nothing new since the last call

    const items = fresh.map(({ p }) => ({
      id:           p.id,
      title:        p.title,
      vendor:       p.vendor,
      handle:       p.handle,
      url:          p.url,
      sku:          p.sku,
      product_type: p.product_type,
      metafields: { BP_ProductAttributes: { bp_department: p.category || '' } },
      selected_variant: p.selected_variant
    }));
    // listName "Search Results" → item_list_name; listId + locationId +
    // eventLocation "Search Experience" → item_list_id / location_id /
    // event_details.event_location (matches search select_item). startIndex
    // continues the index across lazy-loaded batches. this.query →
    // event_details.search_term (the typed query).
    window.bpTrack.view_item_list(items, 'Search Results', 'Search Experience', 'Search Experience', this._vilNextIndex, 'Search Experience', this.query);
    fresh.forEach((x) => this._vilReported.add(x.id));
    this._vilNextIndex += fresh.length;
  }

  // ---- Bloomreach engine (keyword mode) --------------------------------
  initBloomreach() {
    const br = (window.shop && window.shop.br) || {};
    const cfg = {
      host:      this.dataset.brHost || br.host,
      accountId: br.accountId,
      domainKey: br.domainKey,
      searchQuery: this.query,
      viewId:    this.dataset.brViewId || '',
      perPage:   this.dataset.brPerPage,
      siteUrl:   this.dataset.brSiteUrl || (window.shop && window.shop.url) || location.origin,
      refUrl:    document.referrer || location.href,
      authKey:   br.authKey || '',
      brUid: (function () {
        var raw = (document.cookie.match(/(?:^|;\s*)_br_uid_2=([^;]+)/) || [])[1] || '';
        try { return decodeURIComponent(raw); } catch (e) { return raw; }
      })(),
      cardQbStyle: this.dataset.bpCardQbStyle || 'button',
      cardQvDest:  this.dataset.bpCardQvDest || 'drawer',
      cardQvVisD:  this.dataset.bpCardQvVisD || 'hover',
      cardQvVisM:  this.dataset.bpCardQvVisM || 'shown',
      cardSecondaryHover: true,
      contentInjection: false,
      onRender: (grid) => this.bindBagIcons(grid),
    };

    const tryInit = (left) => {
      if (window.BpBloomreach && typeof window.BpBloomreach.init === 'function') {
        window.BpBloomreach.init(this, cfg);
        return;
      }
      if (left <= 0) return;
      setTimeout(() => tryInit(left - 100), 100);
    };
    tryInit(3000);
  }

  // GA4 search event once the engine has painted the count.
  trackSearch() {
    if (!this.query) return;
    const countEl = this.querySelector('.bp-coll__count');
    const fire = (n) => { if (window.bpTrack && window.bpTrack.search) window.bpTrack.search(this.query, n); };
    if (!countEl) { fire(undefined); return; }
    const obs = new MutationObserver(() => {
      const m = (countEl.textContent || '').match(/\d[\d,]*/);
      if (m) { obs.disconnect(); fire(parseInt(m[0].replace(/,/g, ''), 10)); }
    });
    obs.observe(countEl, { childList: true, characterData: true, subtree: true });
    setTimeout(() => obs.disconnect(), 8000);
  }

  // ---- Filter drawer (open/close + pill toggle) ------------------------
  // Apply/Clear are handled by the engine (client-side refetch); the base
  // handlers below are the no-engine fallback and preserve ?q=.
  bindFilterDrawer() {
    const opener = this.querySelector('[data-bp-filter-open]');
    const drawer = this.querySelector('dialog.bp-filter-drawer');
    if (!opener || !drawer) return;

    opener.addEventListener('click', (e) => {
      e.preventDefault();
      if (drawer.open) return;
      if (typeof drawer.showModal === 'function') drawer.showModal();
      else drawer.setAttribute('open', '');
    });

    drawer.addEventListener('cancel', (e) => { e.preventDefault(); this.closeFilterDrawer(drawer); });

    drawer.addEventListener('click', (e) => {
      const pill = e.target.closest('[data-bp-pill]');
      if (pill) {
        if (pill.getAttribute('aria-disabled') === 'true') return;
        e.preventDefault(); e.stopPropagation();
        this.togglePill(pill);
        return;
      }
      if (e.target.closest('[data-bp-filter-apply]')) { e.preventDefault(); e.stopPropagation(); this.applyFilters(drawer); return; }
      if (e.target.closest('[data-bp-filter-clear]')) { e.preventDefault(); e.stopPropagation(); this.clearFilters(drawer); return; }
      if (e.target.closest('[data-bp-filter-close]')) { e.preventDefault(); e.stopPropagation(); this.closeFilterDrawer(drawer); return; }
      if (e.target === drawer) { e.preventDefault(); e.stopPropagation(); this.closeFilterDrawer(drawer); }
    });
  }

  togglePill(pill) {
    const next = !pill.classList.contains('is-active');
    pill.classList.toggle('is-active', next);
    if (next) pill.setAttribute('aria-current', 'true');
    else pill.removeAttribute('aria-current');
    this.updateFilterCount(pill.closest('[data-bp-filter]'));
  }

  updateFilterCount(detailsEl) {
    if (!detailsEl) return;
    const count = detailsEl.querySelectorAll('[data-bp-pill].is-active').length;
    const summary = detailsEl.querySelector('.bp-filter__summary');
    if (!summary) return;
    let countEl = summary.querySelector('.bp-filter__count');
    if (count > 0) {
      if (!countEl) {
        countEl = document.createElement('span');
        countEl.className = 'bp-filter__count';
        const chev = summary.querySelector('.bp-filter__chevron');
        if (chev) summary.insertBefore(countEl, chev); else summary.appendChild(countEl);
      }
      countEl.textContent = `${count} Selected`;
    } else if (countEl) {
      countEl.remove();
    }
  }

  // Fallback navigation (engine intercepts these under normal operation).
  // Always preserve the ?q= search term.
  #baseParams() {
    const params = new URLSearchParams();
    if (this.query) params.set('q', this.query);
    return params;
  }

  applyFilters(drawer) {
    const baseUrl = (drawer.dataset.collectionUrl || location.pathname).split('?')[0];
    const params = this.#baseParams();
    drawer.querySelectorAll('[data-bp-pill].is-active').forEach((pill) => {
      const key = pill.dataset.param, val = pill.dataset.value;
      if (key && val) params.append(key, val);
    });
    const priceForm = drawer.querySelector('[data-bp-price-form]');
    if (priceForm) new FormData(priceForm).forEach((v, k) => { if (v !== '' && v != null) params.append(k, v); });
    const current = new URLSearchParams(location.search);
    ['sort_by', 'per_page'].forEach((k) => { const v = current.get(k); if (v) params.set(k, v); });
    location.href = baseUrl + '?' + params.toString();
  }

  clearFilters(drawer) {
    const baseUrl = (drawer.dataset.collectionUrl || location.pathname).split('?')[0];
    const params = this.#baseParams();
    const current = new URLSearchParams(location.search);
    ['sort_by', 'per_page'].forEach((k) => { const v = current.get(k); if (v) params.set(k, v); });
    location.href = baseUrl + '?' + params.toString();
  }

  closeFilterDrawer(drawer) {
    if (drawer.dataset.bpClosing === '1' || !drawer.open) return;
    drawer.dataset.bpClosing = '1';
    drawer.classList.add('is-closing');
    const finish = () => {
      drawer.classList.remove('is-closing');
      delete drawer.dataset.bpClosing;
      try { drawer.close(); } catch (_) { drawer.removeAttribute('open'); }
    };
    let done = false;
    const onEnd = (e) => {
      if (done || (e && e.target !== drawer)) return;
      done = true;
      drawer.removeEventListener('animationend', onEnd);
      finish();
    };
    drawer.addEventListener('animationend', onEnd);
    setTimeout(() => { if (!done) onEnd(); }, 350);
  }

  // ---- Bag icons → quick-add drawer (mirrors bp-collection) -------------
  bindBagIcons(scope) {
    scope.querySelectorAll('.bp-card__quick').forEach((bag) => {
      if (bag.dataset.bpBound) return;
      bag.dataset.bpBound = '1';
      bag.addEventListener('click', (e) => {
        e.preventDefault(); e.stopPropagation();
        const card = bag.closest('.bp-card');
        if (!card) return;
        const open = () => {
          const trigger = card.querySelector('.quick-add__button--choose');
          if (!trigger) return false;
          if (typeof window.bpOpenProductDrawer === 'function') window.bpOpenProductDrawer(trigger);
          else trigger.click();
          return true;
        };
        if (open()) return;
        const handle = (card.dataset.productUrl || '').match(/\/products\/([^/?#]+)/);
        if (!handle || card.dataset.bpQaLoading === '1' || !window.BpCardHydrate) return;
        card.dataset.bpQaLoading = '1';
        window.BpCardHydrate.hydrateHandle(handle[1])
          .then((data) => { window.BpCardHydrate.applyHydration(card, data); })
          .then(() => { card.dataset.bpQaLoading = '0'; open(); })
          .catch(() => { card.dataset.bpQaLoading = '0'; });
      });
    });
  }
}

if (!customElements.get('bp-search-results')) {
  customElements.define('bp-search-results', BpSearchResults);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bp-shop-the-look"] && !Shopify.designMode) return;
  try {
    
  class BpShopTheLook extends HTMLElement {
    connectedCallback() {
      this.initTriggers();
      this.initCarousel();
    }

    initTriggers() {
      this.querySelectorAll('[data-stl-trigger]').forEach((btn) => {
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          const id = btn.dataset.drawerId;
          if (!id) return;
          const dialog = document.getElementById('bp-stl-drawer-' + id);
          if (!dialog) return;
          if (typeof dialog.showModal === 'function') {
            dialog.showModal();
          } else {
            dialog.setAttribute('open', '');
          }
        });
      });
    }

    initCarousel() {
      // Always builds the rail — desktop (>=1024px) is now always a
      // carousel, and CSS alone decides whether the rail renders as a
      // scroll track or collapses transparently into the grid (mobile
      // grid mode). See the "Carousel rail" stylesheet block above.
      const inner = this.querySelector('.bp-stl__inner');
      if (!inner) return;

      // Collect .shopify-block wrappers that contain a look article.
      // Heading blocks stay in .bp-stl__inner; look blocks move to the rail.
      const lookBlocks = Array.from(
        inner.querySelectorAll(':scope > .shopify-block')
      ).filter((b) => b.querySelector('.bp-stl__look'));

      if (lookBlocks.length === 0) return;

      // Build scroll rail and insert before the first look block
      const rail = document.createElement('div');
      rail.className = 'bp-stl__rail';
      inner.insertBefore(rail, lookBlocks[0]);
      lookBlocks.forEach((b) => rail.appendChild(b));
      this.rail = rail;

      // Prev / next arrows — Figma pins them top-right of the section
      // on mobile carousel mode. Position via CSS; click handlers
      // scroll the rail by one tile width. Inserted as the first
      // child of the section so they sit at the same vertical level
      // as the heading row.
      const nav = document.createElement('div');
      nav.className = 'bp-stl__nav';
      // Chevron SVG per BP design spec (44×44, fill currentColor).
      // Same SVG used in bp-styled-for-you — prev flips via scaleX(-1).
      const chevronSvg = '<svg xmlns="http://www.w3.org/2000/svg" width="44" height="44" viewBox="0 0 44 44" fill="none" aria-hidden="true">' +
        '<path d="M18.1326 13.8674C18.0884 13.8244 18.0442 13.7814 18 13.7385C17.9128 13.8256 17.8256 13.9128 17.7385 14C17.7814 14.0442 17.8244 14.0884 17.8674 14.1326C18.1304 14.4029 18.3934 14.6733 18.6564 14.9436C21.0232 17.3768 23.3901 19.8099 25.7569 22.2431V21.7569C23.3238 24.1238 20.8906 26.4906 18.4575 28.8575C18.1871 29.1205 17.9168 29.3835 17.6464 29.6464C17.527 29.7627 17.4075 29.8789 17.288 29.9951C17.527 30.2341 17.7659 30.473 18.0049 30.712C18.1211 30.5925 18.2373 30.473 18.3536 30.3536C18.6165 30.0832 18.8795 29.8129 19.1425 29.5425C21.5094 27.1094 23.8762 24.6762 26.2431 22.2431L26.486 21.9933L26.2431 21.7569C23.8099 19.3901 21.3768 17.0232 18.9436 14.6564C18.6733 14.3934 18.4029 14.1304 18.1326 13.8674Z" fill="currentColor"/>' +
        '<path d="M18.3536 13.6464C18.2373 13.527 18.1211 13.4075 18.0049 13.288C17.7659 13.527 17.527 13.7659 17.288 14.0049C17.4075 14.1211 17.527 14.2373 17.6464 14.3536C17.9168 14.6165 18.1871 14.8795 18.4575 15.1425C20.8906 17.5094 23.3238 19.8762 25.7569 22.2431V21.7569C23.3901 24.1901 21.0232 26.6232 18.6564 29.0564C18.3934 29.3267 18.1304 29.5971 17.8674 29.8674C17.8244 29.9116 17.7814 29.9558 17.7385 30C17.8256 30.0872 17.9128 30.1744 18 30.2615C18.0442 30.2186 18.0884 30.1756 18.1326 30.1326C18.4029 29.8696 18.6733 29.6066 18.9436 29.3436C21.3768 26.9768 23.8099 24.6099 26.2431 22.2431L26.486 21.9933L26.2431 21.7569C23.8762 19.3238 21.5094 16.8906 19.1425 14.4575C18.8795 14.1871 18.6165 13.9168 18.3536 13.6464Z" fill="currentColor"/>' +
      '</svg>';
      nav.innerHTML = (
        '<button type="button" class="bp-stl__nav-btn bp-stl__nav-btn--prev" data-stl-nav="prev" aria-label="Previous look">' + chevronSvg + '</button>' +
        '<button type="button" class="bp-stl__nav-btn bp-stl__nav-btn--next" data-stl-nav="next" aria-label="Next look">' + chevronSvg + '</button>'
      );
      this.insertBefore(nav, this.firstChild);
      this.nav = nav;
      this.scrollByTile = (dir) => {
        if (!this.rail) return;
        const first = this.rail.querySelector('.shopify-block');
        if (!first) return;
        const step = first.getBoundingClientRect().width +
          (parseFloat(getComputedStyle(this.rail).columnGap) || parseFloat(getComputedStyle(this.rail).gap) || 0);
        this.rail.scrollBy({ left: step * dir, behavior: 'smooth' });
      };
      nav.querySelector('[data-stl-nav="prev"]').addEventListener('click', () => this.scrollByTile(-1));
      nav.querySelector('[data-stl-nav="next"]').addEventListener('click', () => this.scrollByTile(1));

      // Indicator sits after the inner container (outside padding)
      const indicator = document.createElement('div');
      indicator.className = 'bp-stl__indicator';
      indicator.setAttribute('aria-hidden', 'true');
      this.appendChild(indicator);
      this.indicator = indicator;

      this.updateIndicator = this.updateIndicator.bind(this);
      this.updateNavState = this.updateNavState.bind(this);
      rail.addEventListener('scroll', this.updateIndicator, { passive: true });
      rail.addEventListener('scroll', this.updateNavState, { passive: true });
      window.addEventListener('resize', this.updateIndicator);
      window.addEventListener('resize', this.updateNavState);
      requestAnimationFrame(() => { this.updateIndicator(); this.updateNavState(); });
    }

    updateNavState() {
      if (!this.rail || !this.nav) return;
      const { scrollLeft, scrollWidth, clientWidth } = this.rail;
      const prev = this.nav.querySelector('[data-stl-nav="prev"]');
      const next = this.nav.querySelector('[data-stl-nav="next"]');
      if (prev) prev.disabled = scrollLeft <= 1;
      if (next) next.disabled = scrollLeft + clientWidth >= scrollWidth - 1;
    }

    updateIndicator() {
      if (!this.rail || !this.indicator) return;
      const { scrollLeft, scrollWidth, clientWidth } = this.rail;
      if (scrollWidth <= clientWidth) {
        this.indicator.style.display = 'none';
        return;
      }
      this.indicator.style.display = '';
      const thumbW = (clientWidth / scrollWidth) * 100;
      const overflow = scrollWidth - clientWidth;
      const thumbX = overflow > 0 ? scrollLeft / overflow : 0;
      this.indicator.style.setProperty('--bp-stl-thumb-w', thumbW + '%');
      this.indicator.style.setProperty('--bp-stl-thumb-x', thumbX);
    }

    disconnectedCallback() {
      if (this.updateIndicator) {
        window.removeEventListener('resize', this.updateIndicator);
      }
    }
  }

  if (!customElements.get('bp-shop-the-look')) {
    customElements.define('bp-shop-the-look', BpShopTheLook);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bp-styled-for-you"] && !Shopify.designMode) return;
  try {
    
  // ===== Stylitics outfit fetch — shared with bp-stl-drawer.js. =====
  // Same endpoint, username, and handle-resolution logic that the
  // shop-the-look drawer uses (assets/bp-stl-drawer.js:166-294). Kept
  // local so this section stays self-contained — the function is
  // small and the duplication isolates this from drawer changes.
  const SFY_STL_ENDPOINT = 'https://widget-api.stylitics.com/api/outfits';
  const SFY_STL_USERNAME = 'bostonproper';
  const SFY_GRID_SIZE = 4;

  function sfyHandleFromUrl(url) {
    const m = String(url || '').match(/\/products\/([^/?#]+)/);
    return m ? m[1] : null;
  }
  function sfyEsc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({
      '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'
    }[c]));
  }
  function sfySizeImg(url, w) {
    if (!url) return '';
    return url + (url.indexOf('?') >= 0 ? '&' : '?') + 'width=' + w;
  }

  class BpStyledForYou extends HTMLElement {
    connectedCallback() {
      this.wrapLooksInTrack();
      this.track = this.querySelector('.bp-sfy__track');
      this.prevBtn = this.querySelector('[data-direction="prev"]');
      this.nextBtn = this.querySelector('[data-direction="next"]');

      // Wire up every server-rendered card. Cards that get injected
      // later by Stylitics hydration go through wireCard() too.
      this.querySelectorAll('.bp-sfy__card[data-product-id]').forEach((card) => this.wireCard(card));

      // Kick off Stylitics hydration for any auto-mode looks. Runs
      // async — server-rendered fallback stays visible until (and if)
      // a real outfit lands.
      this.hydrateStyliticsLooks();

      // Arrow navigation (mobile only — arrows are display:none on desktop)
      if (this.track && this.prevBtn) {
        this.prevBtn.addEventListener('click', () => this.scrollByLook(-1));
      }
      if (this.track && this.nextBtn) {
        this.nextBtn.addEventListener('click', () => this.scrollByLook(1));
      }
      if (this.track) {
        this.updateArrows = this.updateArrows.bind(this);
        this.updateIndicator = this.updateIndicator.bind(this);
        var tick = () => { this.updateArrows(); this.updateIndicator(); };
        this.track.addEventListener('scroll', tick, { passive: true });
        window.addEventListener('resize', tick);
        requestAnimationFrame(tick);
      }
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.updateArrows);
    }

    // ----- Card listeners (extracted so injected cards reuse them) -----
    wireCard(card) {
      if (card._bpSfyWired) return;
      card._bpSfyWired = true;
      let prefetched = false;
      const prefetch = () => {
        if (prefetched) return;
        prefetched = true;
        const host = card.closest('.bp-sfy__card-host');
        const link = host?.querySelector('a[ref="productCardLink"]');
        if (link?.href) fetch(link.href, { credentials: 'same-origin' }).catch(() => {});
      };
      card.addEventListener('mouseenter', prefetch);
      card.addEventListener('focus', prefetch);
      card.addEventListener('touchstart', prefetch, { passive: true });

      card.addEventListener('click', (e) => this.handleCardClick(e, card));
      card.setAttribute('role', 'button');
      card.setAttribute('tabindex', '0');
      card.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          this.handleCardClick(e, card);
        }
      });
    }

    handleCardClick(e, card) {
      // The hidden quick-add component lives inside this card. When
      // bpOpenProductDrawer programmatically fires a click on its
      // "Choose" button, that click bubbles back up through the card
      // and would re-invoke this handler — causing infinite
      // recursion. Bail out if the click originated inside the
      // quick-add wrapper.
      if (e && e.target && e.target.closest && e.target.closest('.bp-sfy__card-quick')) {
        return;
      }

      const trigger = card.querySelector('.quick-add__button--choose');
      if (!trigger) return;
      // Open the drawer instantly with a loading state, then let
      // Horizon's fetch+populate run in the background. Helper is
      // defined globally by sections/bp-quick-drawer.liquid.
      if (typeof window.bpOpenProductDrawer === 'function') {
        window.bpOpenProductDrawer(trigger);
      } else {
        trigger.click();
      }
    }

    // ----- Stylitics hydration -----
    async hydrateStyliticsLooks() {
      const looks = this.querySelectorAll('[data-bp-sfy-look][data-bp-sfy-style]');
      if (!looks.length) return;
      // Fire all looks in parallel — they're independent fetches.
      await Promise.all(Array.from(looks).map((look) => this.hydrateLook(look)));
    }

    async hydrateLook(look) {
      const style = look.getAttribute('data-bp-sfy-style');
      if (!style) return;
      let products = [];
      try {
        products = await this.fetchStyliticsOutfit(style);
      } catch (err) {
        console.warn('[bp-sfy] Stylitics fetch threw for style', style, err);
        return;
      }
      // Leave the server-rendered manual fallback in place when
      // Stylitics returns fewer than 4 products. Partial outfits look
      // broken (empty cells in a curated lookbook), so a complete
      // manual fallback is the better failure mode — the merchant
      // populated those slots for exactly this case.
      if (products.length < SFY_GRID_SIZE) return;
      this.replaceGridCards(look, products);
    }

    async fetchStyliticsOutfit(style) {
      const url = SFY_STL_ENDPOINT +
        '?username=' + encodeURIComponent(SFY_STL_USERNAME) +
        '&item_number=' + encodeURIComponent(style);
      const res = await fetch(url, { cache: 'force-cache' });
      if (!res.ok) return [];
      const outfits = await res.json();
      if (!Array.isArray(outfits) || !outfits.length) return [];

      const items = (outfits[0].items || []).slice(0, SFY_GRID_SIZE * 2);
      // Parallelize handle → /products/{handle}.js resolution, then
      // dedupe + filter to available products + cap at 4.
      const seen = new Set();
      const requests = [];
      for (const item of items) {
        const handle = sfyHandleFromUrl(item && item.affiliate_link);
        if (!handle || seen.has(handle)) continue;
        seen.add(handle);
        requests.push(
          fetch('/products/' + handle + '.js', { cache: 'force-cache' })
            .then((r) => (r.ok ? r.json() : null))
            .catch(() => null)
        );
      }
      const resolved = await Promise.all(requests);
      return resolved.filter((p) => p && p.available !== false).slice(0, SFY_GRID_SIZE);
    }

    replaceGridCards(look, products) {
      const grid = look.querySelector('[data-bp-sfy-grid]');
      if (!grid) return;
      const sectionId = this.dataset.sectionId || '';

      let html = '';
      for (let i = 0; i < SFY_GRID_SIZE; i += 1) {
        html += products[i]
          ? this.buildCardHtml(products[i], sectionId)
          : '<div class="bp-sfy__card bp-sfy__card--empty" aria-hidden="true"></div>';
      }
      grid.innerHTML = html;

      // The injected <product-card> / <quick-add-component> custom
      // elements upgrade on insertion; their on:click bindings are
      // wired by the document-level delegation in assets/component.js,
      // so they fire without any extra setup here. We just need to
      // attach our card-surface click handler.
      grid.querySelectorAll('.bp-sfy__card[data-product-id]').forEach((card) => this.wireCard(card));
    }

    // Build the minimum markup that:
    //  1. Satisfies ProductCard's required `refs.productCardLink`
    //  2. Includes a `.quick-add__button--choose` so card-surface
    //     clicks open Horizon's quick-add modal (BP drawer skin).
    //  3. Matches the layout/CSS hooks used by the Liquid card
    //     snippet (`bp-sfy__card`, `bp-sfy__card-image`, etc.).
    // Mirrors the manual server-render in snippets/bp-styled-for-you-
    // card.liquid; intentionally trimmed (no <form>, no add-to-cart
    // button — quick-add modal does the heavy lifting via fetch).
    buildCardHtml(product, sectionId) {
      // When use-ghost is on, prefer the second image (ghost / flat
      // shot). When off, use the primary (lifestyle / model). Matches
      // the server-side branch in bp-styled-for-you-card.liquid.
      const useGhost = this.dataset.bpSfyUseGhost !== '0';
      // Accessories / shoes carry the ghost (flat) shot as their FIRST image,
      // so keep the featured (1st) image for those types instead of swapping
      // to the 2nd (which would show the on-model shot). Mirrors the Liquid
      // card (bp-styled-for-you-card.liquid).
      const ghostFirstTypes = (this.dataset.bpSfyGhostFirstTypes || '')
        .toLowerCase().split(',').map((t) => t.trim()).filter(Boolean);
      const ptype = String(product.type || '').toLowerCase().trim();
      const ghostFirst = ptype && ghostFirstTypes.some((t) => ptype.indexOf(t) !== -1);
      let featured = product.featured_image || '';
      if (useGhost && !ghostFirst) {
        if (Array.isArray(product.images) && product.images.length > 1) {
          featured = product.images[1] || featured;
        } else if (Array.isArray(product.media) && product.media.length > 1) {
          const m1 = product.media[1];
          featured = (m1 && (m1.preview_image && m1.preview_image.src || m1.src)) || featured;
        }
      }
      const url = product.url || ('/products/' + product.handle);
      const title = product.title || '';
      const imgSrc = featured ? sfySizeImg(featured, 540) : '';
      const imgSrcset = featured
        ? sfySizeImg(featured, 360) + ' 360w, ' + sfySizeImg(featured, 540) + ' 540w, ' + sfySizeImg(featured, 720) + ' 720w'
        : '';

      const imgHtml = imgSrc
        ? '<img class="bp-sfy__card-image" src="' + sfyEsc(imgSrc) + '" srcset="' + sfyEsc(imgSrcset) + '"' +
          ' sizes="(min-width: 1024px) 16vw, 40vw" alt="' + sfyEsc(title) + '" loading="lazy">'
        : '';

      // SVG bag icon — same path data as bp-styled-for-you-card.liquid.
      const bagSvg =
        '<span class="bp-sfy__card-bag" aria-hidden="true">' +
          '<svg viewBox="0 0 20 20" fill="currentColor" xmlns="http://www.w3.org/2000/svg">' +
            '<path d="M4.18929 5.74434H16.5343H16.6292L16.6729 5.74549C16.9007 5.75099 17.1328 5.87803 17.2448 6.08089C17.3145 6.20157 17.3382 6.30372 17.3547 6.43048C17.6354 9.18806 17.9008 11.996 18.3051 14.7356C18.3771 15.2467 18.4466 15.758 18.5137 16.2697C18.5163 16.2917 18.5195 16.336 18.5207 16.3582C18.5378 16.6193 18.4156 16.9263 18.1508 17.0687C17.9651 17.1752 17.7807 17.1763 17.5845 17.1755C16.1978 17.1755 4.69428 17.1755 3.34023 17.1755C3.20422 17.1726 3.01496 17.1862 2.86505 17.1451C2.45036 17.0406 2.25213 16.656 2.31666 16.2445C2.41071 15.5271 2.58579 14.2489 2.68621 13.5185C2.95476 11.5399 3.15849 9.46674 3.35962 7.47459C3.37582 7.3571 3.44296 6.63739 3.45714 6.52887L3.46698 6.43424L3.46814 6.42237C3.46814 6.41948 3.46901 6.4134 3.47045 6.40559C3.5156 6.02417 3.79254 5.74028 4.18929 5.74434Z"/>' +
            '<path d="M6.08301 8.78064C6.1788 7.5189 6.20658 6.21405 6.58539 4.98907C7.15432 3.11007 8.4421 2.11631 10.414 2.12673C13.8001 2.13338 14.5031 4.87997 14.6721 7.71395C14.6964 8.07453 14.7158 8.43453 14.745 8.78035L13.5874 8.77485C13.6172 8.46057 13.6575 8.02649 13.6754 7.71858C13.801 5.83351 13.5976 3.34129 11.3988 2.81605C10.7575 2.6676 10.0702 2.6676 9.42892 2.81605C7.61503 3.24811 7.15143 5.0374 7.12683 6.6872C7.11121 7.36929 7.17545 8.09132 7.24056 8.77485L6.08301 8.78035V8.78064Z"/>' +
          '</svg>' +
        '</span>';

      return (
        '<product-card class="bp-sfy__card-host">' +
          '<a href="' + sfyEsc(url) + '" ref="productCardLink" class="visually-hidden" tabindex="-1" aria-hidden="true">' + sfyEsc(title) + '</a>' +
          '<article class="bp-sfy__card" data-product-id="' + sfyEsc(product.id) + '" data-product-handle="' + sfyEsc(product.handle || '') + '" aria-label="View ' + sfyEsc(title) + '">' +
            imgHtml +
            bagSvg +
            '<div class="bp-sfy__card-quick">' +
              '<quick-add-component class="quick-add" ref="quickAdd"' +
                ' data-product-title="' + sfyEsc(title) + '"' +
                ' data-quick-add-button="choose">' +
                '<product-form-component' +
                  ' data-section-id="' + sfyEsc(sectionId) + '"' +
                  ' data-product-id="' + sfyEsc(product.id) + '"' +
                  ' class="quick-add__product-form-component">' +
                  '<button class="button quick-add__button quick-add__button--choose add-to-cart-button"' +
                    ' type="button" name="add"' +
                    ' on:click="quick-add-component/handleClick">' +
                    '<span class="add-to-cart-text"><span class="add-to-cart-text__content"><span><span>Choose</span></span></span></span>' +
                  '</button>' +
                '</product-form-component>' +
              '</quick-add-component>' +
            '</div>' +
          '</article>' +
        '</product-card>'
      );
    }

    // Wrap all `.bp-sfy__look` children into a single `.bp-sfy__track`
    // container so mobile CSS can turn them into a horizontal
    // scroll-snap rail while desktop keeps the existing grid layout
    // (via display: contents on the track). Also injects a
    // `.bp-sfy__indicator` (scroll progress bar) after the track —
    // same pattern as bp-category-tiles / bp-tabbed-gallery.
    wrapLooksInTrack() {
      var inner = this.querySelector('.bp-sfy__inner');
      if (!inner) return;
      if (inner.querySelector(':scope > .bp-sfy__track')) return;
      var looks = Array.from(inner.querySelectorAll('.bp-sfy__look'));
      if (looks.length === 0) return;
      var track = document.createElement('div');
      track.className = 'bp-sfy__track';
      // Insert the track as a direct child of `.bp-sfy__inner` at the
      // position of the first look's direct-child ancestor (which may
      // be a `.shopify-block` wrapper from content_for 'blocks').
      var first = looks[0];
      while (first && first.parentNode !== inner) first = first.parentNode;
      if (first) {
        inner.insertBefore(track, first);
      } else {
        inner.appendChild(track);
      }
      looks.forEach(function (look) { track.appendChild(look); });

      // Scroll progress indicator (mobile only via CSS).
      var indicator = document.createElement('div');
      indicator.className = 'bp-sfy__indicator';
      indicator.setAttribute('data-bp-sfy-indicator', '');
      indicator.setAttribute('aria-hidden', 'true');
      track.after(indicator);

      // Header row: heading + nav arrows on the right (mobile only via CSS).
      // The first non-track direct child of `.bp-sfy__inner` is treated as
      // the section heading — it might be the h2 itself or a `.shopify-block`
      // wrapper for the heading block. Move it into a new `.bp-sfy__header`
      // flex row and append the arrow nav on the right.
      if (!inner.querySelector(':scope > .bp-sfy__header')) {
        var headingHost = inner.firstElementChild;
        // Skip past the track/indicator we just inserted.
        while (headingHost && (headingHost === track || headingHost === indicator)) {
          headingHost = headingHost.nextElementSibling;
        }
        var header = document.createElement('div');
        header.className = 'bp-sfy__header';
        if (headingHost && headingHost !== track && headingHost !== indicator) {
          inner.insertBefore(header, headingHost);
          header.appendChild(headingHost);
        } else {
          inner.insertBefore(header, inner.firstChild);
        }
        // Chevron SVG per BP design spec (44×44, fill currentColor).
        // The prev button flips it horizontally via CSS scaleX(-1).
        var chevronSvg = '<svg xmlns="http://www.w3.org/2000/svg" width="44" height="44" viewBox="0 0 44 44" fill="none" aria-hidden="true">' +
          '<path d="M18.1326 13.8674C18.0884 13.8244 18.0442 13.7814 18 13.7385C17.9128 13.8256 17.8256 13.9128 17.7385 14C17.7814 14.0442 17.8244 14.0884 17.8674 14.1326C18.1304 14.4029 18.3934 14.6733 18.6564 14.9436C21.0232 17.3768 23.3901 19.8099 25.7569 22.2431V21.7569C23.3238 24.1238 20.8906 26.4906 18.4575 28.8575C18.1871 29.1205 17.9168 29.3835 17.6464 29.6464C17.527 29.7627 17.4075 29.8789 17.288 29.9951C17.527 30.2341 17.7659 30.473 18.0049 30.712C18.1211 30.5925 18.2373 30.473 18.3536 30.3536C18.6165 30.0832 18.8795 29.8129 19.1425 29.5425C21.5094 27.1094 23.8762 24.6762 26.2431 22.2431L26.486 21.9933L26.2431 21.7569C23.8099 19.3901 21.3768 17.0232 18.9436 14.6564C18.6733 14.3934 18.4029 14.1304 18.1326 13.8674Z" fill="currentColor"/>' +
          '<path d="M18.3536 13.6464C18.2373 13.527 18.1211 13.4075 18.0049 13.288C17.7659 13.527 17.527 13.7659 17.288 14.0049C17.4075 14.1211 17.527 14.2373 17.6464 14.3536C17.9168 14.6165 18.1871 14.8795 18.4575 15.1425C20.8906 17.5094 23.3238 19.8762 25.7569 22.2431V21.7569C23.3901 24.1901 21.0232 26.6232 18.6564 29.0564C18.3934 29.3267 18.1304 29.5971 17.8674 29.8674C17.8244 29.9116 17.7814 29.9558 17.7385 30C17.8256 30.0872 17.9128 30.1744 18 30.2615C18.0442 30.2186 18.0884 30.1756 18.1326 30.1326C18.4029 29.8696 18.6733 29.6066 18.9436 29.3436C21.3768 26.9768 23.8099 24.6099 26.2431 22.2431L26.486 21.9933L26.2431 21.7569C23.8762 19.3238 21.5094 16.8906 19.1425 14.4575C18.8795 14.1871 18.6165 13.9168 18.3536 13.6464Z" fill="currentColor"/>' +
        '</svg>';
        header.insertAdjacentHTML('beforeend',
          '<div class="bp-sfy__nav">' +
            '<button type="button" class="bp-sfy__arrow bp-sfy__arrow--prev" data-direction="prev" aria-label="Previous look">' + chevronSvg + '</button>' +
            '<button type="button" class="bp-sfy__arrow bp-sfy__arrow--next" data-direction="next" aria-label="Next look">' + chevronSvg + '</button>' +
          '</div>'
        );
      }
    }

    updateIndicator() {
      if (!this.track) return;
      var indicator = this.querySelector('[data-bp-sfy-indicator]');
      if (!indicator) return;
      var visible = this.track.clientWidth;
      var total = this.track.scrollWidth;
      if (total <= visible + 1) {
        indicator.style.display = 'none';
        return;
      }
      indicator.style.display = '';
      var overflow = total - visible;
      var thumbW = (visible / total) * 100;
      var thumbX = overflow > 0 ? this.track.scrollLeft / overflow : 0;
      indicator.style.setProperty('--bp-sfy-thumb-w', thumbW + '%');
      indicator.style.setProperty('--bp-sfy-thumb-x', thumbX);
    }

    scrollByLook(direction) {
      const look = this.track.querySelector('.bp-sfy__look');
      if (!look) return;
      const styles = getComputedStyle(this.track);
      const gap = parseFloat(styles.columnGap || styles.gap) || 0;
      const step = look.getBoundingClientRect().width + gap;
      this.track.scrollBy({ left: step * direction, behavior: 'smooth' });
    }

    updateArrows() {
      if (!this.prevBtn || !this.nextBtn || !this.track) return;
      const { scrollLeft, scrollWidth, clientWidth } = this.track;
      this.prevBtn.disabled = scrollLeft <= 1;
      this.nextBtn.disabled = scrollLeft + clientWidth >= scrollWidth - 1;
    }
  }

  if (!customElements.get('bp-styled-for-you')) {
    customElements.define('bp-styled-for-you', BpStyledForYou);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bp-tabbed-gallery"] && !Shopify.designMode) return;
  try {
    
  class BpTabbedGallery extends HTMLElement {
    connectedCallback() {
      this.distributeBlocks();

      const tabs = Array.from(this.querySelectorAll('.bp-tg__tab'));
      const panels = Array.from(this.querySelectorAll('.bp-tg__panel'));

      tabs.forEach((tab) => {
        tab.addEventListener('click', () => {
          const target = tab.dataset.tab;
          tabs.forEach((t) => {
            const active = t === tab;
            t.classList.toggle('is-active', active);
            t.setAttribute('aria-selected', active ? 'true' : 'false');
          });
          panels.forEach((p) => {
            const show = p.dataset.panel === target;
            p.classList.toggle('is-active', show);
            if (show) p.removeAttribute('hidden');
            else p.setAttribute('hidden', '');
          });
          // Recompute rail indicators after panels switch — the
          // newly-shown panel's rail has fresh client/scroll widths.
          requestAnimationFrame(this._updateAllRails);
        });
      });

      // Wire each scroll rail to its sibling indicator. The rail
      // computes thumb width as visible/total and thumb position
      // as scrollLeft / overflow; the CSS reads those vars.
      this._rails = [];
      this.querySelectorAll('[data-bp-tg-rail]').forEach((rail) => {
        const id =
          rail.classList.contains('bp-tg__colors-list')
            ? 'colors'
            : (rail.closest('.bp-tg__panel')?.dataset.panel || null);
        if (!id) return;
        const indicator = this.querySelector(`[data-bp-tg-indicator-for="${id}"]`);
        if (!indicator) return;
        const update = () => {
          const visible = rail.clientWidth;
          const total = rail.scrollWidth;
          if (total <= visible) {
            indicator.style.display = 'none';
            return;
          }
          indicator.style.display = '';
          const overflow = total - visible;
          const thumbW = (visible / total) * 100;
          const thumbX = overflow > 0 ? rail.scrollLeft / overflow : 0;
          indicator.style.setProperty('--bp-tg-thumb-w', thumbW + '%');
          indicator.style.setProperty('--bp-tg-thumb-x', thumbX);
        };
        rail.addEventListener('scroll', update, { passive: true });
        this._rails.push({ rail, update });
      });

      this._updateAllRails = () => this._rails.forEach((r) => r.update());
      window.addEventListener('resize', this._updateAllRails);
      requestAnimationFrame(this._updateAllRails);
    }

    /**
     * Move theme blocks from the [data-bp-tg-source] bucket into the
     * right destination — cards into their tab grid by data-tab,
     * colors into the colors list. Updates per-tab empty states and
     * gates the popular-colors wrapper based on whether any colors
     * landed.
     *
     * Theme blocks aren't iterable via `section.blocks` in Liquid in
     * this section, so the previous SSR filter rendered nothing. The
     * source bucket sidesteps that by relying on `content_for 'blocks'`,
     * which Shopify always renders correctly, and lets JS do the
     * filtering on the client.
     */
    distributeBlocks() {
      const source = this.querySelector('[data-bp-tg-source]');
      if (!source) return;

      // Shopify wraps each theme block in <div class="shopify-block">.
      // Walk those wrappers and inspect their first element child to
      // identify what kind of block it is.
      const wrappers = Array.from(source.children);
      const counts = { tab1: 0, tab2: 0, color: 0 };

      wrappers.forEach((wrapper) => {
        // The block content is either the wrapper itself (if Shopify
        // doesn't add the shopify-block div) or its first child.
        const node = wrapper.matches('[data-bp-tg-block]')
          ? wrapper
          : wrapper.querySelector('[data-bp-tg-block]');
        if (!node) return;

        const kind = node.dataset.bpTgBlock;
        if (kind === 'card') {
          const tab = node.dataset.tab || 'tab1';
          const grid = this.querySelector(`[data-bp-tg-grid="${tab}"]`);
          if (grid) {
            grid.appendChild(node);
            counts[tab] += 1;
          }
        } else if (kind === 'color') {
          const list = this.querySelector('[data-bp-tg-colors-list]');
          if (list) {
            list.appendChild(node);
            counts.color += 1;
          }
        }
      });

      // Drop the now-empty source bucket.
      source.remove();

      // Empty state per panel.
      ['tab1', 'tab2'].forEach((id) => {
        const empty = this.querySelector(`[data-bp-tg-empty="${id}"]`);
        const grid = this.querySelector(`[data-bp-tg-grid="${id}"]`);
        if (empty) empty.hidden = counts[id] > 0;
        if (grid) grid.hidden = counts[id] === 0;
      });

      // Reveal the popular-colors wrapper only if we actually
      // distributed at least one color block into it.
      const colorsWrapper = this.querySelector('[data-bp-tg-colors-wrapper]');
      if (colorsWrapper) {
        colorsWrapper.hidden = counts.color === 0;
      }
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this._updateAllRails);
    }
  }
  if (!customElements.get('bp-tabbed-gallery')) {
    customElements.define('bp-tabbed-gallery', BpTabbedGallery);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bp-true-fit-landing"] && !Shopify.designMode) return;
  try {
    
  class BpTrueFit extends HTMLElement {
    connectedCallback() {
      // tf-integration.js binds `.tfc-fitrec-register` when it scans the DOM.
      // It loads async, so a single early nudge can land before the SDK is
      // ready (queued calculate) OR after it has already scanned past us.
      // Re-nudge a few times over ~5s so the button gets bound regardless of
      // load order — calculate is idempotent. Also re-run on full page load.
      let tries = 0;
      const nudge = () => {
        if (window.tfcapi) { try { window.tfcapi('calculate'); } catch (_) {} }
      };
      nudge();
      const iv = setInterval(() => { nudge(); if (++tries >= 10) clearInterval(iv); }, 500);
      window.addEventListener('load', nudge, { once: true });
    }
  }
  if (!customElements.get('bp-true-fit')) customElements.define('bp-true-fit', BpTrueFit);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bp-yotpo-loyalty"] && !Shopify.designMode) return;
  try {
    
  class BpYotpoLoyalty extends HTMLElement {
    connectedCallback() {
      const widget = this.querySelector('.yotpo-widget-instance');
      if (!widget) return;
      const check = () => {
        // Height-based, not child-count: Yotpo often injects empty wrapper
        // nodes, so children.length isn't reliable. A rendered rewards widget
        // is tall; treat anything under ~40px as "no meaningful content" and
        // collapse the band. Expands the moment real content hydrates in.
        const empty = widget.offsetHeight < 40;
        this.toggleAttribute('data-bp-empty', empty);
      };
      new MutationObserver(check).observe(widget, { childList: true, subtree: true });
      check();
      // Delayed re-checks in case the loader boots slowly / renders late.
      [1500, 4000, 8000].forEach((t) => setTimeout(check, t));
    }
  }
  if (!customElements.get('bp-yotpo-loyalty')) {
    customElements.define('bp-yotpo-loyalty', BpYotpoLoyalty);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bp-yotpo-reviews"] && !Shopify.designMode) return;
  try {
    
  /* ============================================================
     BP YOTPO FILTERS — proxy renderer
     ============================================================
     Yotpo's native filter UI renders dropdowns whose click +
     popover-positioning logic is locked inside its Vue component.
     Our CSS overrides kept breaking the click cycle. Instead of
     fighting Yotpo's DOM, we:
       1. Wait for .yotpo-filters-container to render.
       2. Extract each chip's metadata (label + options + which
          option is currently selected) by reading Yotpo's DOM.
       3. Hide the native filter bar.
       4. Render a BP-styled mirror filter bar above it.
       5. When the user picks a value in our UI, programmatically
          click the equivalent native Yotpo control — Yotpo's Vue
          handles the actual review refetch + state update.
     Filter chips covered: Score (Rating), Custom-question filters
     (Age / Usual Size / Size Purchased / Fit; Occasion hidden per
     design), Sort by, Media toggle, Search.
     ============================================================ */
  (function () {
    var ROOT_SEL = '.yotpo-filters-container';
    var MIRROR_CLASS = 'bp-yfm';
    var rendered = false;

    function init() {
      var native = document.querySelector(ROOT_SEL);
      if (!native || native.dataset.bpYfmMounted) return false;
      // Wait until Yotpo has filled the chips with options (its
      // Vue hydration runs after the initial DOM paint). Defer
      // until the score dropdown has at least one option.
      if (!native.querySelector('.yotpo-score-option')) return false;
      native.dataset.bpYfmMounted = '1';
      mount(native);
      return true;
    }

    function txt(el) { return (el && el.textContent || '').trim(); }
    function esc(s)  { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&':'&amp;', '<':'&lt;', '>':'&gt;', '"':'&quot;', "'":'&#39;' }[c];
    }); }

    function readScoreOptions(native) {
      // Native: .yotpo-score-filter .yotpo-score-option (each has title="0|1|2|3|4|5")
      var opts = Array.from(native.querySelectorAll('.yotpo-score-filter .yotpo-score-option'));
      return opts.map(function (o) {
        var n = parseInt(o.getAttribute('title') || '0', 10);
        var label = n === 0 ? 'All ratings' : (n + ' star' + (n === 1 ? '' : 's'));
        return { value: String(n), label: label, native: o };
      });
    }
    function readCustomFilters(native) {
      // Native: .yotpo-custom-questions-filter, each with a
      // .yotpo-selected-value[title="Label"] (the chip label) and
      // .yotpo-dropdown-option[title="OptionLabel"] children.
      var chips = Array.from(native.querySelectorAll('.yotpo-custom-questions-filter'));
      return chips.map(function (chip) {
        var label = txt(chip.querySelector('.yotpo-selected-value')) || (chip.querySelector('.yotpo-selected-value')||{}).getAttribute && chip.querySelector('.yotpo-selected-value').getAttribute('title') || '';
        var opts = Array.from(chip.querySelectorAll('.yotpo-dropdown-option')).map(function (o) {
          return { value: (o.getAttribute('title') || txt(o)).trim(), label: (o.getAttribute('title') || txt(o)).trim(), native: o };
        });
        return { label: label, options: opts, native: chip };
      });
    }
    function readSortOptions(native) {
      var chip = native.querySelector('.yotpo-sorting-filter-container');
      if (!chip) return [];
      var opts = Array.from(chip.querySelectorAll('.yotpo-dropdown-option'));
      return opts.map(function (o) {
        return { value: txt(o), label: txt(o), native: o };
      });
    }

    function mount(native) {
      var score = readScoreOptions(native);
      var custom = readCustomFilters(native);
      var sort = readSortOptions(native);
      var nativeSearch = native.querySelector('.yotpo-search-input');
      var nativeMedia  = native.querySelector('.yotpo-media-select');

      // Build mirror DOM (4-col grid, 2 rows on desktop).
      // Row 1: Age / Usual Size / Size Purchased / Fit (skip
      // Occasion at index 3).
      // Row 2: Search (col 1) / Rating (col 2) / With media (col 3)
      // / Sort by (col 4).
      var mirror = document.createElement('div');
      mirror.className = MIRROR_CLASS;
      mirror.setAttribute('role', 'group');
      mirror.setAttribute('aria-label', 'Review filters');

      // Custom-question chips row
      // Filter out Occasion (per Figma — design only shows 4 chips:
      // Age / Usual Fit / Size Purchased / Fit). Remap Yotpo's
      // "Usual Size" label to the Figma label "Usual Fit".
      var row1 = document.createElement('div');
      row1.className = MIRROR_CLASS + '__row';
      var labelMap = { 'Usual Size': 'Usual Fit' };
      var skipLabels = { 'Occasion': true };
      custom.forEach(function (cf) {
        if (!cf || !cf.label || skipLabels[cf.label]) return;
        var displayLabel = labelMap[cf.label] || cf.label;
        row1.appendChild(buildSelect({
          label: displayLabel,
          options: [{ value: '', label: 'All' }].concat(cf.options.filter(function (o) { return o.value && o.value.toLowerCase() !== 'all'; })),
          onPick: function (val) {
            var target = val
              ? cf.options.find(function (o) { return o.value === val; })
              : cf.options.find(function (o) { return (o.value || '').toLowerCase() === 'all'; });
            if (target && target.native) clickNative(target.native);
          },
        }));
      });
      mirror.appendChild(row1);

      // Top row (search / rating / media / sort)
      var row2 = document.createElement('div');
      row2.className = MIRROR_CLASS + '__row';

      // Search
      var searchEl = document.createElement('label');
      searchEl.className = MIRROR_CLASS + '__search';
      searchEl.innerHTML =
        '<svg class="' + MIRROR_CLASS + '__search-icon" width="44" height="44" viewBox="0 0 44 44" fill="none" aria-hidden="true">' +
        '<path d="M30.6967 19.7055C30.7183 23.8405 27.932 27.3926 24.0949 28.7508C17.6703 31.1232 10.0267 26.8687 10 19.7055C10.0272 12.5414 17.6703 8.28779 24.0953 10.6602C27.932 12.0184 30.7187 15.5704 30.6967 19.7055ZM28.5408 19.7055C28.5477 16.9739 27.3344 14.2088 25.1509 12.5164C22.4003 10.326 18.2959 10.3256 15.5454 12.5164C13.3619 14.2088 12.1486 16.9735 12.1555 19.7055C12.1486 22.437 13.3619 25.2022 15.5454 26.8946C18.2959 29.085 22.4003 29.0854 25.1509 26.8946C27.3344 25.2022 28.5477 22.4374 28.5408 19.7055Z" fill="currentColor"/>' +
        '<path d="M33.1722 33.9996C31.5949 32.7677 30.2259 31.2982 28.913 29.7964C28.4818 29.2932 28.0609 28.7814 27.6703 28.2437L28.9798 27.1214C29.4515 27.5896 29.893 28.0838 30.3242 28.587C31.3974 29.8538 32.421 31.1658 33.3136 32.5693C33.4921 32.8526 33.6663 33.1394 33.8267 33.4386L33.1717 34L33.1722 33.9996Z" fill="currentColor"/>' +
        '</svg>' +
        '<input type="search" placeholder="Search reviews">';
      var searchInput = searchEl.querySelector('input');
      var sTimer;
      searchInput.addEventListener('input', function () {
        if (!nativeSearch) return;
        clearTimeout(sTimer);
        sTimer = setTimeout(function () {
          var setter = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, 'value').set;
          setter.call(nativeSearch, searchInput.value);
          nativeSearch.dispatchEvent(new Event('input', { bubbles: true }));
          nativeSearch.dispatchEvent(new Event('change', { bubbles: true }));
        }, 250);
      });
      row2.appendChild(searchEl);

      // Rating
      row2.appendChild(buildSelect({
        label: 'Rating',
        options: score,
        onPick: function (val) {
          var target = score.find(function (o) { return o.value === val; });
          if (target && target.native) clickNative(target.native);
        },
      }));

      // With media toggle
      var mediaEl = document.createElement('button');
      mediaEl.type = 'button';
      mediaEl.className = MIRROR_CLASS + '__media';
      mediaEl.setAttribute('aria-pressed', nativeMedia ? (nativeMedia.getAttribute('aria-pressed') || 'false') : 'false');
      mediaEl.innerHTML =
        '<span class="' + MIRROR_CLASS + '__media-label">With media</span>' +
        '<svg class="' + MIRROR_CLASS + '__media-icon" width="44" height="44" viewBox="0 0 44 44" fill="none" aria-hidden="true">' +
        '<circle cx="22" cy="22" r="9.25" stroke="currentColor" stroke-width="1.5"/>' +
        '</svg>';
      mediaEl.addEventListener('click', function () {
        if (!nativeMedia) return;
        clickNative(nativeMedia);
        // Reflect new state after a microtask
        setTimeout(function () {
          mediaEl.setAttribute('aria-pressed', nativeMedia.getAttribute('aria-pressed') || 'false');
        }, 16);
      });
      row2.appendChild(mediaEl);

      // Sort by
      row2.appendChild(buildSelect({
        label: 'Sort by:',
        labelInline: true,
        placeholder: 'Most recent',
        options: sort,
        onPick: function (val) {
          var target = sort.find(function (o) { return o.value === val; });
          if (target && target.native) clickNative(target.native);
        },
      }));

      mirror.appendChild(row2);

      // Hide native bar; insert mirror just before it so it occupies
      // the same DOM location.
      native.style.display = 'none';
      native.parentNode.insertBefore(mirror, native);

      // Reflect native state on mount (e.g. if Yotpo already has a
      // default sort/option selected).
      reflectSelected(mirror, native);

      // Watch for native changes (Yotpo re-renders the .yotpo-selected-value
      // after a click) and re-sync our mirror.
      var obs = new MutationObserver(function () { reflectSelected(mirror, native); });
      obs.observe(native, { subtree: true, attributes: true, attributeFilter: ['title', 'aria-pressed', 'style', 'class'] });
    }

    function buildSelect(cfg) {
      // cfg: { label, options:[{value,label}], onPick(value), labelInline?, placeholder? }
      var wrap = document.createElement('div');
      wrap.className = MIRROR_CLASS + '__chip';
      wrap.dataset.bpChipLabel = cfg.label;
      wrap.innerHTML =
        '<button type="button" class="' + MIRROR_CLASS + '__btn" aria-haspopup="listbox" aria-expanded="false">' +
        (cfg.labelInline ? '<span class="' + MIRROR_CLASS + '__btn-prefix">' + esc(cfg.label) + '</span>' : '') +
        '<span class="' + MIRROR_CLASS + '__btn-value">' + esc(cfg.labelInline ? (cfg.placeholder || '') : cfg.label) + '</span>' +
        '<svg class="' + MIRROR_CLASS + '__chev" width="44" height="44" viewBox="0 0 44 44" fill="none" aria-hidden="true">' +
        '<path d="M30.0986 18.2534C30.1784 18.1615 30.2582 18.0696 30.338 17.9777C30.1586 17.8132 29.9791 17.6487 29.7997 17.4842C29.715 17.5717 29.6304 17.6591 29.5457 17.7466C29.2773 18.024 29.0089 18.3014 28.7405 18.5788C26.3247 21.0755 23.9089 23.5721 21.4932 26.0688H22.5068C20.2292 23.4454 17.9516 20.8221 15.6741 18.1987C15.421 17.9072 15.1679 17.6158 14.9149 17.3243C14.6963 17.0725 14.4777 16.8207 14.2591 16.5689C13.7544 17.0315 13.2497 17.4942 12.745 17.9568C12.9768 18.1964 13.2087 18.4361 13.4406 18.6757C13.709 18.9531 13.9774 19.2305 14.2458 19.5079C16.6616 22.0046 19.0774 24.5012 21.4932 26.9979L22.0274 27.55L22.5068 26.9979C24.7843 24.3745 27.0619 21.7512 29.3394 19.1278C29.5925 18.8364 29.8455 18.5449 30.0986 18.2534Z" fill="currentColor"/>' +
        '<path d="M30.5593 18.6757C30.7912 18.4361 31.0231 18.1964 31.255 17.9568C30.7503 17.4942 30.2456 17.0315 29.7408 16.5689C29.5222 16.8207 29.3036 17.0725 29.085 17.3243C28.832 17.6158 28.5789 17.9072 28.3258 18.1987C26.0483 20.8221 23.7707 23.4454 21.4932 26.0688H22.5068C20.091 23.5721 17.6752 21.0755 15.2594 18.5788C14.991 18.3014 14.7226 18.024 14.4542 17.7466C14.3695 17.6591 14.2849 17.5717 14.2003 17.4842C14.0208 17.6487 13.8414 17.8132 13.6619 17.9777C13.7417 18.0696 13.8215 18.1615 13.9013 18.2534C14.1544 18.5449 14.4074 18.8364 14.6605 19.1278C16.938 21.7512 19.2156 24.3745 21.4932 26.9979L22.0274 27.55L22.5068 26.9979C24.9225 24.5012 27.3383 22.0046 29.7541 19.5079C30.0225 19.2305 30.2909 18.9531 30.5593 18.6757Z" fill="currentColor"/>' +
        '</svg>' +
        '</button>' +
        '<ul class="' + MIRROR_CLASS + '__menu" role="listbox" hidden>' +
        cfg.options.map(function (o) {
          return '<li class="' + MIRROR_CLASS + '__opt" role="option" data-value="' + esc(o.value) + '"><span>' + esc(o.label) + '</span><svg class="' + MIRROR_CLASS + '__check" width="12" height="9" viewBox="0 0 12 9" fill="none" aria-hidden="true"><path d="M4.67 7.12 10.79.99l.95.94L4.67 9 .42 4.76l.94-.95 3.3 3.3Z" fill="currentColor"/></svg></li>';
        }).join('') +
        '</ul>';

      var btn = wrap.querySelector('.' + MIRROR_CLASS + '__btn');
      var valSpan = wrap.querySelector('.' + MIRROR_CLASS + '__btn-value');
      var menu = wrap.querySelector('.' + MIRROR_CLASS + '__menu');
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        var open = menu.hidden === false;
        // Close any other open menus
        document.querySelectorAll('.' + MIRROR_CLASS + '__menu').forEach(function (m) { m.hidden = true; });
        document.querySelectorAll('.' + MIRROR_CLASS + '__btn').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
        if (!open) {
          menu.hidden = false;
          btn.setAttribute('aria-expanded', 'true');
        }
      });
      menu.addEventListener('click', function (e) {
        var li = e.target.closest('.' + MIRROR_CLASS + '__opt');
        if (!li) return;
        var v = li.dataset.value;
        var label = (cfg.options.find(function (o) { return o.value === v; }) || {}).label;
        // Update visible label and selected mark
        menu.querySelectorAll('.' + MIRROR_CLASS + '__opt').forEach(function (li2) {
          li2.classList.toggle('is-selected', li2.dataset.value === v);
        });
        var nonDefault = v !== '' && (label || '').toLowerCase() !== 'all' && (label || '').toLowerCase() !== 'all ratings';
        valSpan.textContent = label || (cfg.labelInline ? (cfg.placeholder || '') : cfg.label);
        wrap.classList.toggle('is-active', nonDefault);
        menu.hidden = true;
        btn.setAttribute('aria-expanded', 'false');
        if (typeof cfg.onPick === 'function') cfg.onPick(v);
      });
      return wrap;
    }

    function clickNative(el) {
      if (!el) return;
      // Some Yotpo Vue handlers fire on mousedown — dispatch both.
      try { el.dispatchEvent(new MouseEvent('mousedown', { bubbles: true })); } catch (_) {}
      try { el.click(); } catch (_) {}
      try { el.dispatchEvent(new MouseEvent('mouseup', { bubbles: true })); } catch (_) {}
    }

    function reflectSelected(mirror, native) {
      // Score: read .yotpo-score-option that has the 'selected'
      // background-color inline style Yotpo emits.
      // For each filter type, find the currently selected option
      // in native and mark its mirror equivalent.
      var chips = mirror.querySelectorAll('.' + MIRROR_CLASS + '__chip');
      chips.forEach(function (chip) {
        // For each chip, find its options menu and check if any
        // mirror option matches the native selected state by label.
        var menu = chip.querySelector('.' + MIRROR_CLASS + '__menu');
        if (!menu) return;
      });
      // Media toggle reflection
      var mediaBtn = mirror.querySelector('.' + MIRROR_CLASS + '__media');
      var nativeMedia = native.querySelector('.yotpo-media-select');
      if (mediaBtn && nativeMedia) {
        mediaBtn.setAttribute('aria-pressed', nativeMedia.getAttribute('aria-pressed') || 'false');
      }
    }

    // Close menus when clicking outside
    document.addEventListener('click', function (e) {
      if (e.target.closest('.' + MIRROR_CLASS)) return;
      document.querySelectorAll('.' + MIRROR_CLASS + '__menu').forEach(function (m) { m.hidden = true; });
      document.querySelectorAll('.' + MIRROR_CLASS + '__btn').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    });

    // Poll until Yotpo has rendered with options, then mount once.
    function tryMount(attempts) {
      if (init()) return;
      if (attempts > 50) return;
      setTimeout(function () { tryMount(attempts + 1); }, 250);
    }

    // Below the fold on the PDP — don't kick off the mount poll (250ms
    // retry loop + MutationObservers) until the reviews section scrolls
    // near the viewport, so the heavy filter-mirror hydration doesn't
    // compete with the LCP at page load. Rendering/mount logic is
    // unchanged — only WHEN tryMount first runs. The section can be empty
    // / box-less before Yotpo hydrates, and IntersectionObserver can't
    // observe a box-less element, so anchor a 1px sentinel at the
    // section's DOM position (always in layout) and observe that. Once,
    // ~600px lead. Mirrors bp-youll-also-love / bp-complete-the-look.
    function armObserver() {
      var section = document.getElementById('bp-pdp-reviews');
      if ('IntersectionObserver' in window && section && section.parentNode) {
        var sentinel = document.createElement('div');
        sentinel.setAttribute('aria-hidden', 'true');
        sentinel.style.cssText = 'width:1px;height:1px;';
        section.parentNode.insertBefore(sentinel, section);
        var io = new IntersectionObserver(function (entries, obs) {
          if (entries.some(function (e) { return e.isIntersecting; })) {
            obs.disconnect();
            sentinel.remove();
            tryMount(0);
          }
        }, { rootMargin: '600px 0px' });
        io.observe(sentinel);
      } else {
        tryMount(0);
      }
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', armObserver);
    } else {
      armObserver();
    }

    // Re-mount after a colour-swatch swap. bp-pdp-swap re-hydrates the Yotpo
    // widgets and dispatches `bp:pdp:swapped`; Yotpo then renders a FRESH
    // .yotpo-filters-container WITHOUT our data-bp-yfm-mounted flag, so the
    // BP filter-grid CSS (gated on that flag) stops applying and the native,
    // unstyled/misaligned filter bar shows (QA 7/27, Dragana — fine on load,
    // broken after a swatch change). Tear down the stale BP mirror + mount
    // flag, then re-run the mount poll against the new container (Yotpo's
    // re-hydration is async, so poll rather than mount immediately).
    document.addEventListener('bp:pdp:swapped', function () {
      document.querySelectorAll('.' + MIRROR_CLASS + ', .' + MIRROR_CLASS + '__menu')
        .forEach(function (m) { m.remove(); });
      document.querySelectorAll(ROOT_SEL + '[data-bp-yfm-mounted]').forEach(function (c) {
        delete c.dataset.bpYfmMounted;
      });
      rendered = false;
      setTimeout(function () { tryMount(0); }, 400);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["customer-care-links"] && !Shopify.designMode) return;
  try {
    
  (function() {
    const section = document.querySelector('[data-section-id]');
    if (!section) return;

    const track    = section.querySelector('[data-cc-track]');
    const progress = section.querySelector('[data-cc-progress]');
    const btnPrev  = section.querySelector('[data-cc-prev]');
    const btnNext  = section.querySelector('[data-cc-next]');

    if (!track) return;

    function updateProgress() {
      if (!progress) return;
      const max = track.scrollWidth - track.clientWidth;
      if (max <= 0) { progress.style.width = '100%'; return; }
      progress.style.width = ((track.scrollLeft / max) * 100) + '%';
    }

    track.addEventListener('scroll', updateProgress, { passive: true });
    updateProgress();

    if (btnPrev) {
      btnPrev.addEventListener('click', () => {
        track.scrollBy({ left: -(track.clientWidth * 0.8), behavior: 'smooth' });
      });
    }
    if (btnNext) {
      btnNext.addEventListener('click', () => {
        track.scrollBy({ left: track.clientWidth * 0.8, behavior: 'smooth' });
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["customer-service-layout"] && !Shopify.designMode) return;
  try {
    
  /* Legacy Atlas accordion toggle — clicks on
     `.js-accordion-toggler` toggle the parent `.js-accordion`'s
     `is-open` class and swap the inner `+` ↔ `−` glyph. Uses
     document-level delegation so it works for any accordion
     markup the admin pastes into ANY customer-service page (not
     just the one currently visible). Idempotent via a window
     singleton flag — multiple section instances on the same page
     won't double-bind. */
  if (!window.__bpLegacyAccordionWired) {
    window.__bpLegacyAccordionWired = true;
    document.addEventListener('click', (e) => {
      const btn = e.target.closest('.js-accordion-toggler');
      if (!btn) return;
      const item = btn.closest('.js-accordion');
      if (!item) return;
      e.preventDefault();
      const isOpen = item.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', String(isOpen));
      const pm = btn.querySelector('.plusminus');
      if (pm) pm.textContent = isOpen ? '−' : '+';
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
